function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9e47"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9e47"] = parcelRequire;
}
parcelRequire.register("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRequire.register("3vQgY", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("2sgnw")).then(()=>parcelRequire("4ZFd2"));

});

var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;




parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
// @generated by Peggy 4.2.0.
//
// https://peggyjs.org/
function $e1e1f1f3cd154daa$var$rootNode(comment) {
    return comment !== null ? {
        comment: comment,
        variations: []
    } : {
        variations: []
    };
}
function $e1e1f1f3cd154daa$var$node(move, suffix, nag, comment, variations) {
    const node = {
        move: move,
        variations: variations
    };
    if (suffix) node.suffix = suffix;
    if (nag) node.nag = nag;
    if (comment !== null) node.comment = comment;
    return node;
}
function $e1e1f1f3cd154daa$var$lineToTree(...nodes) {
    const [root, ...rest] = nodes;
    let parent = root;
    for (const child of rest)if (child !== null) {
        parent.variations = [
            child,
            ...child.variations
        ];
        child.variations = [];
        parent = child;
    }
    return root;
}
function $e1e1f1f3cd154daa$var$pgn(headers, game) {
    if (game.marker && game.marker.comment) {
        let node = game.root;
        while(true){
            const next = node.variations[0];
            if (!next) {
                node.comment = game.marker.comment;
                break;
            }
            node = next;
        }
    }
    return {
        headers: headers,
        root: game.root,
        result: (game.marker && game.marker.result) ?? undefined
    };
}
function $e1e1f1f3cd154daa$var$peg$subclass(child, parent) {
    function C() {
        this.constructor = child;
    }
    C.prototype = parent.prototype;
    child.prototype = new C();
}
function $e1e1f1f3cd154daa$var$peg$SyntaxError(message, expected, found, location) {
    var self = Error.call(this, message);
    // istanbul ignore next Check is a necessary evil to support older environments
    if (Object.setPrototypeOf) Object.setPrototypeOf(self, $e1e1f1f3cd154daa$var$peg$SyntaxError.prototype);
    self.expected = expected;
    self.found = found;
    self.location = location;
    self.name = "SyntaxError";
    return self;
}
$e1e1f1f3cd154daa$var$peg$subclass($e1e1f1f3cd154daa$var$peg$SyntaxError, Error);
function $e1e1f1f3cd154daa$var$peg$padEnd(str, targetLength, padString) {
    padString = padString || " ";
    if (str.length > targetLength) return str;
    targetLength -= str.length;
    padString += padString.repeat(targetLength);
    return str + padString.slice(0, targetLength);
}
$e1e1f1f3cd154daa$var$peg$SyntaxError.prototype.format = function(sources) {
    var str = "Error: " + this.message;
    if (this.location) {
        var src = null;
        var k;
        for(k = 0; k < sources.length; k++)if (sources[k].source === this.location.source) {
            src = sources[k].text.split(/\r\n|\n|\r/g);
            break;
        }
        var s = this.location.start;
        var offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s) : s;
        var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
        if (src) {
            var e = this.location.end;
            var filler = $e1e1f1f3cd154daa$var$peg$padEnd("", offset_s.line.toString().length, " ");
            var line = src[s.line - 1];
            var last = s.line === e.line ? e.column : line.length + 1;
            var hatLen = last - s.column || 1;
            str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line + "\n" + filler + " | " + $e1e1f1f3cd154daa$var$peg$padEnd("", s.column - 1, " ") + $e1e1f1f3cd154daa$var$peg$padEnd("", hatLen, "^");
        } else str += "\n at " + loc;
    }
    return str;
};
$e1e1f1f3cd154daa$var$peg$SyntaxError.buildMessage = function(expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
            return '"' + literalEscape(expectation.text) + '"';
        },
        class: function(expectation) {
            var escapedParts = expectation.parts.map(function(part) {
                return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
            });
            return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
        },
        any: function() {
            return "any character";
        },
        end: function() {
            return "end of input";
        },
        other: function(expectation) {
            return expectation.description;
        }
    };
    function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase();
    }
    function literalEscape(s) {
        return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
            return "\\x0" + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return "\\x" + hex(ch);
        });
    }
    function classEscape(s) {
        return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
            return "\\x0" + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return "\\x" + hex(ch);
        });
    }
    function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }
    function describeExpected(expected) {
        var descriptions = expected.map(describeExpectation);
        var i, j;
        descriptions.sort();
        if (descriptions.length > 0) {
            for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                descriptions[j] = descriptions[i];
                j++;
            }
            descriptions.length = j;
        }
        switch(descriptions.length){
            case 1:
                return descriptions[0];
            case 2:
                return descriptions[0] + " or " + descriptions[1];
            default:
                return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
        }
    }
    function describeFound(found) {
        return found ? '"' + literalEscape(found) + '"' : "end of input";
    }
    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function $e1e1f1f3cd154daa$var$peg$parse(input, options) {
    options = options !== undefined ? options : {};
    var peg$FAILED = {};
    var peg$source = options.grammarSource;
    var peg$startRuleFunctions = {
        pgn: peg$parsepgn
    };
    var peg$startRuleFunction = peg$parsepgn;
    var peg$c0 = "[";
    var peg$c1 = '"';
    var peg$c2 = "]";
    var peg$c3 = ".";
    var peg$c4 = "O-O-O";
    var peg$c5 = "O-O";
    var peg$c6 = "0-0-0";
    var peg$c7 = "0-0";
    var peg$c8 = "$";
    var peg$c9 = "{";
    var peg$c10 = "}";
    var peg$c11 = ";";
    var peg$c12 = "(";
    var peg$c13 = ")";
    var peg$c14 = "1-0";
    var peg$c15 = "0-1";
    var peg$c16 = "1/2-1/2";
    var peg$c17 = "*";
    var peg$r0 = /^[a-zA-Z]/;
    var peg$r1 = /^[^"]/;
    var peg$r2 = /^[0-9]/;
    var peg$r3 = /^[.]/;
    var peg$r4 = /^[a-zA-Z1-8\-=]/;
    var peg$r5 = /^[+#]/;
    var peg$r6 = /^[!?]/;
    var peg$r7 = /^[^}]/;
    var peg$r8 = /^[^\r\n]/;
    var peg$r9 = /^[ \t\r\n]/;
    var peg$e0 = peg$otherExpectation("tag pair");
    var peg$e1 = peg$literalExpectation("[", false);
    var peg$e2 = peg$literalExpectation('"', false);
    var peg$e3 = peg$literalExpectation("]", false);
    var peg$e4 = peg$otherExpectation("tag name");
    var peg$e5 = peg$classExpectation([
        [
            "a",
            "z"
        ],
        [
            "A",
            "Z"
        ]
    ], false, false);
    var peg$e6 = peg$otherExpectation("tag value");
    var peg$e7 = peg$classExpectation([
        '"'
    ], true, false);
    var peg$e8 = peg$otherExpectation("move number");
    var peg$e9 = peg$classExpectation([
        [
            "0",
            "9"
        ]
    ], false, false);
    var peg$e10 = peg$literalExpectation(".", false);
    var peg$e11 = peg$classExpectation([
        "."
    ], false, false);
    var peg$e12 = peg$otherExpectation("standard algebraic notation");
    var peg$e13 = peg$literalExpectation("O-O-O", false);
    var peg$e14 = peg$literalExpectation("O-O", false);
    var peg$e15 = peg$literalExpectation("0-0-0", false);
    var peg$e16 = peg$literalExpectation("0-0", false);
    var peg$e17 = peg$classExpectation([
        [
            "a",
            "z"
        ],
        [
            "A",
            "Z"
        ],
        [
            "1",
            "8"
        ],
        "-",
        "="
    ], false, false);
    var peg$e18 = peg$classExpectation([
        "+",
        "#"
    ], false, false);
    var peg$e19 = peg$otherExpectation("suffix annotation");
    var peg$e20 = peg$classExpectation([
        "!",
        "?"
    ], false, false);
    var peg$e21 = peg$otherExpectation("NAG");
    var peg$e22 = peg$literalExpectation("$", false);
    var peg$e23 = peg$otherExpectation("brace comment");
    var peg$e24 = peg$literalExpectation("{", false);
    var peg$e25 = peg$classExpectation([
        "}"
    ], true, false);
    var peg$e26 = peg$literalExpectation("}", false);
    var peg$e27 = peg$otherExpectation("rest of line comment");
    var peg$e28 = peg$literalExpectation(";", false);
    var peg$e29 = peg$classExpectation([
        "\r",
        "\n"
    ], true, false);
    var peg$e30 = peg$otherExpectation("variation");
    var peg$e31 = peg$literalExpectation("(", false);
    var peg$e32 = peg$literalExpectation(")", false);
    var peg$e33 = peg$otherExpectation("game termination marker");
    var peg$e34 = peg$literalExpectation("1-0", false);
    var peg$e35 = peg$literalExpectation("0-1", false);
    var peg$e36 = peg$literalExpectation("1/2-1/2", false);
    var peg$e37 = peg$literalExpectation("*", false);
    var peg$e38 = peg$otherExpectation("whitespace");
    var peg$e39 = peg$classExpectation([
        " ",
        "	",
        "\r",
        "\n"
    ], false, false);
    var peg$f0 = function(headers, game) {
        return $e1e1f1f3cd154daa$var$pgn(headers, game);
    };
    var peg$f1 = function(tagPairs) {
        return Object.fromEntries(tagPairs);
    };
    var peg$f2 = function(tagName, tagValue) {
        return [
            tagName,
            tagValue
        ];
    };
    var peg$f3 = function(root, marker) {
        return {
            root: root,
            marker: marker
        };
    };
    var peg$f4 = function(comment, moves) {
        return $e1e1f1f3cd154daa$var$lineToTree($e1e1f1f3cd154daa$var$rootNode(comment), ...moves.flat());
    };
    var peg$f5 = function(san, suffix, nag, comment, variations) {
        return $e1e1f1f3cd154daa$var$node(san, suffix, nag, comment, variations);
    };
    var peg$f6 = function(nag) {
        return nag;
    };
    var peg$f7 = function(comment) {
        return comment.replace(/[\r\n]+/g, " ");
    };
    var peg$f8 = function(comment) {
        return comment.trim();
    };
    var peg$f9 = function(line) {
        return line;
    };
    var peg$f10 = function(result, comment) {
        return {
            result: result,
            comment: comment
        };
    };
    var peg$currPos = options.peg$currPos | 0;
    var peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ];
    var peg$maxFailPos = peg$currPos;
    var peg$maxFailExpected = options.peg$maxFailExpected || [];
    var peg$silentFails = options.peg$silentFails | 0;
    var peg$result;
    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos];
        var p;
        if (details) return details;
        else {
            if (pos >= peg$posDetailsCache.length) p = peg$posDetailsCache.length - 1;
            else {
                p = pos;
                while(!peg$posDetailsCache[--p]);
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos, offset) {
        var startPosDetails = peg$computePosDetails(startPos);
        var endPosDetails = peg$computePosDetails(endPos);
        var res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
        return res;
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $e1e1f1f3cd154daa$var$peg$SyntaxError($e1e1f1f3cd154daa$var$peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }
    function peg$parsepgn() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsetagPairSection();
        s2 = peg$parsemoveTextSection();
        s0 = peg$f0(s1, s2);
        return s0;
    }
    function peg$parsetagPairSection() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsetagPair();
        while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parsetagPair();
        }
        s2 = peg$parse_();
        s0 = peg$f1(s1);
        return s0;
    }
    function peg$parsetagPair() {
        var s0, s2, s4, s6, s7, s8, s10;
        peg$silentFails++;
        s0 = peg$currPos;
        peg$parse_();
        if (input.charCodeAt(peg$currPos) === 91) {
            s2 = peg$c0;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e1);
        }
        if (s2 !== peg$FAILED) {
            peg$parse_();
            s4 = peg$parsetagName();
            if (s4 !== peg$FAILED) {
                peg$parse_();
                if (input.charCodeAt(peg$currPos) === 34) {
                    s6 = peg$c1;
                    peg$currPos++;
                } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e2);
                }
                if (s6 !== peg$FAILED) {
                    s7 = peg$parsetagValue();
                    if (input.charCodeAt(peg$currPos) === 34) {
                        s8 = peg$c1;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 93) {
                            s10 = peg$c2;
                            peg$currPos++;
                        } else {
                            s10 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e3);
                        }
                        if (s10 !== peg$FAILED) s0 = peg$f2(s4, s7);
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            if (peg$silentFails === 0) peg$fail(peg$e0);
        }
        return s0;
    }
    function peg$parsetagName() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r0.test(s2)) peg$currPos++;
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e5);
        }
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r0.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e5);
            }
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
        else s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e4);
        }
        return s0;
    }
    function peg$parsetagValue() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r1.test(s2)) peg$currPos++;
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e7);
        }
        while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r1.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e7);
            }
        }
        s0 = input.substring(s0, peg$currPos);
        peg$silentFails--;
        s1 = peg$FAILED;
        if (peg$silentFails === 0) peg$fail(peg$e6);
        return s0;
    }
    function peg$parsemoveTextSection() {
        var s0, s1, s3;
        s0 = peg$currPos;
        s1 = peg$parseline();
        peg$parse_();
        s3 = peg$parsegameTerminationMarker();
        if (s3 === peg$FAILED) s3 = null;
        peg$parse_();
        s0 = peg$f3(s1, s3);
        return s0;
    }
    function peg$parseline() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parsecomment();
        if (s1 === peg$FAILED) s1 = null;
        s2 = [];
        s3 = peg$parsemove();
        while(s3 !== peg$FAILED){
            s2.push(s3);
            s3 = peg$parsemove();
        }
        s0 = peg$f4(s1, s2);
        return s0;
    }
    function peg$parsemove() {
        var s0, s4, s5, s6, s7, s8, s9, s10;
        s0 = peg$currPos;
        peg$parse_();
        peg$parsemoveNumber();
        peg$parse_();
        s4 = peg$parsesan();
        if (s4 !== peg$FAILED) {
            s5 = peg$parsesuffixAnnotation();
            if (s5 === peg$FAILED) s5 = null;
            s6 = [];
            s7 = peg$parsenag();
            while(s7 !== peg$FAILED){
                s6.push(s7);
                s7 = peg$parsenag();
            }
            s7 = peg$parse_();
            s8 = peg$parsecomment();
            if (s8 === peg$FAILED) s8 = null;
            s9 = [];
            s10 = peg$parsevariation();
            while(s10 !== peg$FAILED){
                s9.push(s10);
                s10 = peg$parsevariation();
            }
            s0 = peg$f5(s4, s5, s6, s8, s9);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsemoveNumber() {
        var s0, s1, s2, s3, s4, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r2.test(s2)) peg$currPos++;
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e9);
        }
        while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r2.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e9);
            }
        }
        if (input.charCodeAt(peg$currPos) === 46) {
            s2 = peg$c3;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e10);
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parse_();
            s4 = [];
            s5 = input.charAt(peg$currPos);
            if (peg$r3.test(s5)) peg$currPos++;
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e11);
            }
            while(s5 !== peg$FAILED){
                s4.push(s5);
                s5 = input.charAt(peg$currPos);
                if (peg$r3.test(s5)) peg$currPos++;
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e11);
                }
            }
            s1 = [
                s1,
                s2,
                s3,
                s4
            ];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e8);
        }
        return s0;
    }
    function peg$parsesan() {
        var s0, s1, s2, s3, s4, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c4) {
            s2 = peg$c4;
            peg$currPos += 5;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e13);
        }
        if (s2 === peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c5) {
                s2 = peg$c5;
                peg$currPos += 3;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e14);
            }
            if (s2 === peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c6) {
                    s2 = peg$c6;
                    peg$currPos += 5;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e15);
                }
                if (s2 === peg$FAILED) {
                    if (input.substr(peg$currPos, 3) === peg$c7) {
                        s2 = peg$c7;
                        peg$currPos += 3;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e16);
                    }
                    if (s2 === peg$FAILED) {
                        s2 = peg$currPos;
                        s3 = input.charAt(peg$currPos);
                        if (peg$r0.test(s3)) peg$currPos++;
                        else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e5);
                        }
                        if (s3 !== peg$FAILED) {
                            s4 = [];
                            s5 = input.charAt(peg$currPos);
                            if (peg$r4.test(s5)) peg$currPos++;
                            else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$e17);
                            }
                            if (s5 !== peg$FAILED) while(s5 !== peg$FAILED){
                                s4.push(s5);
                                s5 = input.charAt(peg$currPos);
                                if (peg$r4.test(s5)) peg$currPos++;
                                else {
                                    s5 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$e17);
                                }
                            }
                            else s4 = peg$FAILED;
                            if (s4 !== peg$FAILED) {
                                s3 = [
                                    s3,
                                    s4
                                ];
                                s2 = s3;
                            } else {
                                peg$currPos = s2;
                                s2 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    }
                }
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = input.charAt(peg$currPos);
            if (peg$r5.test(s3)) peg$currPos++;
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e18);
            }
            if (s3 === peg$FAILED) s3 = null;
            s2 = [
                s2,
                s3
            ];
            s1 = s2;
        } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
        else s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e12);
        }
        return s0;
    }
    function peg$parsesuffixAnnotation() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r6.test(s2)) peg$currPos++;
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e20);
        }
        while(s2 !== peg$FAILED){
            s1.push(s2);
            if (s1.length >= 2) s2 = peg$FAILED;
            else {
                s2 = input.charAt(peg$currPos);
                if (peg$r6.test(s2)) peg$currPos++;
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e20);
                }
            }
        }
        if (s1.length < 1) {
            peg$currPos = s0;
            s0 = peg$FAILED;
        } else s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e19);
        }
        return s0;
    }
    function peg$parsenag() {
        var s0, s2, s3, s4, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        peg$parse_();
        if (input.charCodeAt(peg$currPos) === 36) {
            s2 = peg$c8;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e22);
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$currPos;
            s4 = [];
            s5 = input.charAt(peg$currPos);
            if (peg$r2.test(s5)) peg$currPos++;
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e9);
            }
            if (s5 !== peg$FAILED) while(s5 !== peg$FAILED){
                s4.push(s5);
                s5 = input.charAt(peg$currPos);
                if (peg$r2.test(s5)) peg$currPos++;
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e9);
                }
            }
            else s4 = peg$FAILED;
            if (s4 !== peg$FAILED) s3 = input.substring(s3, peg$currPos);
            else s3 = s4;
            if (s3 !== peg$FAILED) s0 = peg$f6(s3);
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            if (peg$silentFails === 0) peg$fail(peg$e21);
        }
        return s0;
    }
    function peg$parsecomment() {
        var s0;
        s0 = peg$parsebraceComment();
        if (s0 === peg$FAILED) s0 = peg$parserestOfLineComment();
        return s0;
    }
    function peg$parsebraceComment() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c9;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e24);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = [];
            s4 = input.charAt(peg$currPos);
            if (peg$r7.test(s4)) peg$currPos++;
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e25);
            }
            while(s4 !== peg$FAILED){
                s3.push(s4);
                s4 = input.charAt(peg$currPos);
                if (peg$r7.test(s4)) peg$currPos++;
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e25);
                }
            }
            s2 = input.substring(s2, peg$currPos);
            if (input.charCodeAt(peg$currPos) === 125) {
                s3 = peg$c10;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e26);
            }
            if (s3 !== peg$FAILED) s0 = peg$f7(s2);
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e23);
        }
        return s0;
    }
    function peg$parserestOfLineComment() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 59) {
            s1 = peg$c11;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e28);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = [];
            s4 = input.charAt(peg$currPos);
            if (peg$r8.test(s4)) peg$currPos++;
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e29);
            }
            while(s4 !== peg$FAILED){
                s3.push(s4);
                s4 = input.charAt(peg$currPos);
                if (peg$r8.test(s4)) peg$currPos++;
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e29);
                }
            }
            s2 = input.substring(s2, peg$currPos);
            s0 = peg$f8(s2);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e27);
        }
        return s0;
    }
    function peg$parsevariation() {
        var s0, s2, s3, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        peg$parse_();
        if (input.charCodeAt(peg$currPos) === 40) {
            s2 = peg$c12;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e31);
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parseline();
            if (s3 !== peg$FAILED) {
                peg$parse_();
                if (input.charCodeAt(peg$currPos) === 41) {
                    s5 = peg$c13;
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e32);
                }
                if (s5 !== peg$FAILED) s0 = peg$f9(s3);
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            if (peg$silentFails === 0) peg$fail(peg$e30);
        }
        return s0;
    }
    function peg$parsegameTerminationMarker() {
        var s0, s1, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 3) === peg$c14) {
            s1 = peg$c14;
            peg$currPos += 3;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e34);
        }
        if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c15) {
                s1 = peg$c15;
                peg$currPos += 3;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e35);
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 7) === peg$c16) {
                    s1 = peg$c16;
                    peg$currPos += 7;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e36);
                }
                if (s1 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 42) {
                        s1 = peg$c17;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e37);
                    }
                }
            }
        }
        if (s1 !== peg$FAILED) {
            peg$parse_();
            s3 = peg$parsecomment();
            if (s3 === peg$FAILED) s3 = null;
            s0 = peg$f10(s1, s3);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e33);
        }
        return s0;
    }
    function peg$parse_() {
        var s0, s1;
        peg$silentFails++;
        s0 = [];
        s1 = input.charAt(peg$currPos);
        if (peg$r9.test(s1)) peg$currPos++;
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e39);
        }
        while(s1 !== peg$FAILED){
            s0.push(s1);
            s1 = input.charAt(peg$currPos);
            if (peg$r9.test(s1)) peg$currPos++;
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e39);
            }
        }
        peg$silentFails--;
        s1 = peg$FAILED;
        if (peg$silentFails === 0) peg$fail(peg$e38);
        return s0;
    }
    peg$result = peg$startRuleFunction();
    if (options.peg$library) return /** @type {any} */ {
        peg$result: peg$result,
        peg$currPos: peg$currPos,
        peg$FAILED: peg$FAILED,
        peg$maxFailExpected: peg$maxFailExpected,
        peg$maxFailPos: peg$maxFailPos
    };
    if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
/**
 * @license
 * Copyright (c) 2025, Jeff Hlywa (jhlywa@gmail.com)
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 *    this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ const $e1e1f1f3cd154daa$var$MASK64 = 0xffffffffffffffffn;
function $e1e1f1f3cd154daa$var$rotl(x, k) {
    return (x << k | x >> 64n - k) & 0xffffffffffffffffn;
}
function $e1e1f1f3cd154daa$var$wrappingMul(x, y) {
    return x * y & $e1e1f1f3cd154daa$var$MASK64;
}
// xoroshiro128**
function $e1e1f1f3cd154daa$export$516db1fd5fe00a68(state) {
    return function() {
        let s0 = BigInt(state & $e1e1f1f3cd154daa$var$MASK64);
        let s1 = BigInt(state >> 64n & $e1e1f1f3cd154daa$var$MASK64);
        const result = $e1e1f1f3cd154daa$var$wrappingMul($e1e1f1f3cd154daa$var$rotl($e1e1f1f3cd154daa$var$wrappingMul(s0, 5n), 7n), 9n);
        s1 ^= s0;
        s0 = ($e1e1f1f3cd154daa$var$rotl(s0, 24n) ^ s1 ^ s1 << 16n) & $e1e1f1f3cd154daa$var$MASK64;
        s1 = $e1e1f1f3cd154daa$var$rotl(s1, 37n);
        state = s1 << 64n | s0;
        return result;
    };
}
const $e1e1f1f3cd154daa$var$rand = $e1e1f1f3cd154daa$export$516db1fd5fe00a68(0xa187eb39cdcaed8f31c4b365b102e01en);
const $e1e1f1f3cd154daa$var$PIECE_KEYS = Array.from({
    length: 2
}, ()=>Array.from({
        length: 6
    }, ()=>Array.from({
            length: 128
        }, ()=>$e1e1f1f3cd154daa$var$rand())));
const $e1e1f1f3cd154daa$var$EP_KEYS = Array.from({
    length: 8
}, ()=>$e1e1f1f3cd154daa$var$rand());
const $e1e1f1f3cd154daa$var$CASTLING_KEYS = Array.from({
    length: 16
}, ()=>$e1e1f1f3cd154daa$var$rand());
const $e1e1f1f3cd154daa$var$SIDE_KEY = $e1e1f1f3cd154daa$var$rand();
const $e1e1f1f3cd154daa$export$29814851e0aa981f = "w";
const $e1e1f1f3cd154daa$export$7a91b0fde7ec420f = "b";
const $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0 = "p";
const $e1e1f1f3cd154daa$export$ce32bc8c2a29bae6 = "n";
const $e1e1f1f3cd154daa$export$54a167f801c5dba3 = "b";
const $e1e1f1f3cd154daa$export$68d4c913908dc245 = "r";
const $e1e1f1f3cd154daa$export$36a8946792f13ec9 = "q";
const $e1e1f1f3cd154daa$export$42387107bb0d6206 = "k";
const $e1e1f1f3cd154daa$export$1264a6620073cfaa = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
class $e1e1f1f3cd154daa$export$e49a5ad3dd6df925 {
    color;
    from;
    to;
    piece;
    captured;
    promotion;
    /**
     * @deprecated This field is deprecated and will be removed in version 2.0.0.
     * Please use move descriptor functions instead: `isCapture`, `isPromotion`,
     * `isEnPassant`, `isKingsideCastle`, `isQueensideCastle`, `isCastle`, and
     * `isBigPawn`
     */ flags;
    san;
    lan;
    before;
    after;
    constructor(chess, internal){
        const { color: color , piece: piece , from: from , to: to , flags: flags , captured: captured , promotion: promotion  } = internal;
        const fromAlgebraic = $e1e1f1f3cd154daa$var$algebraic(from);
        const toAlgebraic = $e1e1f1f3cd154daa$var$algebraic(to);
        this.color = color;
        this.piece = piece;
        this.from = fromAlgebraic;
        this.to = toAlgebraic;
        /*
         * HACK: The chess['_method']() calls below invoke private methods in the
         * Chess class to generate SAN and FEN. It's a bit of a hack, but makes the
         * code cleaner elsewhere.
         */ this.san = chess["_moveToSan"](internal, chess["_moves"]({
            legal: true
        }));
        this.lan = fromAlgebraic + toAlgebraic;
        this.before = chess.fen();
        // Generate the FEN for the 'after' key
        chess["_makeMove"](internal);
        this.after = chess.fen();
        chess["_undoMove"]();
        // Build the text representation of the move flags
        this.flags = "";
        for(const flag in $e1e1f1f3cd154daa$var$BITS)if ($e1e1f1f3cd154daa$var$BITS[flag] & flags) this.flags += $e1e1f1f3cd154daa$var$FLAGS[flag];
        if (captured) this.captured = captured;
        if (promotion) {
            this.promotion = promotion;
            this.lan += promotion;
        }
    }
    isCapture() {
        return this.flags.indexOf($e1e1f1f3cd154daa$var$FLAGS["CAPTURE"]) > -1;
    }
    isPromotion() {
        return this.flags.indexOf($e1e1f1f3cd154daa$var$FLAGS["PROMOTION"]) > -1;
    }
    isEnPassant() {
        return this.flags.indexOf($e1e1f1f3cd154daa$var$FLAGS["EP_CAPTURE"]) > -1;
    }
    isKingsideCastle() {
        return this.flags.indexOf($e1e1f1f3cd154daa$var$FLAGS["KSIDE_CASTLE"]) > -1;
    }
    isQueensideCastle() {
        return this.flags.indexOf($e1e1f1f3cd154daa$var$FLAGS["QSIDE_CASTLE"]) > -1;
    }
    isBigPawn() {
        return this.flags.indexOf($e1e1f1f3cd154daa$var$FLAGS["BIG_PAWN"]) > -1;
    }
}
const $e1e1f1f3cd154daa$var$EMPTY = -1;
const $e1e1f1f3cd154daa$var$FLAGS = {
    NORMAL: "n",
    CAPTURE: "c",
    BIG_PAWN: "b",
    EP_CAPTURE: "e",
    PROMOTION: "p",
    KSIDE_CASTLE: "k",
    QSIDE_CASTLE: "q",
    NULL_MOVE: "-"
};
// prettier-ignore
const $e1e1f1f3cd154daa$export$5fc67852ab417150 = [
    "a8",
    "b8",
    "c8",
    "d8",
    "e8",
    "f8",
    "g8",
    "h8",
    "a7",
    "b7",
    "c7",
    "d7",
    "e7",
    "f7",
    "g7",
    "h7",
    "a6",
    "b6",
    "c6",
    "d6",
    "e6",
    "f6",
    "g6",
    "h6",
    "a5",
    "b5",
    "c5",
    "d5",
    "e5",
    "f5",
    "g5",
    "h5",
    "a4",
    "b4",
    "c4",
    "d4",
    "e4",
    "f4",
    "g4",
    "h4",
    "a3",
    "b3",
    "c3",
    "d3",
    "e3",
    "f3",
    "g3",
    "h3",
    "a2",
    "b2",
    "c2",
    "d2",
    "e2",
    "f2",
    "g2",
    "h2",
    "a1",
    "b1",
    "c1",
    "d1",
    "e1",
    "f1",
    "g1",
    "h1"
];
const $e1e1f1f3cd154daa$var$BITS = {
    NORMAL: 1,
    CAPTURE: 2,
    BIG_PAWN: 4,
    EP_CAPTURE: 8,
    PROMOTION: 16,
    KSIDE_CASTLE: 32,
    QSIDE_CASTLE: 64,
    NULL_MOVE: 128
};
/* eslint-disable @typescript-eslint/naming-convention */ // these are required, according to spec
const $e1e1f1f3cd154daa$export$2873e67bbeaa3712 = {
    Event: "?",
    Site: "?",
    Date: "????.??.??",
    Round: "?",
    White: "?",
    Black: "?",
    Result: "*"
};
/**
 * These nulls are placeholders to fix the order of tags (as they appear in PGN spec); null values will be
 * eliminated in getHeaders()
 */ const $e1e1f1f3cd154daa$var$SUPLEMENTAL_TAGS = {
    WhiteTitle: null,
    BlackTitle: null,
    WhiteElo: null,
    BlackElo: null,
    WhiteUSCF: null,
    BlackUSCF: null,
    WhiteNA: null,
    BlackNA: null,
    WhiteType: null,
    BlackType: null,
    EventDate: null,
    EventSponsor: null,
    Section: null,
    Stage: null,
    Board: null,
    Opening: null,
    Variation: null,
    SubVariation: null,
    ECO: null,
    NIC: null,
    Time: null,
    UTCTime: null,
    UTCDate: null,
    TimeControl: null,
    SetUp: null,
    FEN: null,
    Termination: null,
    Annotator: null,
    Mode: null,
    PlyCount: null
};
const $e1e1f1f3cd154daa$var$HEADER_TEMPLATE = {
    ...$e1e1f1f3cd154daa$export$2873e67bbeaa3712,
    ...$e1e1f1f3cd154daa$var$SUPLEMENTAL_TAGS
};
/* eslint-enable @typescript-eslint/naming-convention */ /*
 * NOTES ABOUT 0x88 MOVE GENERATION ALGORITHM
 * ----------------------------------------------------------------------------
 * From https://github.com/jhlywa/chess.js/issues/230
 *
 * A lot of people are confused when they first see the internal representation
 * of chess.js. It uses the 0x88 Move Generation Algorithm which internally
 * stores the board as an 8x16 array. This is purely for efficiency but has a
 * couple of interesting benefits:
 *
 * 1. 0x88 offers a very inexpensive "off the board" check. Bitwise AND (&) any
 *    square with 0x88, if the result is non-zero then the square is off the
 *    board. For example, assuming a knight square A8 (0 in 0x88 notation),
 *    there are 8 possible directions in which the knight can move. These
 *    directions are relative to the 8x16 board and are stored in the
 *    PIECE_OFFSETS map. One possible move is A8 - 18 (up one square, and two
 *    squares to the left - which is off the board). 0 - 18 = -18 & 0x88 = 0x88
 *    (because of two-complement representation of -18). The non-zero result
 *    means the square is off the board and the move is illegal. Take the
 *    opposite move (from A8 to C7), 0 + 18 = 18 & 0x88 = 0. A result of zero
 *    means the square is on the board.
 *
 * 2. The relative distance (or difference) between two squares on a 8x16 board
 *    is unique and can be used to inexpensively determine if a piece on a
 *    square can attack any other arbitrary square. For example, let's see if a
 *    pawn on E7 can attack E2. The difference between E7 (20) - E2 (100) is
 *    -80. We add 119 to make the ATTACKS array index non-negative (because the
 *    worst case difference is A8 - H1 = -119). The ATTACKS array contains a
 *    bitmask of pieces that can attack from that distance and direction.
 *    ATTACKS[-80 + 119=39] gives us 24 or 0b11000 in binary. Look at the
 *    PIECE_MASKS map to determine the mask for a given piece type. In our pawn
 *    example, we would check to see if 24 & 0x1 is non-zero, which it is
 *    not. So, naturally, a pawn on E7 can't attack a piece on E2. However, a
 *    rook can since 24 & 0x8 is non-zero. The only thing left to check is that
 *    there are no blocking pieces between E7 and E2. That's where the RAYS
 *    array comes in. It provides an offset (in this case 16) to add to E7 (20)
 *    to check for blocking pieces. E7 (20) + 16 = E6 (36) + 16 = E5 (52) etc.
 */ // prettier-ignore
// eslint-disable-next-line
const $e1e1f1f3cd154daa$var$Ox88 = {
    a8: 0,
    b8: 1,
    c8: 2,
    d8: 3,
    e8: 4,
    f8: 5,
    g8: 6,
    h8: 7,
    a7: 16,
    b7: 17,
    c7: 18,
    d7: 19,
    e7: 20,
    f7: 21,
    g7: 22,
    h7: 23,
    a6: 32,
    b6: 33,
    c6: 34,
    d6: 35,
    e6: 36,
    f6: 37,
    g6: 38,
    h6: 39,
    a5: 48,
    b5: 49,
    c5: 50,
    d5: 51,
    e5: 52,
    f5: 53,
    g5: 54,
    h5: 55,
    a4: 64,
    b4: 65,
    c4: 66,
    d4: 67,
    e4: 68,
    f4: 69,
    g4: 70,
    h4: 71,
    a3: 80,
    b3: 81,
    c3: 82,
    d3: 83,
    e3: 84,
    f3: 85,
    g3: 86,
    h3: 87,
    a2: 96,
    b2: 97,
    c2: 98,
    d2: 99,
    e2: 100,
    f2: 101,
    g2: 102,
    h2: 103,
    a1: 112,
    b1: 113,
    c1: 114,
    d1: 115,
    e1: 116,
    f1: 117,
    g1: 118,
    h1: 119
};
const $e1e1f1f3cd154daa$var$PAWN_OFFSETS = {
    b: [
        16,
        32,
        17,
        15
    ],
    w: [
        -16,
        -32,
        -17,
        -15
    ]
};
const $e1e1f1f3cd154daa$var$PIECE_OFFSETS = {
    n: [
        -18,
        -33,
        -31,
        -14,
        18,
        33,
        31,
        14
    ],
    b: [
        -17,
        -15,
        17,
        15
    ],
    r: [
        -16,
        1,
        16,
        -1
    ],
    q: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ],
    k: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ]
};
// prettier-ignore
const $e1e1f1f3cd154daa$var$ATTACKS = [
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    24,
    24,
    24,
    24,
    56,
    0,
    56,
    24,
    24,
    24,
    24,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20
];
// prettier-ignore
const $e1e1f1f3cd154daa$var$RAYS = [
    17,
    0,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    16,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    16,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    16,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    -16,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    -16,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    -16,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    0,
    -17
];
const $e1e1f1f3cd154daa$var$PIECE_MASKS = {
    p: 0x1,
    n: 0x2,
    b: 0x4,
    r: 0x8,
    q: 0x10,
    k: 0x20
};
const $e1e1f1f3cd154daa$var$SYMBOLS = "pnbrqkPNBRQK";
const $e1e1f1f3cd154daa$var$PROMOTIONS = [
    $e1e1f1f3cd154daa$export$ce32bc8c2a29bae6,
    $e1e1f1f3cd154daa$export$54a167f801c5dba3,
    $e1e1f1f3cd154daa$export$68d4c913908dc245,
    $e1e1f1f3cd154daa$export$36a8946792f13ec9
];
const $e1e1f1f3cd154daa$var$RANK_1 = 7;
const $e1e1f1f3cd154daa$var$RANK_2 = 6;
/*
 * const RANK_3 = 5
 * const RANK_4 = 4
 * const RANK_5 = 3
 * const RANK_6 = 2
 */ const $e1e1f1f3cd154daa$var$RANK_7 = 1;
const $e1e1f1f3cd154daa$var$RANK_8 = 0;
const $e1e1f1f3cd154daa$var$SIDES = {
    [$e1e1f1f3cd154daa$export$42387107bb0d6206]: $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE,
    [$e1e1f1f3cd154daa$export$36a8946792f13ec9]: $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE
};
const $e1e1f1f3cd154daa$var$ROOKS = {
    w: [
        {
            square: $e1e1f1f3cd154daa$var$Ox88.a1,
            flag: $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE
        },
        {
            square: $e1e1f1f3cd154daa$var$Ox88.h1,
            flag: $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE
        }
    ],
    b: [
        {
            square: $e1e1f1f3cd154daa$var$Ox88.a8,
            flag: $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE
        },
        {
            square: $e1e1f1f3cd154daa$var$Ox88.h8,
            flag: $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE
        }
    ]
};
const $e1e1f1f3cd154daa$var$SECOND_RANK = {
    b: $e1e1f1f3cd154daa$var$RANK_7,
    w: $e1e1f1f3cd154daa$var$RANK_2
};
const $e1e1f1f3cd154daa$var$SAN_NULLMOVE = "--";
// Extracts the zero-based rank of an 0x88 square.
function $e1e1f1f3cd154daa$var$rank(square) {
    return square >> 4;
}
// Extracts the zero-based file of an 0x88 square.
function $e1e1f1f3cd154daa$var$file(square) {
    return square & 0xf;
}
function $e1e1f1f3cd154daa$var$isDigit(c) {
    return "0123456789".indexOf(c) !== -1;
}
// Converts a 0x88 square to algebraic notation.
function $e1e1f1f3cd154daa$var$algebraic(square) {
    const f = $e1e1f1f3cd154daa$var$file(square);
    const r = $e1e1f1f3cd154daa$var$rank(square);
    return "abcdefgh".substring(f, f + 1) + "87654321".substring(r, r + 1);
}
function $e1e1f1f3cd154daa$var$swapColor(color) {
    return color === $e1e1f1f3cd154daa$export$29814851e0aa981f ? $e1e1f1f3cd154daa$export$7a91b0fde7ec420f : $e1e1f1f3cd154daa$export$29814851e0aa981f;
}
function $e1e1f1f3cd154daa$export$d9e02ca3a6185312(fen) {
    // 1st criterion: 6 space-seperated fields?
    const tokens = fen.split(/\s+/);
    if (tokens.length !== 6) return {
        ok: false,
        error: "Invalid FEN: must contain six space-delimited fields"
    };
    // 2nd criterion: move number field is a integer value > 0?
    const moveNumber = parseInt(tokens[5], 10);
    if (isNaN(moveNumber) || moveNumber <= 0) return {
        ok: false,
        error: "Invalid FEN: move number must be a positive integer"
    };
    // 3rd criterion: half move counter is an integer >= 0?
    const halfMoves = parseInt(tokens[4], 10);
    if (isNaN(halfMoves) || halfMoves < 0) return {
        ok: false,
        error: "Invalid FEN: half move counter number must be a non-negative integer"
    };
    // 4th criterion: 4th field is a valid e.p.-string?
    if (!/^(-|[abcdefgh][36])$/.test(tokens[3])) return {
        ok: false,
        error: "Invalid FEN: en-passant square is invalid"
    };
    // 5th criterion: 3th field is a valid castle-string?
    if (/[^kKqQ-]/.test(tokens[2])) return {
        ok: false,
        error: "Invalid FEN: castling availability is invalid"
    };
    // 6th criterion: 2nd field is "w" (white) or "b" (black)?
    if (!/^(w|b)$/.test(tokens[1])) return {
        ok: false,
        error: "Invalid FEN: side-to-move is invalid"
    };
    // 7th criterion: 1st field contains 8 rows?
    const rows = tokens[0].split("/");
    if (rows.length !== 8) return {
        ok: false,
        error: "Invalid FEN: piece data does not contain 8 '/'-delimited rows"
    };
    // 8th criterion: every row is valid?
    for(let i = 0; i < rows.length; i++){
        // check for right sum of fields AND not two numbers in succession
        let sumFields = 0;
        let previousWasNumber = false;
        for(let k = 0; k < rows[i].length; k++)if ($e1e1f1f3cd154daa$var$isDigit(rows[i][k])) {
            if (previousWasNumber) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (consecutive number)"
            };
            sumFields += parseInt(rows[i][k], 10);
            previousWasNumber = true;
        } else {
            if (!/^[prnbqkPRNBQK]$/.test(rows[i][k])) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (invalid piece)"
            };
            sumFields += 1;
            previousWasNumber = false;
        }
        if (sumFields !== 8) return {
            ok: false,
            error: "Invalid FEN: piece data is invalid (too many squares in rank)"
        };
    }
    // 9th criterion: is en-passant square legal?
    if (tokens[3][1] == "3" && tokens[1] == "w" || tokens[3][1] == "6" && tokens[1] == "b") return {
        ok: false,
        error: "Invalid FEN: illegal en-passant square"
    };
    // 10th criterion: does chess position contain exact two kings?
    const kings = [
        {
            color: "white",
            regex: /K/g
        },
        {
            color: "black",
            regex: /k/g
        }
    ];
    for (const { color: color , regex: regex  } of kings){
        if (!regex.test(tokens[0])) return {
            ok: false,
            error: `Invalid FEN: missing ${color} king`
        };
        if ((tokens[0].match(regex) || []).length > 1) return {
            ok: false,
            error: `Invalid FEN: too many ${color} kings`
        };
    }
    // 11th criterion: are any pawns on the first or eighth rows?
    if (Array.from(rows[0] + rows[7]).some((char)=>char.toUpperCase() === "P")) return {
        ok: false,
        error: "Invalid FEN: some pawns are on the edge rows"
    };
    return {
        ok: true
    };
}
// this function is used to uniquely identify ambiguous moves
function $e1e1f1f3cd154daa$var$getDisambiguator(move, moves) {
    const from = move.from;
    const to = move.to;
    const piece = move.piece;
    let ambiguities = 0;
    let sameRank = 0;
    let sameFile = 0;
    for(let i = 0, len = moves.length; i < len; i++){
        const ambigFrom = moves[i].from;
        const ambigTo = moves[i].to;
        const ambigPiece = moves[i].piece;
        /*
         * if a move of the same piece type ends on the same to square, we'll need
         * to add a disambiguator to the algebraic notation
         */ if (piece === ambigPiece && from !== ambigFrom && to === ambigTo) {
            ambiguities++;
            if ($e1e1f1f3cd154daa$var$rank(from) === $e1e1f1f3cd154daa$var$rank(ambigFrom)) sameRank++;
            if ($e1e1f1f3cd154daa$var$file(from) === $e1e1f1f3cd154daa$var$file(ambigFrom)) sameFile++;
        }
    }
    if (ambiguities > 0) {
        if (sameRank > 0 && sameFile > 0) /*
             * if there exists a similar moving piece on the same rank and file as
             * the move in question, use the square as the disambiguator
             */ return $e1e1f1f3cd154daa$var$algebraic(from);
        else if (sameFile > 0) /*
             * if the moving piece rests on the same file, use the rank symbol as the
             * disambiguator
             */ return $e1e1f1f3cd154daa$var$algebraic(from).charAt(1);
        else // else use the file symbol
        return $e1e1f1f3cd154daa$var$algebraic(from).charAt(0);
    }
    return "";
}
function $e1e1f1f3cd154daa$var$addMove(moves, color, from, to, piece, captured, flags = $e1e1f1f3cd154daa$var$BITS.NORMAL) {
    const r = $e1e1f1f3cd154daa$var$rank(to);
    if (piece === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0 && (r === $e1e1f1f3cd154daa$var$RANK_1 || r === $e1e1f1f3cd154daa$var$RANK_8)) for(let i = 0; i < $e1e1f1f3cd154daa$var$PROMOTIONS.length; i++){
        const promotion = $e1e1f1f3cd154daa$var$PROMOTIONS[i];
        moves.push({
            color: color,
            from: from,
            to: to,
            piece: piece,
            captured: captured,
            promotion: promotion,
            flags: flags | $e1e1f1f3cd154daa$var$BITS.PROMOTION
        });
    }
    else moves.push({
        color: color,
        from: from,
        to: to,
        piece: piece,
        captured: captured,
        flags: flags
    });
}
function $e1e1f1f3cd154daa$var$inferPieceType(san) {
    let pieceType = san.charAt(0);
    if (pieceType >= "a" && pieceType <= "h") {
        const matches = san.match(/[a-h]\d.*[a-h]\d/);
        if (matches) return undefined;
        return $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0;
    }
    pieceType = pieceType.toLowerCase();
    if (pieceType === "o") return $e1e1f1f3cd154daa$export$42387107bb0d6206;
    return pieceType;
}
// parses all of the decorators out of a SAN string
function $e1e1f1f3cd154daa$var$strippedSan(move) {
    return move.replace(/=/, "").replace(/[+#]?[?!]*$/, "");
}
class $e1e1f1f3cd154daa$export$a4d6ea685c300d39 {
    _board = new Array(128);
    _turn = $e1e1f1f3cd154daa$export$29814851e0aa981f;
    _header = {};
    _kings = {
        w: $e1e1f1f3cd154daa$var$EMPTY,
        b: $e1e1f1f3cd154daa$var$EMPTY
    };
    _epSquare = -1;
    _halfMoves = 0;
    _moveNumber = 0;
    _history = [];
    _comments = {};
    _castling = {
        w: 0,
        b: 0
    };
    _hash = 0n;
    // tracks number of times a position has been seen for repetition checking
    _positionCount = new Map();
    constructor(fen = $e1e1f1f3cd154daa$export$1264a6620073cfaa, { skipValidation: skipValidation = false  } = {}){
        this.load(fen, {
            skipValidation: skipValidation
        });
    }
    clear({ preserveHeaders: preserveHeaders = false  } = {}) {
        this._board = new Array(128);
        this._kings = {
            w: $e1e1f1f3cd154daa$var$EMPTY,
            b: $e1e1f1f3cd154daa$var$EMPTY
        };
        this._turn = $e1e1f1f3cd154daa$export$29814851e0aa981f;
        this._castling = {
            w: 0,
            b: 0
        };
        this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
        this._halfMoves = 0;
        this._moveNumber = 1;
        this._history = [];
        this._comments = {};
        this._header = preserveHeaders ? this._header : {
            ...$e1e1f1f3cd154daa$var$HEADER_TEMPLATE
        };
        this._hash = this._computeHash();
        this._positionCount = new Map();
        /*
         * Delete the SetUp and FEN headers (if preserved), the board is empty and
         * these headers don't make sense in this state. They'll get added later
         * via .load() or .put()
         */ this._header["SetUp"] = null;
        this._header["FEN"] = null;
    }
    load(fen, { skipValidation: skipValidation = false , preserveHeaders: preserveHeaders = false  } = {}) {
        let tokens = fen.split(/\s+/);
        // append commonly omitted fen tokens
        if (tokens.length >= 2 && tokens.length < 6) {
            const adjustments = [
                "-",
                "-",
                "0",
                "1"
            ];
            fen = tokens.concat(adjustments.slice(-(6 - tokens.length))).join(" ");
        }
        tokens = fen.split(/\s+/);
        if (!skipValidation) {
            const { ok: ok , error: error  } = $e1e1f1f3cd154daa$export$d9e02ca3a6185312(fen);
            if (!ok) throw new Error(error);
        }
        const position = tokens[0];
        let square = 0;
        this.clear({
            preserveHeaders: preserveHeaders
        });
        for(let i = 0; i < position.length; i++){
            const piece = position.charAt(i);
            if (piece === "/") square += 8;
            else if ($e1e1f1f3cd154daa$var$isDigit(piece)) square += parseInt(piece, 10);
            else {
                const color = piece < "a" ? $e1e1f1f3cd154daa$export$29814851e0aa981f : $e1e1f1f3cd154daa$export$7a91b0fde7ec420f;
                this._put({
                    type: piece.toLowerCase(),
                    color: color
                }, $e1e1f1f3cd154daa$var$algebraic(square));
                square++;
            }
        }
        this._turn = tokens[1];
        if (tokens[2].indexOf("K") > -1) this._castling.w |= $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("Q") > -1) this._castling.w |= $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE;
        if (tokens[2].indexOf("k") > -1) this._castling.b |= $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("q") > -1) this._castling.b |= $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE;
        this._epSquare = tokens[3] === "-" ? $e1e1f1f3cd154daa$var$EMPTY : $e1e1f1f3cd154daa$var$Ox88[tokens[3]];
        this._halfMoves = parseInt(tokens[4], 10);
        this._moveNumber = parseInt(tokens[5], 10);
        this._hash = this._computeHash();
        this._updateSetup(fen);
        this._incPositionCount();
    }
    fen({ forceEnpassantSquare: forceEnpassantSquare = false  } = {}) {
        let empty = 0;
        let fen = "";
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            if (this._board[i]) {
                if (empty > 0) {
                    fen += empty;
                    empty = 0;
                }
                const { color: color , type: piece  } = this._board[i];
                fen += color === $e1e1f1f3cd154daa$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
            } else empty++;
            if (i + 1 & 0x88) {
                if (empty > 0) fen += empty;
                if (i !== $e1e1f1f3cd154daa$var$Ox88.h1) fen += "/";
                empty = 0;
                i += 8;
            }
        }
        let castling = "";
        if (this._castling[$e1e1f1f3cd154daa$export$29814851e0aa981f] & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) castling += "K";
        if (this._castling[$e1e1f1f3cd154daa$export$29814851e0aa981f] & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) castling += "Q";
        if (this._castling[$e1e1f1f3cd154daa$export$7a91b0fde7ec420f] & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) castling += "k";
        if (this._castling[$e1e1f1f3cd154daa$export$7a91b0fde7ec420f] & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) castling += "q";
        // do we have an empty castling flag?
        castling = castling || "-";
        let epSquare = "-";
        /*
         * only print the ep square if en passant is a valid move (pawn is present
         * and ep capture is not pinned)
         */ if (this._epSquare !== $e1e1f1f3cd154daa$var$EMPTY) {
            if (forceEnpassantSquare) epSquare = $e1e1f1f3cd154daa$var$algebraic(this._epSquare);
            else {
                const bigPawnSquare = this._epSquare + (this._turn === $e1e1f1f3cd154daa$export$29814851e0aa981f ? 16 : -16);
                const squares = [
                    bigPawnSquare + 1,
                    bigPawnSquare - 1
                ];
                for (const square of squares){
                    // is the square off the board?
                    if (square & 0x88) continue;
                    const color = this._turn;
                    // is there a pawn that can capture the epSquare?
                    if (this._board[square]?.color === color && this._board[square]?.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                        // if the pawn makes an ep capture, does it leave its king in check?
                        this._makeMove({
                            color: color,
                            from: square,
                            to: this._epSquare,
                            piece: $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0,
                            captured: $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0,
                            flags: $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE
                        });
                        const isLegal = !this._isKingAttacked(color);
                        this._undoMove();
                        // if ep is legal, break and set the ep square in the FEN output
                        if (isLegal) {
                            epSquare = $e1e1f1f3cd154daa$var$algebraic(this._epSquare);
                            break;
                        }
                    }
                }
            }
        }
        return [
            fen,
            this._turn,
            castling,
            epSquare,
            this._halfMoves,
            this._moveNumber
        ].join(" ");
    }
    _pieceKey(i) {
        if (!this._board[i]) return 0n;
        const { color: color , type: type  } = this._board[i];
        const colorIndex = {
            w: 0,
            b: 1
        }[color];
        const typeIndex = {
            p: 0,
            n: 1,
            b: 2,
            r: 3,
            q: 4,
            k: 5
        }[type];
        return $e1e1f1f3cd154daa$var$PIECE_KEYS[colorIndex][typeIndex][i];
    }
    _epKey() {
        return this._epSquare === $e1e1f1f3cd154daa$var$EMPTY ? 0n : $e1e1f1f3cd154daa$var$EP_KEYS[this._epSquare & 7];
    }
    _castlingKey() {
        const index = this._castling.w >> 5 | this._castling.b >> 3;
        return $e1e1f1f3cd154daa$var$CASTLING_KEYS[index];
    }
    _computeHash() {
        let hash = 0n;
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            // did we run off the end of the board
            if (i & 0x88) {
                i += 7;
                continue;
            }
            if (this._board[i]) hash ^= this._pieceKey(i);
        }
        hash ^= this._epKey();
        hash ^= this._castlingKey();
        if (this._turn === "b") hash ^= $e1e1f1f3cd154daa$var$SIDE_KEY;
        return hash;
    }
    /*
     * Called when the initial board setup is changed with put() or remove().
     * modifies the SetUp and FEN properties of the header object. If the FEN
     * is equal to the default position, the SetUp and FEN are deleted the setup
     * is only updated if history.length is zero, ie moves haven't been made.
     */ _updateSetup(fen) {
        if (this._history.length > 0) return;
        if (fen !== $e1e1f1f3cd154daa$export$1264a6620073cfaa) {
            this._header["SetUp"] = "1";
            this._header["FEN"] = fen;
        } else {
            this._header["SetUp"] = null;
            this._header["FEN"] = null;
        }
    }
    reset() {
        this.load($e1e1f1f3cd154daa$export$1264a6620073cfaa);
    }
    get(square) {
        return this._board[$e1e1f1f3cd154daa$var$Ox88[square]];
    }
    findPiece(piece) {
        const squares = [];
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            // did we run off the end of the board
            if (i & 0x88) {
                i += 7;
                continue;
            }
            // if empty square or wrong color
            if (!this._board[i] || this._board[i]?.color !== piece.color) continue;
            // check if square contains the requested piece
            if (this._board[i].color === piece.color && this._board[i].type === piece.type) squares.push($e1e1f1f3cd154daa$var$algebraic(i));
        }
        return squares;
    }
    put({ type: type , color: color  }, square) {
        if (this._put({
            type: type,
            color: color
        }, square)) {
            this._updateCastlingRights();
            this._updateEnPassantSquare();
            this._updateSetup(this.fen());
            return true;
        }
        return false;
    }
    _set(sq, piece) {
        this._hash ^= this._pieceKey(sq);
        this._board[sq] = piece;
        this._hash ^= this._pieceKey(sq);
    }
    _put({ type: type , color: color  }, square) {
        // check for piece
        if ($e1e1f1f3cd154daa$var$SYMBOLS.indexOf(type.toLowerCase()) === -1) return false;
        // check for valid square
        if (!(square in $e1e1f1f3cd154daa$var$Ox88)) return false;
        const sq = $e1e1f1f3cd154daa$var$Ox88[square];
        // don't let the user place more than one king
        if (type == $e1e1f1f3cd154daa$export$42387107bb0d6206 && !(this._kings[color] == $e1e1f1f3cd154daa$var$EMPTY || this._kings[color] == sq)) return false;
        const currentPieceOnSquare = this._board[sq];
        // if one of the kings will be replaced by the piece from args, set the `_kings` respective entry to `EMPTY`
        if (currentPieceOnSquare && currentPieceOnSquare.type === $e1e1f1f3cd154daa$export$42387107bb0d6206) this._kings[currentPieceOnSquare.color] = $e1e1f1f3cd154daa$var$EMPTY;
        this._set(sq, {
            type: type,
            color: color
        });
        if (type === $e1e1f1f3cd154daa$export$42387107bb0d6206) this._kings[color] = sq;
        return true;
    }
    _clear(sq) {
        this._hash ^= this._pieceKey(sq);
        delete this._board[sq];
    }
    remove(square) {
        const piece = this.get(square);
        this._clear($e1e1f1f3cd154daa$var$Ox88[square]);
        if (piece && piece.type === $e1e1f1f3cd154daa$export$42387107bb0d6206) this._kings[piece.color] = $e1e1f1f3cd154daa$var$EMPTY;
        this._updateCastlingRights();
        this._updateEnPassantSquare();
        this._updateSetup(this.fen());
        return piece;
    }
    _updateCastlingRights() {
        this._hash ^= this._castlingKey();
        const whiteKingInPlace = this._board[$e1e1f1f3cd154daa$var$Ox88.e1]?.type === $e1e1f1f3cd154daa$export$42387107bb0d6206 && this._board[$e1e1f1f3cd154daa$var$Ox88.e1]?.color === $e1e1f1f3cd154daa$export$29814851e0aa981f;
        const blackKingInPlace = this._board[$e1e1f1f3cd154daa$var$Ox88.e8]?.type === $e1e1f1f3cd154daa$export$42387107bb0d6206 && this._board[$e1e1f1f3cd154daa$var$Ox88.e8]?.color === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f;
        if (!whiteKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.a1]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.a1]?.color !== $e1e1f1f3cd154daa$export$29814851e0aa981f) this._castling.w &= -65;
        if (!whiteKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.h1]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.h1]?.color !== $e1e1f1f3cd154daa$export$29814851e0aa981f) this._castling.w &= -33;
        if (!blackKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.a8]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.a8]?.color !== $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._castling.b &= -65;
        if (!blackKingInPlace || this._board[$e1e1f1f3cd154daa$var$Ox88.h8]?.type !== $e1e1f1f3cd154daa$export$68d4c913908dc245 || this._board[$e1e1f1f3cd154daa$var$Ox88.h8]?.color !== $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._castling.b &= -33;
        this._hash ^= this._castlingKey();
    }
    _updateEnPassantSquare() {
        if (this._epSquare === $e1e1f1f3cd154daa$var$EMPTY) return;
        const startSquare = this._epSquare + (this._turn === $e1e1f1f3cd154daa$export$29814851e0aa981f ? -16 : 16);
        const currentSquare = this._epSquare + (this._turn === $e1e1f1f3cd154daa$export$29814851e0aa981f ? 16 : -16);
        const attackers = [
            currentSquare + 1,
            currentSquare - 1
        ];
        if (this._board[startSquare] !== null || this._board[this._epSquare] !== null || this._board[currentSquare]?.color !== $e1e1f1f3cd154daa$var$swapColor(this._turn) || this._board[currentSquare]?.type !== $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
            this._hash ^= this._epKey();
            this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
            return;
        }
        const canCapture = (square)=>!(square & 0x88) && this._board[square]?.color === this._turn && this._board[square]?.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0;
        if (!attackers.some(canCapture)) {
            this._hash ^= this._epKey();
            this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
        }
    }
    _attacked(color, square, verbose) {
        const attackers = [];
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            // did we run off the end of the board
            if (i & 0x88) {
                i += 7;
                continue;
            }
            // if empty square or wrong color
            if (this._board[i] === undefined || this._board[i].color !== color) continue;
            const piece = this._board[i];
            const difference = i - square;
            // skip - to/from square are the same
            if (difference === 0) continue;
            const index = difference + 119;
            if ($e1e1f1f3cd154daa$var$ATTACKS[index] & $e1e1f1f3cd154daa$var$PIECE_MASKS[piece.type]) {
                if (piece.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                    if (difference > 0 && piece.color === $e1e1f1f3cd154daa$export$29814851e0aa981f || difference <= 0 && piece.color === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) {
                        if (!verbose) return true;
                        else attackers.push($e1e1f1f3cd154daa$var$algebraic(i));
                    }
                    continue;
                }
                // if the piece is a knight or a king
                if (piece.type === "n" || piece.type === "k") {
                    if (!verbose) return true;
                    else {
                        attackers.push($e1e1f1f3cd154daa$var$algebraic(i));
                        continue;
                    }
                }
                const offset = $e1e1f1f3cd154daa$var$RAYS[index];
                let j = i + offset;
                let blocked = false;
                while(j !== square){
                    if (this._board[j] != null) {
                        blocked = true;
                        break;
                    }
                    j += offset;
                }
                if (!blocked) {
                    if (!verbose) return true;
                    else {
                        attackers.push($e1e1f1f3cd154daa$var$algebraic(i));
                        continue;
                    }
                }
            }
        }
        if (verbose) return attackers;
        else return false;
    }
    attackers(square, attackedBy) {
        if (!attackedBy) return this._attacked(this._turn, $e1e1f1f3cd154daa$var$Ox88[square], true);
        else return this._attacked(attackedBy, $e1e1f1f3cd154daa$var$Ox88[square], true);
    }
    _isKingAttacked(color) {
        const square = this._kings[color];
        return square === -1 ? false : this._attacked($e1e1f1f3cd154daa$var$swapColor(color), square);
    }
    hash() {
        return this._hash.toString(16);
    }
    isAttacked(square, attackedBy) {
        return this._attacked(attackedBy, $e1e1f1f3cd154daa$var$Ox88[square]);
    }
    isCheck() {
        return this._isKingAttacked(this._turn);
    }
    inCheck() {
        return this.isCheck();
    }
    isCheckmate() {
        return this.isCheck() && this._moves().length === 0;
    }
    isStalemate() {
        return !this.isCheck() && this._moves().length === 0;
    }
    isInsufficientMaterial() {
        /*
         * k.b. vs k.b. (of opposite colors) with mate in 1:
         * 8/8/8/8/1b6/8/B1k5/K7 b - - 0 1
         *
         * k.b. vs k.n. with mate in 1:
         * 8/8/8/8/1n6/8/B7/K1k5 b - - 2 1
         */ const pieces = {
            b: 0,
            n: 0,
            r: 0,
            q: 0,
            k: 0,
            p: 0
        };
        const bishops = [];
        let numPieces = 0;
        let squareColor = 0;
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            squareColor = (squareColor + 1) % 2;
            if (i & 0x88) {
                i += 7;
                continue;
            }
            const piece = this._board[i];
            if (piece) {
                pieces[piece.type] = piece.type in pieces ? pieces[piece.type] + 1 : 1;
                if (piece.type === $e1e1f1f3cd154daa$export$54a167f801c5dba3) bishops.push(squareColor);
                numPieces++;
            }
        }
        // k vs. k
        if (numPieces === 2) return true;
        else if (// k vs. kn .... or .... k vs. kb
        numPieces === 3 && (pieces[$e1e1f1f3cd154daa$export$54a167f801c5dba3] === 1 || pieces[$e1e1f1f3cd154daa$export$ce32bc8c2a29bae6] === 1)) return true;
        else if (numPieces === pieces[$e1e1f1f3cd154daa$export$54a167f801c5dba3] + 2) {
            // kb vs. kb where any number of bishops are all on the same color
            let sum = 0;
            const len = bishops.length;
            for(let i = 0; i < len; i++)sum += bishops[i];
            if (sum === 0 || sum === len) return true;
        }
        return false;
    }
    isThreefoldRepetition() {
        return this._getPositionCount(this._hash) >= 3;
    }
    isDrawByFiftyMoves() {
        return this._halfMoves >= 100; // 50 moves per side = 100 half moves
    }
    isDraw() {
        return this.isDrawByFiftyMoves() || this.isStalemate() || this.isInsufficientMaterial() || this.isThreefoldRepetition();
    }
    isGameOver() {
        return this.isCheckmate() || this.isDraw();
    }
    moves({ verbose: verbose = false , square: square , piece: piece  } = {}) {
        const moves = this._moves({
            square: square,
            piece: piece
        });
        if (verbose) return moves.map((move)=>new $e1e1f1f3cd154daa$export$e49a5ad3dd6df925(this, move));
        else return moves.map((move)=>this._moveToSan(move, moves));
    }
    _moves({ legal: legal = true , piece: piece , square: square  } = {}) {
        const forSquare = square ? square.toLowerCase() : undefined;
        const forPiece = piece?.toLowerCase();
        const moves = [];
        const us = this._turn;
        const them = $e1e1f1f3cd154daa$var$swapColor(us);
        let firstSquare = $e1e1f1f3cd154daa$var$Ox88.a8;
        let lastSquare = $e1e1f1f3cd154daa$var$Ox88.h1;
        let singleSquare = false;
        // are we generating moves for a single square?
        if (forSquare) {
            // illegal square, return empty moves
            if (!(forSquare in $e1e1f1f3cd154daa$var$Ox88)) return [];
            else {
                firstSquare = lastSquare = $e1e1f1f3cd154daa$var$Ox88[forSquare];
                singleSquare = true;
            }
        }
        for(let from = firstSquare; from <= lastSquare; from++){
            // did we run off the end of the board
            if (from & 0x88) {
                from += 7;
                continue;
            }
            // empty square or opponent, skip
            if (!this._board[from] || this._board[from].color === them) continue;
            const { type: type  } = this._board[from];
            let to;
            if (type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                if (forPiece && forPiece !== type) continue;
                // single square, non-capturing
                to = from + $e1e1f1f3cd154daa$var$PAWN_OFFSETS[us][0];
                if (!this._board[to]) {
                    $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0);
                    // double square
                    to = from + $e1e1f1f3cd154daa$var$PAWN_OFFSETS[us][1];
                    if ($e1e1f1f3cd154daa$var$SECOND_RANK[us] === $e1e1f1f3cd154daa$var$rank(from) && !this._board[to]) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, undefined, $e1e1f1f3cd154daa$var$BITS.BIG_PAWN);
                }
                // pawn captures
                for(let j = 2; j < 4; j++){
                    to = from + $e1e1f1f3cd154daa$var$PAWN_OFFSETS[us][j];
                    if (to & 0x88) continue;
                    if (this._board[to]?.color === them) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, this._board[to].type, $e1e1f1f3cd154daa$var$BITS.CAPTURE);
                    else if (to === this._epSquare) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0, $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE);
                }
            } else {
                if (forPiece && forPiece !== type) continue;
                for(let j = 0, len = $e1e1f1f3cd154daa$var$PIECE_OFFSETS[type].length; j < len; j++){
                    const offset = $e1e1f1f3cd154daa$var$PIECE_OFFSETS[type][j];
                    to = from;
                    while(true){
                        to += offset;
                        if (to & 0x88) break;
                        if (!this._board[to]) $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, type);
                        else {
                            // own color, stop loop
                            if (this._board[to].color === us) break;
                            $e1e1f1f3cd154daa$var$addMove(moves, us, from, to, type, this._board[to].type, $e1e1f1f3cd154daa$var$BITS.CAPTURE);
                            break;
                        }
                        /* break, if knight or king */ if (type === $e1e1f1f3cd154daa$export$ce32bc8c2a29bae6 || type === $e1e1f1f3cd154daa$export$42387107bb0d6206) break;
                    }
                }
            }
        }
        /*
         * check for castling if we're:
         *   a) generating all moves, or
         *   b) doing single square move generation on the king's square
         */ if (forPiece === undefined || forPiece === $e1e1f1f3cd154daa$export$42387107bb0d6206) {
            if (!singleSquare || lastSquare === this._kings[us]) {
                // king-side castling
                if (this._castling[us] & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom + 2;
                    if (!this._board[castlingFrom + 1] && !this._board[castlingTo] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom + 1) && !this._attacked(them, castlingTo)) $e1e1f1f3cd154daa$var$addMove(moves, us, this._kings[us], castlingTo, $e1e1f1f3cd154daa$export$42387107bb0d6206, undefined, $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE);
                }
                // queen-side castling
                if (this._castling[us] & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom - 2;
                    if (!this._board[castlingFrom - 1] && !this._board[castlingFrom - 2] && !this._board[castlingFrom - 3] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom - 1) && !this._attacked(them, castlingTo)) $e1e1f1f3cd154daa$var$addMove(moves, us, this._kings[us], castlingTo, $e1e1f1f3cd154daa$export$42387107bb0d6206, undefined, $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE);
                }
            }
        }
        /*
         * return all pseudo-legal moves (this includes moves that allow the king
         * to be captured)
         */ if (!legal || this._kings[us] === -1) return moves;
        // filter out illegal moves
        const legalMoves = [];
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(us)) legalMoves.push(moves[i]);
            this._undoMove();
        }
        return legalMoves;
    }
    move(move, { strict: strict = false  } = {}) {
        /*
         * The move function can be called with in the following parameters:
         *
         * .move('Nxb7')       <- argument is a case-sensitive SAN string
         *
         * .move({ from: 'h7', <- argument is a move object
         *         to :'h8',
         *         promotion: 'q' })
         *
         *
         * An optional strict argument may be supplied to tell chess.js to
         * strictly follow the SAN specification.
         */ let moveObj = null;
        if (typeof move === "string") moveObj = this._moveFromSan(move, strict);
        else if (move === null) moveObj = this._moveFromSan($e1e1f1f3cd154daa$var$SAN_NULLMOVE, strict);
        else if (typeof move === "object") {
            const moves = this._moves();
            // convert the pretty move object to an ugly move object
            for(let i = 0, len = moves.length; i < len; i++)if (move.from === $e1e1f1f3cd154daa$var$algebraic(moves[i].from) && move.to === $e1e1f1f3cd154daa$var$algebraic(moves[i].to) && (!("promotion" in moves[i]) || move.promotion === moves[i].promotion)) {
                moveObj = moves[i];
                break;
            }
        }
        // failed to find move
        if (!moveObj) {
            if (typeof move === "string") throw new Error(`Invalid move: ${move}`);
            else throw new Error(`Invalid move: ${JSON.stringify(move)}`);
        }
        //disallow null moves when in check
        if (this.isCheck() && moveObj.flags & $e1e1f1f3cd154daa$var$BITS.NULL_MOVE) throw new Error("Null move not allowed when in check");
        /*
         * need to make a copy of move because we can't generate SAN after the move
         * is made
         */ const prettyMove = new $e1e1f1f3cd154daa$export$e49a5ad3dd6df925(this, moveObj);
        this._makeMove(moveObj);
        this._incPositionCount();
        return prettyMove;
    }
    _push(move) {
        this._history.push({
            move: move,
            kings: {
                b: this._kings.b,
                w: this._kings.w
            },
            turn: this._turn,
            castling: {
                b: this._castling.b,
                w: this._castling.w
            },
            epSquare: this._epSquare,
            halfMoves: this._halfMoves,
            moveNumber: this._moveNumber
        });
    }
    _movePiece(from, to) {
        this._hash ^= this._pieceKey(from);
        this._board[to] = this._board[from];
        delete this._board[from];
        this._hash ^= this._pieceKey(to);
    }
    _makeMove(move) {
        const us = this._turn;
        const them = $e1e1f1f3cd154daa$var$swapColor(us);
        this._push(move);
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.NULL_MOVE) {
            if (us === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._moveNumber++;
            this._halfMoves++;
            this._turn = them;
            this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
            return;
        }
        this._hash ^= this._epKey();
        this._hash ^= this._castlingKey();
        if (move.captured) this._hash ^= this._pieceKey(move.to);
        this._movePiece(move.from, move.to);
        // if ep capture, remove the captured pawn
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE) {
            if (this._turn === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._clear(move.to - 16);
            else this._clear(move.to + 16);
        }
        // if pawn promotion, replace with new piece
        if (move.promotion) {
            this._clear(move.to);
            this._set(move.to, {
                type: move.promotion,
                color: us
            });
        }
        // if we moved the king
        if (this._board[move.to].type === $e1e1f1f3cd154daa$export$42387107bb0d6206) {
            this._kings[us] = move.to;
            // if we castled, move the rook next to the king
            if (move.flags & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) {
                const castlingTo = move.to - 1;
                const castlingFrom = move.to + 1;
                this._movePiece(castlingFrom, castlingTo);
            } else if (move.flags & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) {
                const castlingTo = move.to + 1;
                const castlingFrom = move.to - 2;
                this._movePiece(castlingFrom, castlingTo);
            }
            // turn off castling
            this._castling[us] = 0;
        }
        // turn off castling if we move a rook
        if (this._castling[us]) {
            for(let i = 0, len = $e1e1f1f3cd154daa$var$ROOKS[us].length; i < len; i++)if (move.from === $e1e1f1f3cd154daa$var$ROOKS[us][i].square && this._castling[us] & $e1e1f1f3cd154daa$var$ROOKS[us][i].flag) {
                this._castling[us] ^= $e1e1f1f3cd154daa$var$ROOKS[us][i].flag;
                break;
            }
        }
        // turn off castling if we capture a rook
        if (this._castling[them]) {
            for(let i = 0, len = $e1e1f1f3cd154daa$var$ROOKS[them].length; i < len; i++)if (move.to === $e1e1f1f3cd154daa$var$ROOKS[them][i].square && this._castling[them] & $e1e1f1f3cd154daa$var$ROOKS[them][i].flag) {
                this._castling[them] ^= $e1e1f1f3cd154daa$var$ROOKS[them][i].flag;
                break;
            }
        }
        this._hash ^= this._castlingKey();
        // if big pawn move, update the en passant square
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.BIG_PAWN) {
            let epSquare;
            if (us === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) epSquare = move.to - 16;
            else epSquare = move.to + 16;
            if (!(move.to - 1 & 0x88) && this._board[move.to - 1]?.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0 && this._board[move.to - 1]?.color === them || !(move.to + 1 & 0x88) && this._board[move.to + 1]?.type === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0 && this._board[move.to + 1]?.color === them) {
                this._epSquare = epSquare;
                this._hash ^= this._epKey();
            } else this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
        } else this._epSquare = $e1e1f1f3cd154daa$var$EMPTY;
        // reset the 50 move counter if a pawn is moved or a piece is captured
        if (move.piece === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) this._halfMoves = 0;
        else if (move.flags & ($e1e1f1f3cd154daa$var$BITS.CAPTURE | $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE)) this._halfMoves = 0;
        else this._halfMoves++;
        if (us === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) this._moveNumber++;
        this._turn = them;
        this._hash ^= $e1e1f1f3cd154daa$var$SIDE_KEY;
    }
    undo() {
        const hash = this._hash;
        const move = this._undoMove();
        if (move) {
            const prettyMove = new $e1e1f1f3cd154daa$export$e49a5ad3dd6df925(this, move);
            this._decPositionCount(hash);
            return prettyMove;
        }
        return null;
    }
    _undoMove() {
        const old = this._history.pop();
        if (old === undefined) return null;
        this._hash ^= this._epKey();
        this._hash ^= this._castlingKey();
        const move = old.move;
        this._kings = old.kings;
        this._turn = old.turn;
        this._castling = old.castling;
        this._epSquare = old.epSquare;
        this._halfMoves = old.halfMoves;
        this._moveNumber = old.moveNumber;
        this._hash ^= this._epKey();
        this._hash ^= this._castlingKey();
        this._hash ^= $e1e1f1f3cd154daa$var$SIDE_KEY;
        const us = this._turn;
        const them = $e1e1f1f3cd154daa$var$swapColor(us);
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.NULL_MOVE) return move;
        this._movePiece(move.to, move.from);
        // to undo any promotions
        if (move.piece) {
            this._clear(move.from);
            this._set(move.from, {
                type: move.piece,
                color: us
            });
        }
        if (move.captured) {
            if (move.flags & $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE) {
                // en passant capture
                let index;
                if (us === $e1e1f1f3cd154daa$export$7a91b0fde7ec420f) index = move.to - 16;
                else index = move.to + 16;
                this._set(index, {
                    type: $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0,
                    color: them
                });
            } else // regular capture
            this._set(move.to, {
                type: move.captured,
                color: them
            });
        }
        if (move.flags & ($e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE | $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE)) {
            let castlingTo, castlingFrom;
            if (move.flags & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) {
                castlingTo = move.to + 1;
                castlingFrom = move.to - 1;
            } else {
                castlingTo = move.to - 2;
                castlingFrom = move.to + 1;
            }
            this._movePiece(castlingFrom, castlingTo);
        }
        return move;
    }
    pgn({ newline: newline = "\n" , maxWidth: maxWidth = 0  } = {}) {
        /*
         * using the specification from http://www.chessclub.com/help/PGN-spec
         * example for html usage: .pgn({ max_width: 72, newline_char: "<br />" })
         */ const result = [];
        let headerExists = false;
        /* add the PGN header information */ for(const i in this._header){
            /*
             * TODO: order of enumerated properties in header object is not
             * guaranteed, see ECMA-262 spec (section 12.6.4)
             *
             * By using HEADER_TEMPLATE, the order of tags should be preserved; we
             * do have to check for null placeholders, though, and omit them
             */ const headerTag = this._header[i];
            if (headerTag) result.push(`[${i} "${this._header[i]}"]` + newline);
            headerExists = true;
        }
        if (headerExists && this._history.length) result.push(newline);
        const appendComment = (moveString)=>{
            const comment = this._comments[this.fen()];
            if (typeof comment !== "undefined") {
                const delimiter = moveString.length > 0 ? " " : "";
                moveString = `${moveString}${delimiter}{${comment}}`;
            }
            return moveString;
        };
        // pop all of history onto reversed_history
        const reversedHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        const moves = [];
        let moveString = "";
        // special case of a commented starting position with no moves
        if (reversedHistory.length === 0) moves.push(appendComment(""));
        // build the list of moves.  a move_string looks like: "3. e3 e6"
        while(reversedHistory.length > 0){
            moveString = appendComment(moveString);
            const move = reversedHistory.pop();
            // make TypeScript stop complaining about move being undefined
            if (!move) break;
            // if the position started with black to move, start PGN with #. ...
            if (!this._history.length && move.color === "b") {
                const prefix = `${this._moveNumber}. ...`;
                // is there a comment preceding the first move?
                moveString = moveString ? `${moveString} ${prefix}` : prefix;
            } else if (move.color === "w") {
                // store the previous generated move_string if we have one
                if (moveString.length) moves.push(moveString);
                moveString = this._moveNumber + ".";
            }
            moveString = moveString + " " + this._moveToSan(move, this._moves({
                legal: true
            }));
            this._makeMove(move);
        }
        // are there any other leftover moves?
        if (moveString.length) moves.push(appendComment(moveString));
        // is there a result? (there ALWAYS has to be a result according to spec; see Seven Tag Roster)
        moves.push(this._header.Result || "*");
        /*
         * history should be back to what it was before we started generating PGN,
         * so join together moves
         */ if (maxWidth === 0) return result.join("") + moves.join(" ");
        // TODO (jah): huh?
        const strip = function() {
            if (result.length > 0 && result[result.length - 1] === " ") {
                result.pop();
                return true;
            }
            return false;
        };
        // NB: this does not preserve comment whitespace.
        const wrapComment = function(width, move) {
            for (const token of move.split(" ")){
                if (!token) continue;
                if (width + token.length > maxWidth) {
                    while(strip())width--;
                    result.push(newline);
                    width = 0;
                }
                result.push(token);
                width += token.length;
                result.push(" ");
                width++;
            }
            if (strip()) width--;
            return width;
        };
        // wrap the PGN output at max_width
        let currentWidth = 0;
        for(let i = 0; i < moves.length; i++){
            if (currentWidth + moves[i].length > maxWidth) {
                if (moves[i].includes("{")) {
                    currentWidth = wrapComment(currentWidth, moves[i]);
                    continue;
                }
            }
            // if the current move will push past max_width
            if (currentWidth + moves[i].length > maxWidth && i !== 0) {
                // don't end the line with whitespace
                if (result[result.length - 1] === " ") result.pop();
                result.push(newline);
                currentWidth = 0;
            } else if (i !== 0) {
                result.push(" ");
                currentWidth++;
            }
            result.push(moves[i]);
            currentWidth += moves[i].length;
        }
        return result.join("");
    }
    /**
     * @deprecated Use `setHeader` and `getHeaders` instead. This method will return null header tags (which is not what you want)
     */ header(...args) {
        for(let i = 0; i < args.length; i += 2)if (typeof args[i] === "string" && typeof args[i + 1] === "string") this._header[args[i]] = args[i + 1];
        return this._header;
    }
    // TODO: value validation per spec
    setHeader(key, value) {
        this._header[key] = value ?? $e1e1f1f3cd154daa$export$2873e67bbeaa3712[key] ?? null;
        return this.getHeaders();
    }
    removeHeader(key) {
        if (key in this._header) {
            this._header[key] = $e1e1f1f3cd154daa$export$2873e67bbeaa3712[key] || null;
            return true;
        }
        return false;
    }
    // return only non-null headers (omit placemarker nulls)
    getHeaders() {
        const nonNullHeaders = {};
        for (const [key, value] of Object.entries(this._header))if (value !== null) nonNullHeaders[key] = value;
        return nonNullHeaders;
    }
    loadPgn(pgn, { strict: strict = false , newlineChar: newlineChar = "\r?\n"  } = {}) {
        // If newlineChar is not the default, replace all instances with \n
        if (newlineChar !== "\r?\n") pgn = pgn.replace(new RegExp(newlineChar, "g"), "\n");
        const parsedPgn = $e1e1f1f3cd154daa$var$peg$parse(pgn);
        // Put the board in the starting position
        this.reset();
        // parse PGN header
        const headers = parsedPgn.headers;
        let fen = "";
        for(const key in headers){
            // check to see user is including fen (possibly with wrong tag case)
            if (key.toLowerCase() === "fen") fen = headers[key];
            this.header(key, headers[key]);
        }
        /*
         * the permissive parser should attempt to load a fen tag, even if it's the
         * wrong case and doesn't include a corresponding [SetUp "1"] tag
         */ if (!strict) {
            if (fen) this.load(fen, {
                preserveHeaders: true
            });
        } else /*
             * strict parser - load the starting position indicated by [Setup '1']
             * and [FEN position]
             */ if (headers["SetUp"] === "1") {
            if (!("FEN" in headers)) throw new Error("Invalid PGN: FEN tag must be supplied with SetUp tag");
            // don't clear the headers when loading
            this.load(headers["FEN"], {
                preserveHeaders: true
            });
        }
        let node = parsedPgn.root;
        while(node){
            if (node.move) {
                const move = this._moveFromSan(node.move, strict);
                if (move == null) throw new Error(`Invalid move in PGN: ${node.move}`);
                else {
                    this._makeMove(move);
                    this._incPositionCount();
                }
            }
            if (node.comment !== undefined) this._comments[this.fen()] = node.comment;
            node = node.variations[0];
        }
        /*
         * Per section 8.2.6 of the PGN spec, the Result tag pair must match match
         * the termination marker. Only do this when headers are present, but the
         * result tag is missing
         */ const result = parsedPgn.result;
        if (result && Object.keys(this._header).length && this._header["Result"] !== result) this.setHeader("Result", result);
    }
    /*
     * Convert a move from 0x88 coordinates to Standard Algebraic Notation
     * (SAN)
     *
     * @param {boolean} strict Use the strict SAN parser. It will throw errors
     * on overly disambiguated moves (see below):
     *
     * r1bqkbnr/ppp2ppp/2n5/1B1pP3/4P3/8/PPPP2PP/RNBQK1NR b KQkq - 2 4
     * 4. ... Nge7 is overly disambiguated because the knight on c6 is pinned
     * 4. ... Ne7 is technically the valid SAN
     */ _moveToSan(move, moves) {
        let output = "";
        if (move.flags & $e1e1f1f3cd154daa$var$BITS.KSIDE_CASTLE) output = "O-O";
        else if (move.flags & $e1e1f1f3cd154daa$var$BITS.QSIDE_CASTLE) output = "O-O-O";
        else if (move.flags & $e1e1f1f3cd154daa$var$BITS.NULL_MOVE) return $e1e1f1f3cd154daa$var$SAN_NULLMOVE;
        else {
            if (move.piece !== $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) {
                const disambiguator = $e1e1f1f3cd154daa$var$getDisambiguator(move, moves);
                output += move.piece.toUpperCase() + disambiguator;
            }
            if (move.flags & ($e1e1f1f3cd154daa$var$BITS.CAPTURE | $e1e1f1f3cd154daa$var$BITS.EP_CAPTURE)) {
                if (move.piece === $e1e1f1f3cd154daa$export$4c32fd1f222ff2b0) output += $e1e1f1f3cd154daa$var$algebraic(move.from)[0];
                output += "x";
            }
            output += $e1e1f1f3cd154daa$var$algebraic(move.to);
            if (move.promotion) output += "=" + move.promotion.toUpperCase();
        }
        this._makeMove(move);
        if (this.isCheck()) {
            if (this.isCheckmate()) output += "#";
            else output += "+";
        }
        this._undoMove();
        return output;
    }
    // convert a move from Standard Algebraic Notation (SAN) to 0x88 coordinates
    _moveFromSan(move, strict = false) {
        // strip off any move decorations: e.g Nf3+?! becomes Nf3
        let cleanMove = $e1e1f1f3cd154daa$var$strippedSan(move);
        if (!strict) {
            if (cleanMove === "0-0") cleanMove = "O-O";
            else if (cleanMove === "0-0-0") cleanMove = "O-O-O";
        }
        //first implementation of null with a dummy move (black king moves from a8 to a8), maybe this can be implemented better
        if (cleanMove == $e1e1f1f3cd154daa$var$SAN_NULLMOVE) {
            const res = {
                color: this._turn,
                from: 0,
                to: 0,
                piece: "k",
                flags: $e1e1f1f3cd154daa$var$BITS.NULL_MOVE
            };
            return res;
        }
        let pieceType = $e1e1f1f3cd154daa$var$inferPieceType(cleanMove);
        let moves = this._moves({
            legal: true,
            piece: pieceType
        });
        // strict parser
        for(let i = 0, len = moves.length; i < len; i++){
            if (cleanMove === $e1e1f1f3cd154daa$var$strippedSan(this._moveToSan(moves[i], moves))) return moves[i];
        }
        // the strict parser failed
        if (strict) return null;
        let piece = undefined;
        let matches = undefined;
        let from = undefined;
        let to = undefined;
        let promotion = undefined;
        /*
         * The default permissive (non-strict) parser allows the user to parse
         * non-standard chess notations. This parser is only run after the strict
         * Standard Algebraic Notation (SAN) parser has failed.
         *
         * When running the permissive parser, we'll run a regex to grab the piece, the
         * to/from square, and an optional promotion piece. This regex will
         * parse common non-standard notation like: Pe2-e4, Rc1c4, Qf3xf7,
         * f7f8q, b1c3
         *
         * NOTE: Some positions and moves may be ambiguous when using the permissive
         * parser. For example, in this position: 6k1/8/8/B7/8/8/8/BN4K1 w - - 0 1,
         * the move b1c3 may be interpreted as Nc3 or B1c3 (a disambiguated bishop
         * move). In these cases, the permissive parser will default to the most
         * basic interpretation (which is b1c3 parsing to Nc3).
         */ let overlyDisambiguated = false;
        matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h][1-8])x?-?([a-h][1-8])([qrbnQRBN])?/);
        if (matches) {
            piece = matches[1];
            from = matches[2];
            to = matches[3];
            promotion = matches[4];
            if (from.length == 1) overlyDisambiguated = true;
        } else {
            /*
             * The [a-h]?[1-8]? portion of the regex below handles moves that may be
             * overly disambiguated (e.g. Nge7 is unnecessary and non-standard when
             * there is one legal knight move to e7). In this case, the value of
             * 'from' variable will be a rank or file, not a square.
             */ matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h]?[1-8]?)x?-?([a-h][1-8])([qrbnQRBN])?/);
            if (matches) {
                piece = matches[1];
                from = matches[2];
                to = matches[3];
                promotion = matches[4];
                if (from.length == 1) overlyDisambiguated = true;
            }
        }
        pieceType = $e1e1f1f3cd154daa$var$inferPieceType(cleanMove);
        moves = this._moves({
            legal: true,
            piece: piece ? piece : pieceType
        });
        if (!to) return null;
        for(let i = 0, len = moves.length; i < len; i++){
            if (!from) {
                // if there is no from square, it could be just 'x' missing from a capture
                if (cleanMove === $e1e1f1f3cd154daa$var$strippedSan(this._moveToSan(moves[i], moves)).replace("x", "")) return moves[i];
            // hand-compare move properties with the results from our permissive regex
            } else if ((!piece || piece.toLowerCase() == moves[i].piece) && $e1e1f1f3cd154daa$var$Ox88[from] == moves[i].from && $e1e1f1f3cd154daa$var$Ox88[to] == moves[i].to && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            else if (overlyDisambiguated) {
                /*
                 * SPECIAL CASE: we parsed a move string that may have an unneeded
                 * rank/file disambiguator (e.g. Nge7).  The 'from' variable will
                 */ const square = $e1e1f1f3cd154daa$var$algebraic(moves[i].from);
                if ((!piece || piece.toLowerCase() == moves[i].piece) && $e1e1f1f3cd154daa$var$Ox88[to] == moves[i].to && (from == square[0] || from == square[1]) && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            }
        }
        return null;
    }
    ascii() {
        let s = "   +------------------------+\n";
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            // display the rank
            if ($e1e1f1f3cd154daa$var$file(i) === 0) s += " " + "87654321"[$e1e1f1f3cd154daa$var$rank(i)] + " |";
            if (this._board[i]) {
                const piece = this._board[i].type;
                const color = this._board[i].color;
                const symbol = color === $e1e1f1f3cd154daa$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
                s += " " + symbol + " ";
            } else s += " . ";
            if (i + 1 & 0x88) {
                s += "|\n";
                i += 8;
            }
        }
        s += "   +------------------------+\n";
        s += "     a  b  c  d  e  f  g  h";
        return s;
    }
    perft(depth) {
        const moves = this._moves({
            legal: false
        });
        let nodes = 0;
        const color = this._turn;
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(color)) {
                if (depth - 1 > 0) nodes += this.perft(depth - 1);
                else nodes++;
            }
            this._undoMove();
        }
        return nodes;
    }
    setTurn(color) {
        if (this._turn == color) return false;
        this.move("--");
        return true;
    }
    turn() {
        return this._turn;
    }
    board() {
        const output = [];
        let row = [];
        for(let i = $e1e1f1f3cd154daa$var$Ox88.a8; i <= $e1e1f1f3cd154daa$var$Ox88.h1; i++){
            if (this._board[i] == null) row.push(null);
            else row.push({
                square: $e1e1f1f3cd154daa$var$algebraic(i),
                type: this._board[i].type,
                color: this._board[i].color
            });
            if (i + 1 & 0x88) {
                output.push(row);
                row = [];
                i += 8;
            }
        }
        return output;
    }
    squareColor(square) {
        if (square in $e1e1f1f3cd154daa$var$Ox88) {
            const sq = $e1e1f1f3cd154daa$var$Ox88[square];
            return ($e1e1f1f3cd154daa$var$rank(sq) + $e1e1f1f3cd154daa$var$file(sq)) % 2 === 0 ? "light" : "dark";
        }
        return null;
    }
    history({ verbose: verbose = false  } = {}) {
        const reversedHistory = [];
        const moveHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            if (verbose) moveHistory.push(new $e1e1f1f3cd154daa$export$e49a5ad3dd6df925(this, move));
            else moveHistory.push(this._moveToSan(move, this._moves()));
            this._makeMove(move);
        }
        return moveHistory;
    }
    /*
     * Keeps track of position occurrence counts for the purpose of repetition
     * checking. Old positions are removed from the map if their counts are reduced to 0.
     */ _getPositionCount(hash) {
        return this._positionCount.get(hash) ?? 0;
    }
    _incPositionCount() {
        this._positionCount.set(this._hash, (this._positionCount.get(this._hash) ?? 0) + 1);
    }
    _decPositionCount(hash) {
        const currentCount = this._positionCount.get(hash) ?? 0;
        if (currentCount === 1) this._positionCount.delete(hash);
        else this._positionCount.set(hash, currentCount - 1);
    }
    _pruneComments() {
        const reversedHistory = [];
        const currentComments = {};
        const copyComment = (fen)=>{
            if (fen in this._comments) currentComments[fen] = this._comments[fen];
        };
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        copyComment(this.fen());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            this._makeMove(move);
            copyComment(this.fen());
        }
        this._comments = currentComments;
    }
    getComment() {
        return this._comments[this.fen()];
    }
    setComment(comment) {
        this._comments[this.fen()] = comment.replace("{", "[").replace("}", "]");
    }
    /**
     * @deprecated Renamed to `removeComment` for consistency
     */ deleteComment() {
        return this.removeComment();
    }
    removeComment() {
        const comment = this._comments[this.fen()];
        delete this._comments[this.fen()];
        return comment;
    }
    getComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            return {
                fen: fen,
                comment: this._comments[fen]
            };
        });
    }
    /**
     * @deprecated Renamed to `removeComments` for consistency
     */ deleteComments() {
        return this.removeComments();
    }
    removeComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            const comment = this._comments[fen];
            delete this._comments[fen];
            return {
                fen: fen,
                comment: comment
            };
        });
    }
    setCastlingRights(color, rights) {
        for (const side of [
            $e1e1f1f3cd154daa$export$42387107bb0d6206,
            $e1e1f1f3cd154daa$export$36a8946792f13ec9
        ])if (rights[side] !== undefined) {
            if (rights[side]) this._castling[color] |= $e1e1f1f3cd154daa$var$SIDES[side];
            else this._castling[color] &= ~$e1e1f1f3cd154daa$var$SIDES[side];
        }
        this._updateCastlingRights();
        const result = this.getCastlingRights(color);
        return (rights[$e1e1f1f3cd154daa$export$42387107bb0d6206] === undefined || rights[$e1e1f1f3cd154daa$export$42387107bb0d6206] === result[$e1e1f1f3cd154daa$export$42387107bb0d6206]) && (rights[$e1e1f1f3cd154daa$export$36a8946792f13ec9] === undefined || rights[$e1e1f1f3cd154daa$export$36a8946792f13ec9] === result[$e1e1f1f3cd154daa$export$36a8946792f13ec9]);
    }
    getCastlingRights(color) {
        return {
            [$e1e1f1f3cd154daa$export$42387107bb0d6206]: (this._castling[color] & $e1e1f1f3cd154daa$var$SIDES[$e1e1f1f3cd154daa$export$42387107bb0d6206]) !== 0,
            [$e1e1f1f3cd154daa$export$36a8946792f13ec9]: (this._castling[color] & $e1e1f1f3cd154daa$var$SIDES[$e1e1f1f3cd154daa$export$36a8946792f13ec9]) !== 0
        };
    }
    moveNumber() {
        return this._moveNumber;
    }
}



class $6531107febf5e71a$export$efd12fbd35282d77 {
    constructor(move = null, parent = null, moveNumber = 0){
        // move: chess.js Move object (contains FEN before/after, SAN, etc.)
        this.move = move;
        this.parent = parent; // Reference to parent PgnNode
        this.children = []; // Array of child PgnNodes (variations)
        this.comment = "";
        // Store FEN after the move for quick access
        this.fen = move ? move.after : null;
        this.moveNumber = moveNumber;
    }
    // Add a move (chess.js Move object) as a child
    addMove(move, moveNumber) {
        // Check if the move already exists as a variation (based on SAN)
        const existing = this.children.find((child)=>child.move.san === move.san);
        if (existing) return {
            node: existing,
            isNew: false
        };
        const newNode = new $6531107febf5e71a$export$efd12fbd35282d77(move, this, moveNumber);
        // Ensure FEN is set correctly - if move.after is not available, calculate it
        if (!newNode.fen && move && move.after) newNode.fen = move.after;
        else if (!newNode.fen && this.fen) // If we don't have move.after, calculate the FEN by applying the move
        try {
            const chess = new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)(this.fen);
            const result = chess.move({
                from: move.from,
                to: move.to,
                promotion: move.promotion || "q"
            });
            if (result) newNode.fen = chess.fen();
        } catch (e) {
            // Fallback to START_FEN if calculation fails
            newNode.fen = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
        }
        this.children.push(newNode);
        return {
            node: newNode,
            isNew: true
        };
    }
    // Delete this node and its entire subtree
    deleteNode() {
        if (!this.parent) // Cannot delete root node
        return false;
        // Remove this node from parent's children array
        const index = this.parent.children.indexOf(this);
        if (index > -1) {
            this.parent.children.splice(index, 1);
            index === 0 && this.parent.children.length;
            return true;
        }
        return false;
    }
}
// --- Serialization/Deserialization ---
// Helper to simplify a chess.js move object for storage (JSON compatible)
const $6531107febf5e71a$var$simplifyMove = (move)=>{
    if (!move) return null;
    // We only need enough info to replay the move (from, to, promotion)
    return {
        f: move.from,
        t: move.to,
        p: move.promotion
    };
};
const $6531107febf5e71a$export$b108b341429564b6 = (node)=>{
    if (!node) return {
        c: []
    };
    const serializedNode = {
        // We don't store the move at the root node
        m: node.parent ? $6531107febf5e71a$var$simplifyMove(node.move) : null,
        cm: node.comment || "",
        c: node.children.map((child)=>$6531107febf5e71a$export$b108b341429564b6(child))
    };
    if (!serializedNode.m) delete serializedNode.m;
    if (!serializedNode.cm) delete serializedNode.cm;
    return serializedNode;
};
const $6531107febf5e71a$var$START_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
const $6531107febf5e71a$export$1e58ac48354d58f9 = (serializedTree, startFen = $6531107febf5e71a$var$START_FEN)=>{
    const chess = new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)(startFen);
    const root = new $6531107febf5e71a$export$efd12fbd35282d77(null, null, 0);
    root.fen = startFen;
    const buildTree = (parentNode, childrenData)=>{
        // Save the state before replaying moves from this node
        const fenBefore = chess.fen();
        childrenData.forEach((childData)=>{
            // Reset to the parent state before playing the variation
            chess.load(fenBefore);
            // The move number we want to associate with the upcoming move
            const moveNumber = chess.moveNumber();
            const move = chess.move({
                from: childData.m.f,
                to: childData.m.t,
                promotion: childData.m.p
            });
            if (move) {
                // Use the result object from addMove
                const { node: newNode  } = parentNode.addMove(move, moveNumber);
                // Ensure the FEN is set correctly for this node
                newNode.fen = chess.fen();
                newNode.comment = childData.cm || ""; // Restore comments
                // Recursively build the rest of the tree
                buildTree(newNode, childData.c);
            }
        });
        // Reset chess instance to start after building the whole tree structure
        if (parentNode === root) chess.load(startFen);
    };
    if (serializedTree && serializedTree.c) buildTree(root, serializedTree.c);
    return root;
};



var $bh6RR = parcelRequire("bh6RR");
function $57084659f555c894$var$_extends() {
    return $57084659f555c894$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57084659f555c894$var$_extends.apply(null, arguments);
}
function $57084659f555c894$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $57084659f555c894$var$useOnMount(callback) {
    (0, $bh6RR.useEffect)(callback, []);
}
var $57084659f555c894$var$_excluded = [
    "id",
    "volume",
    "playbackRate",
    "soundEnabled",
    "interrupt",
    "onload"
];

function $57084659f555c894$export$a34349420ba3cec8(src, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$volume = _ref.volume, volume = _ref$volume === void 0 ? 1 : _ref$volume, _ref$playbackRate = _ref.playbackRate, playbackRate = _ref$playbackRate === void 0 ? 1 : _ref$playbackRate, _ref$soundEnabled = _ref.soundEnabled, soundEnabled = _ref$soundEnabled === void 0 ? true : _ref$soundEnabled, _ref$interrupt = _ref.interrupt, interrupt = _ref$interrupt === void 0 ? false : _ref$interrupt, onload = _ref.onload, delegated = $57084659f555c894$var$_objectWithoutPropertiesLoose(_ref, $57084659f555c894$var$_excluded);
    var HowlConstructor = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null), duration = _React$useState[0], setDuration = _React$useState[1];
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null), sound = _React$useState2[0], setSound = _React$useState2[1];
    var handleLoad = function handleLoad() {
        if (typeof onload === "function") // @ts-ignore
        onload.call(this);
        if (isMounted.current) // @ts-ignore
        setDuration(this.duration() * 1000);
        // @ts-ignore
        setSound(this);
    };
    // We want to lazy-load Howler, since sounds can't play on load anyway.
    $57084659f555c894$var$useOnMount(function() {
        (parcelRequire("3vQgY")).then(function(mod) {
            if (!isMounted.current) {
                var _mod$Howl;
                // Depending on the module system used, `mod` might hold
                // the export directly, or it might be under `default`.
                HowlConstructor.current = (_mod$Howl = mod.Howl) !== null && _mod$Howl !== void 0 ? _mod$Howl : mod["default"].Howl;
                isMounted.current = true;
                new HowlConstructor.current($57084659f555c894$var$_extends({
                    src: Array.isArray(src) ? src : [
                        src
                    ],
                    volume: volume,
                    rate: playbackRate,
                    onload: handleLoad
                }, delegated));
            }
        });
        return function() {
            isMounted.current = false;
        };
    });
    // When the `src` changes, we have to do a whole thing where we recreate
    // the Howl instance. This is because Howler doesn't expose a way to
    // tweak the sound
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        if (HowlConstructor.current && sound) setSound(new HowlConstructor.current($57084659f555c894$var$_extends({
            src: Array.isArray(src) ? src : [
                src
            ],
            volume: volume,
            onload: handleLoad
        }, delegated)));
    // The linter wants to run this effect whenever ANYTHING changes,
    // but very specifically I only want to recreate the Howl instance
    // when the `src` changes. Other changes should have no effect.
    // Passing array to the useEffect dependencies list will result in
    // ifinite loop so we need to stringify it, for more details check
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(src)
    ]);
    // Whenever volume/playbackRate are changed, change those properties
    // on the sound instance.
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        if (sound) {
            sound.volume(volume);
            // HACK: When a sprite is defined, `sound.rate()` throws an error, because Howler tries to reset the "_default" sprite, which doesn't exist. This is likely a bug within Howler, but I don’t have the bandwidth to investigate, so instead, we’re ignoring playbackRate changes when a sprite is defined.
            if (!delegated.sprite) sound.rate(playbackRate);
        }
    }, [
        sound,
        volume,
        playbackRate
    ]);
    var play = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(options) {
        if (typeof options === "undefined") options = {};
        if (!sound || !soundEnabled && !options.forceSoundEnabled) return;
        if (interrupt) sound.stop();
        if (options.playbackRate) sound.rate(options.playbackRate);
        sound.play(options.id);
    }, [
        sound,
        soundEnabled,
        interrupt
    ]);
    var stop = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(id) {
        if (!sound) return;
        sound.stop(id);
    }, [
        sound
    ]);
    var pause = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(id) {
        if (!sound) return;
        sound.pause(id);
    }, [
        sound
    ]);
    var returnedValue = [
        play,
        {
            sound: sound,
            stop: stop,
            pause: pause,
            duration: duration
        }
    ];
    return returnedValue;
}
var $57084659f555c894$export$2e2bcd8739ae039 = $57084659f555c894$export$a34349420ba3cec8;


var $82ccdc90324af0e7$exports = {};

$82ccdc90324af0e7$exports = new URL((parcelRequire("kyEFX")).resolve("1hqhz"), import.meta.url).toString();


var $b707c1ec3f10a507$exports = {};

$b707c1ec3f10a507$exports = new URL((parcelRequire("kyEFX")).resolve("g4QIV"), import.meta.url).toString();


var $c28d5afbd02b6b64$exports = {};

$c28d5afbd02b6b64$exports = new URL((parcelRequire("kyEFX")).resolve("gkIZ5"), import.meta.url).toString();


var $c9f3d3b79865965e$exports = {};

$c9f3d3b79865965e$exports = new URL((parcelRequire("kyEFX")).resolve("aE81X"), import.meta.url).toString();


const $7ead3b1a9a673b0a$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
const $7ead3b1a9a673b0a$var$START_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
const $7ead3b1a9a673b0a$var$API_BASE_URL = "https://fhdkkwkge6.execute-api.us-east-1.amazonaws.com/dev/";
const $7ead3b1a9a673b0a$var$API_KEY = "D6Y97ztlHO2fqaiSQeEoR8xv09pDBoSL1zx5rgEN";
// When a user drags the king to the rook's square (e.g. e1→h1), chess.js
// rejects it because it only recognises king-moves-two-squares (e1→g1).
// Remap corner-drop targets so castling works either way.
const $7ead3b1a9a673b0a$var$CASTLING_REMAPS = {
    e1: {
        h1: "g1",
        a1: "c1"
    },
    e8: {
        h8: "g8",
        a8: "c8"
    }
};
function $7ead3b1a9a673b0a$var$normalizeCastlingMove(chess, moveInput) {
    if (typeof moveInput !== "object") return moveInput;
    const piece = chess.get(moveInput.from);
    if (!piece || piece.type !== "k") return moveInput;
    const newTo = $7ead3b1a9a673b0a$var$CASTLING_REMAPS[moveInput.from]?.[moveInput.to];
    return newTo ? {
        ...moveInput,
        to: newTo
    } : moveInput;
}
function $7ead3b1a9a673b0a$var$DataProvider({ children: children  }) {
    const [fen, setFen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState($7ead3b1a9a673b0a$var$START_FEN);
    const [pgnTreeRoot, setPgnTreeRoot] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [currentNode, setCurrentNode] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [repertoires, setRepertoires] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [currentRepertoireId, setCurrentRepertoireId] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [currentMode, setCurrentMode] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("builder");
    const [trainingState, setTrainingState] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({
        isActive: false,
        currentNode: null,
        nextMove: null,
        progress: 0,
        totalNodes: 0,
        visitedNodes: new Set(),
        userColor: "white"
    });
    const [boardOrientation, setBoardOrientation] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("white");
    const toggleBoardOrientation = ()=>{
        const next = boardOrientation === "white" ? "black" : "white";
        setBoardOrientation(next);
        if (trainingState.isActive) startTraining(next);
    };
    const [muted, setMuted] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [volume, setVolume] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0.4);
    const [highlightedSquares, setHighlightedSquares] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({});
    const [customArrows, setCustomArrows] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const hintLevelRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(0);
    const hintTimeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const [playMove] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($82ccdc90324af0e7$exports))), {
        volume: volume,
        soundEnabled: !muted
    });
    const [playCapture] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($b707c1ec3f10a507$exports))), {
        volume: volume,
        soundEnabled: !muted
    });
    const [playKaching] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($c28d5afbd02b6b64$exports))), {
        volume: volume,
        soundEnabled: !muted
    });
    const [playWrong] = (0, $57084659f555c894$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($c9f3d3b79865965e$exports))), {
        volume: volume,
        soundEnabled: !muted
    });
    const setMode = (mode)=>{
        setCurrentMode(mode);
    };
    const apiRequest = async (endpoint, options = {})=>{
        const url = `${$7ead3b1a9a673b0a$var$API_BASE_URL.replace(/\/$/, "")}${endpoint}`;
        const config = {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": $7ead3b1a9a673b0a$var$API_KEY,
                ...options.headers
            },
            ...options
        };
        try {
            const response = await fetch(url, config);
            if (!response.ok) throw new Error(`API request failed: ${response.status} ${response.statusText}`);
            const responseData = await response.json();
            return responseData;
        } catch (error) {
            throw error;
        }
    };
    const loadRepertoiresFromAPI = async ()=>{
        try {
            setIsLoading(true);
            setError(null);
            const pgns = await apiRequest("/pgns");
            const repertoires = pgns.map((pgn, index)=>{
                let tree;
                if (pgn.pgn) try {
                    const pgnData = JSON.parse(pgn.pgn);
                    tree = (0, $6531107febf5e71a$export$1e58ac48354d58f9)(pgnData, $7ead3b1a9a673b0a$var$START_FEN);
                } catch (parseError) {
                    tree = new (0, $6531107febf5e71a$export$efd12fbd35282d77)(null);
                }
                else tree = new (0, $6531107febf5e71a$export$efd12fbd35282d77)(null);
                return {
                    id: pgn.id,
                    name: pgn.openingName,
                    tree: tree,
                    notes: pgn.notes || "",
                    attempts: pgn.attempts || 0,
                    successPercentage: pgn.successPercentage || 0,
                    accuracy: pgn.accuracy || 0,
                    failedRecentFens: pgn.failedRecentFens || []
                };
            });
            setRepertoires(repertoires);
            if (repertoires.length > 0) loadRepertoire(repertoires[0].id, repertoires);
            else initializeDefault();
        } catch (error) {
            setError(error.message);
            initializeDefault();
        } finally{
            setIsLoading(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if ($7ead3b1a9a673b0a$var$API_BASE_URL && $7ead3b1a9a673b0a$var$API_KEY) loadRepertoiresFromAPI();
        else initializeDefault();
    }, []);
    const initializeDefault = ()=>{
        const rootNode = new (0, $6531107febf5e71a$export$efd12fbd35282d77)(null);
        rootNode.fen = $7ead3b1a9a673b0a$var$START_FEN;
        const defaultRepertoire = {
            id: crypto.randomUUID(),
            name: "My First Opening (e4)",
            tree: rootNode,
            notes: "Start building your opening repertoire here!",
            attempts: 0,
            successPercentage: 0,
            accuracy: 0,
            failedRecentFens: []
        };
        const initialData = [
            defaultRepertoire
        ];
        setRepertoires(initialData);
        loadRepertoire(defaultRepertoire.id, initialData);
        setFen($7ead3b1a9a673b0a$var$START_FEN);
    };
    const saveRepertoireToAPI = async (repertoire)=>{
        try {
            const pgnText = (0, $6531107febf5e71a$export$b108b341429564b6)(repertoire.tree);
            const apiData = {
                openingName: repertoire.name,
                pgn: pgnText,
                notes: repertoire.notes || "",
                attempts: repertoire.attempts || 0,
                successPercentage: repertoire.successPercentage || 0,
                accuracy: repertoire.accuracy || 0,
                failedRecentFens: repertoire.failedRecentFens || []
            };
            if (repertoire.id && !repertoire.id.startsWith("temp-")) await apiRequest(`/pgn`, {
                method: "PUT",
                body: JSON.stringify({
                    id: repertoire.id,
                    ...apiData
                })
            });
            else {
                const response = await apiRequest("/pgn", {
                    method: "POST",
                    body: JSON.stringify(apiData)
                });
                repertoire.id = response.pgn_id;
            }
        } catch (error) {
            throw error;
        }
    };
    const loadRepertoire = (id, currentRepertoires = repertoires)=>{
        const repertoire = currentRepertoires.find((r)=>r.id === id);
        if (repertoire) {
            let tree = repertoire.tree;
            if (!tree || !tree.fen) {
                tree = new (0, $6531107febf5e71a$export$efd12fbd35282d77)(null);
                tree.fen = $7ead3b1a9a673b0a$var$START_FEN;
                const updatedRepertoires = currentRepertoires.map((r)=>{
                    if (r.id === id) return {
                        ...r,
                        tree: tree
                    };
                    return r;
                });
                setRepertoires(updatedRepertoires);
            }
            setPgnTreeRoot(tree);
            setCurrentRepertoireId(id);
            updateGameState(tree);
        }
    };
    const createRepertoire = async (name)=>{
        const rootNode = new (0, $6531107febf5e71a$export$efd12fbd35282d77)(null);
        rootNode.fen = $7ead3b1a9a673b0a$var$START_FEN;
        const newRepertoire = {
            id: `temp-${crypto.randomUUID()}`,
            name: name,
            tree: rootNode,
            notes: "",
            attempts: 0,
            successPercentage: 0,
            accuracy: 0,
            failedRecentFens: []
        };
        const updatedRepertoires = [
            ...repertoires,
            newRepertoire
        ];
        setRepertoires(updatedRepertoires);
        loadRepertoire(newRepertoire.id, updatedRepertoires);
        if (!fen || fen !== $7ead3b1a9a673b0a$var$START_FEN) setFen($7ead3b1a9a673b0a$var$START_FEN);
        if ($7ead3b1a9a673b0a$var$API_BASE_URL && $7ead3b1a9a673b0a$var$API_KEY) try {
            await saveRepertoireToAPI(newRepertoire);
            await loadRepertoiresFromAPI();
        } catch (error) {}
    };
    const deleteRepertoire = async (id)=>{
        try {
            if (!id.startsWith("temp-")) await apiRequest(`/pgn?id=${id}`, {
                method: "DELETE"
            });
            const updatedRepertoires = repertoires.filter((r)=>r.id !== id);
            setRepertoires(updatedRepertoires);
            if (currentRepertoireId === id) {
                if (updatedRepertoires.length > 0) loadRepertoire(updatedRepertoires[0].id, updatedRepertoires);
                else initializeDefault();
            }
        } catch (error) {}
    };
    const updateGameState = (node)=>{
        setCurrentNode(node);
        const validFen = node && node.fen ? node.fen : $7ead3b1a9a673b0a$var$START_FEN;
        setFen(validFen);
    };
    const makeMove = (moveInput)=>{
        if (!currentRepertoireId || !currentNode) return null;
        if (!fen) return null;
        const chessCopy = new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)(fen);
        moveInput = $7ead3b1a9a673b0a$var$normalizeCastlingMove(chessCopy, moveInput);
        const moveNumber = chessCopy.moveNumber();
        let move;
        try {
            if (typeof moveInput === "object" && !moveInput.promotion) moveInput.promotion = "q";
            move = chessCopy.move(moveInput);
        } catch (e) {
            return null;
        }
        if (move) {
            const { node: nextNode , isNew: isNew  } = currentNode.addMove(move, moveNumber);
            if (move.flags.includes("c") || move.flags.includes("e")) playCapture();
            else playMove();
            if (isNew) {
                const updatedRepertoires = repertoires.map((r)=>{
                    if (r.id === currentRepertoireId) return {
                        ...r,
                        tree: pgnTreeRoot
                    };
                    return r;
                });
                setRepertoires(updatedRepertoires);
                if ($7ead3b1a9a673b0a$var$API_BASE_URL && $7ead3b1a9a673b0a$var$API_KEY) {
                    const currentRepertoire = updatedRepertoires.find((r)=>r.id === currentRepertoireId);
                    if (currentRepertoire) saveRepertoireToAPI(currentRepertoire).catch((error)=>{});
                }
            }
            updateGameState(nextNode);
            return move;
        }
        return null;
    };
    const navigateBack = ()=>{
        if (currentNode && currentNode.parent) {
            if (currentNode.move) {
                if (currentNode.move.flags.includes("c") || currentNode.move.flags.includes("e")) playCapture();
                else playMove();
            }
            updateGameState(currentNode.parent);
        }
    };
    const navigateForward = (variationIndex = 0)=>{
        if (currentNode && currentNode.children.length > 0) {
            if (variationIndex >= 0 && variationIndex < currentNode.children.length) {
                const nextNode = currentNode.children[variationIndex];
                if (nextNode.move) {
                    if (nextNode.move.flags.includes("c") || nextNode.move.flags.includes("e")) playCapture();
                    else playMove();
                }
                updateGameState(nextNode);
            }
        }
    };
    const navigateToNode = (node)=>{
        if (node) {
            if (node.move) {
                if (node.move.flags.includes("c") || node.move.flags.includes("e")) playCapture();
                else playMove();
            }
            updateGameState(node);
        }
    };
    const findNextUnvisitedNode = (startNode, visitedNodes)=>{
        const stack = [
            ...startNode.children
        ].reverse();
        while(stack.length > 0){
            const node = stack.pop();
            if (!visitedNodes.has(node.fen)) return node;
            const children = [
                ...node.children
            ].reverse();
            for (const child of children)stack.push(child);
        }
        return null;
    };
    const handleLineEnd = (lastNode, visitedNodes)=>{
        let ancestor = lastNode;
        while(ancestor){
            const nextTargetNode = findNextUnvisitedNode(ancestor, visitedNodes);
            if (nextTargetNode) {
                alert("Line complete! Moving to the next variation.");
                updateGameState(ancestor);
                setTimeout(()=>{
                    if (!trainingState.isActive) return;
                    const chessTurn = ancestor.fen.includes(" w ") ? "white" : "black";
                    const trainerPlaysAs = trainingState.userColor === "white" ? "black" : "white";
                    if (chessTurn === trainerPlaysAs) playTrainerMove(ancestor, visitedNodes);
                    else findNextTrainingMove(ancestor, visitedNodes);
                }, 1000);
                return;
            }
            ancestor = ancestor.parent;
        }
        alert("Congratulations! You have completed training for this repertoire!");
        playKaching();
        stopTraining();
    };
    const findNextTrainingMove = (startNode, currentVisitedNodes)=>{
        if (!startNode) return;
        const nextUnvisitedNode = findNextUnvisitedNode(startNode, currentVisitedNodes);
        if (nextUnvisitedNode) setTrainingState((prev)=>({
                ...prev,
                nextMove: nextUnvisitedNode.move,
                currentNode: nextUnvisitedNode.parent
            }));
        else handleLineEnd(startNode, currentVisitedNodes);
    };
    const playTrainerMove = (currentTrainerNode, currentVisitedNodes)=>{
        if (!trainingState.isActive || !currentTrainerNode) return;
        const targetNode = findNextUnvisitedNode(currentTrainerNode, currentVisitedNodes);
        if (targetNode) {
            let nextStepNode = targetNode;
            while(nextStepNode.parent && nextStepNode.parent !== currentTrainerNode)nextStepNode = nextStepNode.parent;
            const chessCopy = new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)(currentTrainerNode.fen);
            try {
                const move = chessCopy.move({
                    from: nextStepNode.move.from,
                    to: nextStepNode.move.to,
                    promotion: nextStepNode.move.promotion || "q"
                });
                if (move) {
                    if (move.flags.includes("c") || move.flags.includes("e")) playCapture();
                    else playMove();
                    const newVisitedNodes = new Set([
                        ...currentVisitedNodes,
                        nextStepNode.fen
                    ]);
                    const newProgress = Math.round(newVisitedNodes.size / trainingState.totalNodes * 100);
                    setTrainingState((prev)=>({
                            ...prev,
                            visitedNodes: newVisitedNodes,
                            progress: newProgress
                        }));
                    updateGameState(nextStepNode);
                    findNextTrainingMove(nextStepNode, newVisitedNodes);
                }
            } catch (e) {
            /* silent fail */ }
        } else handleLineEnd(currentTrainerNode, currentVisitedNodes);
    };
    const makeTrainingMove = (moveInput)=>{
        if (!trainingState.isActive || !trainingState.nextMove) return null;
        if (!fen) return null;
        const expectedMove = trainingState.nextMove;
        const chessCopy = new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)(fen);
        moveInput = $7ead3b1a9a673b0a$var$normalizeCastlingMove(chessCopy, moveInput);
        let move;
        try {
            if (typeof moveInput === "object" && !moveInput.promotion) moveInput.promotion = "q";
            move = chessCopy.move(moveInput);
        } catch (e) {
            return null;
        }
        if (move && move.from === expectedMove.from && move.to === expectedMove.to && (move.promotion || "q") === (expectedMove.promotion || "q")) {
            if (move.flags.includes("c") || move.flags.includes("e")) playCapture();
            else playMove();
            playKaching();
            const nextNode = trainingState.currentNode.children.find((child)=>child.move.san === move.san);
            if (nextNode) {
                const newVisitedNodes = new Set([
                    ...trainingState.visitedNodes,
                    nextNode.fen
                ]);
                const newProgress = Math.round(newVisitedNodes.size / trainingState.totalNodes * 100);
                setTrainingState((prev)=>({
                        ...prev,
                        visitedNodes: newVisitedNodes,
                        progress: newProgress
                    }));
                updateGameState(nextNode);
                clearHint();
                setTimeout(()=>{
                    playTrainerMove(nextNode, newVisitedNodes);
                }, 500);
                return move;
            }
        } else playWrong();
        return null;
    };
    const clearHint = ()=>{
        setHighlightedSquares({});
        setCustomArrows([]);
        hintLevelRef.current = 0;
        if (hintTimeoutRef.current) {
            clearTimeout(hintTimeoutRef.current);
            hintTimeoutRef.current = null;
        }
    };
    const showHint = ()=>{
        if (!trainingState.isActive || !trainingState.nextMove) return;
        const { from: from , to: to  } = trainingState.nextMove;
        if (hintTimeoutRef.current) clearTimeout(hintTimeoutRef.current);
        if (hintLevelRef.current === 0) {
            setHighlightedSquares({
                [from]: {
                    backgroundColor: "rgba(46, 182, 174, 0.55)",
                    borderRadius: "50%",
                    boxShadow: "inset 0 0 0 4px rgba(20, 160, 150, 0.85)"
                }
            });
            hintLevelRef.current = 1;
        } else {
            setCustomArrows([
                [
                    from,
                    to,
                    "rgba(20, 160, 150, 0.8)"
                ]
            ]);
            setHighlightedSquares({
                [from]: {
                    backgroundColor: "rgba(46, 182, 174, 0.45)"
                },
                [to]: {
                    backgroundColor: "rgba(46, 182, 174, 0.45)"
                }
            });
            hintLevelRef.current = 2;
            hintTimeoutRef.current = setTimeout(()=>{
                clearHint();
            }, 5000);
        }
    };
    const startTraining = (orientation = boardOrientation)=>{
        if (!pgnTreeRoot || pgnTreeRoot.children.length === 0) {
            alert("Cannot start training on an empty repertoire.");
            return;
        }
        setCurrentMode("trainer");
        updateGameState(pgnTreeRoot);
        const userPlaysAs = orientation === "white" ? "white" : "black";
        const totalNodes = countNodes(pgnTreeRoot);
        const initialState = {
            isActive: true,
            currentNode: pgnTreeRoot,
            nextMove: null,
            progress: 0,
            totalNodes: totalNodes,
            visitedNodes: new Set([
                pgnTreeRoot.fen
            ]),
            userColor: userPlaysAs
        };
        setTrainingState(initialState);
        clearHint();
    };
    const stopTraining = ()=>{
        setTrainingState({
            isActive: false,
            currentNode: null,
            nextMove: null,
            progress: 0,
            totalNodes: 0,
            visitedNodes: new Set(),
            userColor: "white"
        });
        setCurrentMode("builder");
        updateGameState(pgnTreeRoot);
        clearHint();
    };
    const restartTrainingWithOrientation = (orientation)=>{
        if (trainingState.isActive) {
            setBoardOrientation(orientation);
            startTraining(orientation);
        }
    };
    const countNodes = (node)=>{
        if (!node) return 0;
        let count = 1;
        for (const child of node.children)count += countNodes(child);
        return count;
    };
    const getCurrentPgn = ()=>{
        if (!currentNode) return "";
        const chess = new (0, $e1e1f1f3cd154daa$export$a4d6ea685c300d39)();
        const moves = [];
        let node = currentNode;
        while(node.parent){
            if (node.move) moves.unshift(node.move);
            node = node.parent;
        }
        moves.forEach((move)=>{
            chess.move(move);
        });
        return chess.pgn();
    };
    const updateNodeComment = async (node, comment)=>{
        if (!node || !currentRepertoireId) return;
        node.comment = comment;
        const updatedRepertoires = repertoires.map((r)=>{
            if (r.id === currentRepertoireId) return {
                ...r,
                tree: pgnTreeRoot
            };
            return r;
        });
        setRepertoires(updatedRepertoires);
        if ($7ead3b1a9a673b0a$var$API_BASE_URL && $7ead3b1a9a673b0a$var$API_KEY) {
            const currentRepertoire = updatedRepertoires.find((r)=>r.id === currentRepertoireId);
            if (currentRepertoire) try {
                await saveRepertoireToAPI(currentRepertoire);
            } catch (error) {}
        }
    };
    const deleteMove = async (nodeToDelete)=>{
        if (!nodeToDelete || !currentRepertoireId) return false;
        if (!nodeToDelete.parent) return false;
        const isCurrentNodeOrDescendant = (()=>{
            let current = currentNode;
            while(current){
                if (current === nodeToDelete) return true;
                current = current.parent;
            }
            return false;
        })();
        const deleted = nodeToDelete.deleteNode();
        if (!deleted) return false;
        if (isCurrentNodeOrDescendant) updateGameState(nodeToDelete.parent);
        const updatedRepertoires = repertoires.map((r)=>{
            if (r.id === currentRepertoireId) return {
                ...r,
                tree: pgnTreeRoot
            };
            return r;
        });
        setRepertoires(updatedRepertoires);
        if ($7ead3b1a9a673b0a$var$API_BASE_URL && $7ead3b1a9a673b0a$var$API_KEY) {
            const currentRepertoire = updatedRepertoires.find((r)=>r.id === currentRepertoireId);
            if (currentRepertoire) try {
                await saveRepertoireToAPI(currentRepertoire);
            } catch (error) {
                console.error("Failed to save deleted move to API:", error);
            }
        }
        return true;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (trainingState.isActive && trainingState.currentNode === pgnTreeRoot) {
            const chessTurn = fen.includes(" w ") ? "white" : "black";
            const trainerPlaysAs = trainingState.userColor === "white" ? "black" : "white";
            if (chessTurn === "white" && trainerPlaysAs === "white") setTimeout(()=>{
                if (trainingState.isActive) playTrainerMove(pgnTreeRoot, trainingState.visitedNodes);
            }, 1000);
            else findNextTrainingMove(pgnTreeRoot, trainingState.visitedNodes);
        }
    }, [
        trainingState.isActive,
        trainingState.currentNode,
        pgnTreeRoot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (!fen) setFen($7ead3b1a9a673b0a$var$START_FEN);
    }, [
        fen
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: "Loading Repertoires..."
    });
    if (error) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            "Error loading repertoires: ",
            error
        ]
    });
    if (!pgnTreeRoot) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: "Initializing..."
    });
    if (!fen) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: "Initializing game state..."
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7ead3b1a9a673b0a$export$58d75f9829cbe158.Provider, {
        value: {
            fen: fen,
            currentNode: currentNode,
            makeMove: makeMove,
            navigateBack: navigateBack,
            navigateForward: navigateForward,
            navigateToNode: navigateToNode,
            pgnTreeRoot: pgnTreeRoot,
            getCurrentPgn: getCurrentPgn,
            updateNodeComment: updateNodeComment,
            deleteMove: deleteMove,
            repertoires: repertoires,
            currentRepertoireId: currentRepertoireId,
            loadRepertoire: loadRepertoire,
            createRepertoire: createRepertoire,
            deleteRepertoire: deleteRepertoire,
            isLoading: isLoading,
            error: error,
            currentMode: currentMode,
            setMode: setMode,
            trainingState: trainingState,
            startTraining: startTraining,
            stopTraining: stopTraining,
            restartTrainingWithOrientation: restartTrainingWithOrientation,
            makeTrainingMove: makeTrainingMove,
            playTrainerMove: playTrainerMove,
            boardOrientation: boardOrientation,
            setBoardOrientation: setBoardOrientation,
            toggleBoardOrientation: toggleBoardOrientation,
            muted: muted,
            setMuted: setMuted,
            volume: volume,
            setVolume: setVolume,
            playMove: playMove,
            playCapture: playCapture,
            playKaching: playKaching,
            playWrong: playWrong,
            highlightedSquares: highlightedSquares,
            customArrows: customArrows,
            showHint: showHint
        },
        children: children
    });
}
var $7ead3b1a9a673b0a$export$2e2bcd8739ae039 = $7ead3b1a9a673b0a$var$DataProvider;




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5606419dfe2e9b1b$var$extendStatics = function(d, b) {
    $5606419dfe2e9b1b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5606419dfe2e9b1b$var$extendStatics(d, b);
};
function $5606419dfe2e9b1b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5606419dfe2e9b1b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5606419dfe2e9b1b$export$18ce0697a983be9b = function() {
    $5606419dfe2e9b1b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5606419dfe2e9b1b$export$18ce0697a983be9b.apply(this, arguments);
};
function $5606419dfe2e9b1b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5606419dfe2e9b1b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5606419dfe2e9b1b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5606419dfe2e9b1b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5606419dfe2e9b1b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5606419dfe2e9b1b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5606419dfe2e9b1b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5606419dfe2e9b1b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5606419dfe2e9b1b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5606419dfe2e9b1b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5606419dfe2e9b1b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5606419dfe2e9b1b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5606419dfe2e9b1b$export$45d3717a4c69092e(o, m, p);
}
function $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5606419dfe2e9b1b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5606419dfe2e9b1b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5606419dfe2e9b1b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5606419dfe2e9b1b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5606419dfe2e9b1b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5606419dfe2e9b1b$export$10c90e4f7922046c(v) {
    return this instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? (this.v = v, this) : new $5606419dfe2e9b1b$export$10c90e4f7922046c(v);
}
function $5606419dfe2e9b1b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5606419dfe2e9b1b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5606419dfe2e9b1b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5606419dfe2e9b1b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5606419dfe2e9b1b$export$19a8beecd37a4c45 === "function" ? $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5606419dfe2e9b1b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5606419dfe2e9b1b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5606419dfe2e9b1b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5606419dfe2e9b1b$export$45d3717a4c69092e(result, mod, k);
    }
    $5606419dfe2e9b1b$var$__setModuleDefault(result, mod);
    return result;
}
function $5606419dfe2e9b1b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5606419dfe2e9b1b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5606419dfe2e9b1b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5606419dfe2e9b1b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5606419dfe2e9b1b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5606419dfe2e9b1b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5606419dfe2e9b1b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5606419dfe2e9b1b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5606419dfe2e9b1b$export$2e2bcd8739ae039 = {
    __extends: $5606419dfe2e9b1b$export$a8ba968b8961cb8a,
    __assign: $5606419dfe2e9b1b$export$18ce0697a983be9b,
    __rest: $5606419dfe2e9b1b$export$3c9a16f847548506,
    __decorate: $5606419dfe2e9b1b$export$29e00dfd3077644b,
    __param: $5606419dfe2e9b1b$export$d5ad3fd78186038f,
    __metadata: $5606419dfe2e9b1b$export$f1db080c865becb9,
    __awaiter: $5606419dfe2e9b1b$export$1050f835b63b671e,
    __generator: $5606419dfe2e9b1b$export$67ebef60e6f28a6,
    __createBinding: $5606419dfe2e9b1b$export$45d3717a4c69092e,
    __exportStar: $5606419dfe2e9b1b$export$f33643c0debef087,
    __values: $5606419dfe2e9b1b$export$19a8beecd37a4c45,
    __read: $5606419dfe2e9b1b$export$8d051b38c9118094,
    __spread: $5606419dfe2e9b1b$export$afc72e2116322959,
    __spreadArrays: $5606419dfe2e9b1b$export$6388937ca91ccae8,
    __spreadArray: $5606419dfe2e9b1b$export$1216008129fb82ed,
    __await: $5606419dfe2e9b1b$export$10c90e4f7922046c,
    __asyncGenerator: $5606419dfe2e9b1b$export$e427f37a30a4de9b,
    __asyncDelegator: $5606419dfe2e9b1b$export$bbd80228419bb833,
    __asyncValues: $5606419dfe2e9b1b$export$e3b29a3d6162315f,
    __makeTemplateObject: $5606419dfe2e9b1b$export$4fb47efe1390b86f,
    __importStar: $5606419dfe2e9b1b$export$c21735bcef00d192,
    __importDefault: $5606419dfe2e9b1b$export$da59b14a69baef04,
    __classPrivateFieldGet: $5606419dfe2e9b1b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5606419dfe2e9b1b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5606419dfe2e9b1b$export$81fdc39f203e4e04,
    __addDisposableResource: $5606419dfe2e9b1b$export$88ac25d8e944e405,
    __disposeResources: $5606419dfe2e9b1b$export$8f076105dc360e92
};


function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9145dbf8e0e857b1$export$2e2bcd8739ae039)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $bh6RR = parcelRequire("bh6RR");
var $53a106364dbd0a1b$exports = {};
//
$53a106364dbd0a1b$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$1c5a554c78c0cd12 = "@scope";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $783faa7ec18221fc$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$783faa7ec18221fc$export$4659b591c19bdf3d(e, r);
    });
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$590e8b2c435046d9(e) {
    while(e.root)e = $783faa7ec18221fc$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $783faa7ec18221fc$export$10d8903dec122b9d(e, e.siblings);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(z += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $783faa7ec18221fc$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $783faa7ec18221fc$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(z) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(j = $783faa7ec18221fc$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, j, j, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(z += $783faa7ec18221fc$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) z += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(k = z += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $783faa7ec18221fc$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $783faa7ec18221fc$export$2f35ab04d2335697(e, p + 1, p = $783faa7ec18221fc$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $783faa7ec18221fc$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span", 0) ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch", 0) ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            if (!$783faa7ec18221fc$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


var $e484c752f3f06549$var$f = ("undefined" != typeof $391299e0893a3dfa$exports && void 0 !== $391299e0893a3dfa$exports.env && undefined, "data-styled"), $e484c752f3f06549$var$m = "active", $e484c752f3f06549$var$y = "data-styled-version", $e484c752f3f06549$export$83d89fbfd8236492 = "6.1.19", $e484c752f3f06549$var$g = "/*!sc*/\n", $e484c752f3f06549$var$S = "undefined" != typeof window && "undefined" != typeof document, $e484c752f3f06549$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, "undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, false)), $e484c752f3f06549$var$b = {}, $e484c752f3f06549$var$E = /invalid hook call/i, $e484c752f3f06549$var$N = new Set, $e484c752f3f06549$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e484c752f3f06549$var$_ = Object.freeze([]), $e484c752f3f06549$var$C = Object.freeze({});
function $e484c752f3f06549$var$I(e, t, n) {
    return void 0 === n && (n = $e484c752f3f06549$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e484c752f3f06549$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e484c752f3f06549$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e484c752f3f06549$var$D = /(^-|-$)/g;
function $e484c752f3f06549$var$R(e) {
    return e.replace($e484c752f3f06549$var$O, "-").replace($e484c752f3f06549$var$D, "");
}
var $e484c752f3f06549$var$T = /(a)(d)/gi, $e484c752f3f06549$var$k = 52, $e484c752f3f06549$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e484c752f3f06549$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e484c752f3f06549$var$k; t = t / $e484c752f3f06549$var$k | 0)n = $e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n;
    return ($e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n).replace($e484c752f3f06549$var$T, "$1-$2");
}
var $e484c752f3f06549$var$V, $e484c752f3f06549$var$F = 5381, $e484c752f3f06549$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e484c752f3f06549$var$z = function(e) {
    return $e484c752f3f06549$var$M($e484c752f3f06549$var$F, e);
};
function $e484c752f3f06549$var$$(e) {
    return $e484c752f3f06549$var$x($e484c752f3f06549$var$z(e) >>> 0);
}
function $e484c752f3f06549$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e484c752f3f06549$var$L(e) {
    return "string" == typeof e && true;
}
var $e484c752f3f06549$var$G = "function" == typeof Symbol && Symbol.for, $e484c752f3f06549$var$Y = $e484c752f3f06549$var$G ? Symbol.for("react.memo") : 60115, $e484c752f3f06549$var$W = $e484c752f3f06549$var$G ? Symbol.for("react.forward_ref") : 60112, $e484c752f3f06549$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e484c752f3f06549$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$J = (($e484c752f3f06549$var$V = {})[$e484c752f3f06549$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e484c752f3f06549$var$V[$e484c752f3f06549$var$Y] = $e484c752f3f06549$var$U, $e484c752f3f06549$var$V);
function $e484c752f3f06549$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e484c752f3f06549$var$Y ? $e484c752f3f06549$var$U : "$$typeof" in e ? $e484c752f3f06549$var$J[e.$$typeof] : $e484c752f3f06549$var$q;
}
var $e484c752f3f06549$var$Z = Object.defineProperty, $e484c752f3f06549$var$K = Object.getOwnPropertyNames, $e484c752f3f06549$var$Q = Object.getOwnPropertySymbols, $e484c752f3f06549$var$ee = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$te = Object.getPrototypeOf, $e484c752f3f06549$var$ne = Object.prototype;
function $e484c752f3f06549$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e484c752f3f06549$var$ne) {
            var o = $e484c752f3f06549$var$te(t);
            o && o !== $e484c752f3f06549$var$ne && $e484c752f3f06549$var$oe(e, o, n);
        }
        var r = $e484c752f3f06549$var$K(t);
        $e484c752f3f06549$var$Q && (r = r.concat($e484c752f3f06549$var$Q(t)));
        for(var s = $e484c752f3f06549$var$X(e), i = $e484c752f3f06549$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e484c752f3f06549$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e484c752f3f06549$var$ee(t, c);
                try {
                    $e484c752f3f06549$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e484c752f3f06549$var$re(e) {
    return "function" == typeof e;
}
function $e484c752f3f06549$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e484c752f3f06549$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e484c752f3f06549$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e484c752f3f06549$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e484c752f3f06549$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e484c752f3f06549$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    else if ($e484c752f3f06549$var$ce(t)) for(var o in t)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    return e;
}
function $e484c752f3f06549$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e484c752f3f06549$var$pe = {};
function $e484c752f3f06549$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e484c752f3f06549$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e484c752f3f06549$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e484c752f3f06549$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e484c752f3f06549$var$g);
        return t;
    }, e;
}(), $e484c752f3f06549$var$me = 1073741824, $e484c752f3f06549$var$ye = new Map, $e484c752f3f06549$var$ve = new Map, $e484c752f3f06549$var$ge = 1, $e484c752f3f06549$var$Se = function(e) {
    if ($e484c752f3f06549$var$ye.has(e)) return $e484c752f3f06549$var$ye.get(e);
    for(; $e484c752f3f06549$var$ve.has($e484c752f3f06549$var$ge);)$e484c752f3f06549$var$ge++;
    var t = $e484c752f3f06549$var$ge++;
    return $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e), t;
}, $e484c752f3f06549$var$we = function(e, t) {
    $e484c752f3f06549$var$ge = t + 1, $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e);
}, $e484c752f3f06549$var$be = "style[".concat($e484c752f3f06549$var$f, "][").concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"]'), $e484c752f3f06549$var$Ee = new RegExp("^".concat($e484c752f3f06549$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e484c752f3f06549$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e484c752f3f06549$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e484c752f3f06549$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e484c752f3f06549$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e484c752f3f06549$var$we(u, l), $e484c752f3f06549$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $e484c752f3f06549$var$_e = function(e) {
    for(var t = document.querySelectorAll($e484c752f3f06549$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($e484c752f3f06549$var$f) !== $e484c752f3f06549$var$m && ($e484c752f3f06549$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $e484c752f3f06549$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e484c752f3f06549$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e484c752f3f06549$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e484c752f3f06549$var$f, $e484c752f3f06549$var$m), o.setAttribute($e484c752f3f06549$var$y, $e484c752f3f06549$export$83d89fbfd8236492);
    var i = $e484c752f3f06549$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e484c752f3f06549$var$Ae = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e484c752f3f06549$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e484c752f3f06549$var$Oe = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e484c752f3f06549$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e484c752f3f06549$var$Re = $e484c752f3f06549$var$S, $e484c752f3f06549$var$Te = {
    isServer: !$e484c752f3f06549$var$S,
    useCSSOMInjection: !$e484c752f3f06549$var$w
}, $e484c752f3f06549$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e484c752f3f06549$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, $e484c752f3f06549$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$Re && ($e484c752f3f06549$var$Re = !1, $e484c752f3f06549$var$_e(this)), $e484c752f3f06549$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e484c752f3f06549$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($e484c752f3f06549$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e484c752f3f06549$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e484c752f3f06549$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e484c752f3f06549$var$De(n) : t ? new $e484c752f3f06549$var$Ae(n) : new $e484c752f3f06549$var$Oe(n);
        }(this.options), new $e484c752f3f06549$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e484c752f3f06549$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e484c752f3f06549$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e484c752f3f06549$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e484c752f3f06549$var$je = /&/g, $e484c752f3f06549$var$xe = /^\s*\/\/.*$/gm;
function $e484c752f3f06549$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e484c752f3f06549$var$Ve(e.children, t)), e;
    });
}
function $e484c752f3f06549$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $e484c752f3f06549$var$C : e, s = r.options, i = void 0 === s ? $e484c752f3f06549$var$C : s, a = r.plugins, c = void 0 === a ? $e484c752f3f06549$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $783faa7ec18221fc$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e484c752f3f06549$var$je, n).replace(o, l));
    }), i.prefix && u.push($783faa7ec18221fc$export$e08c7d021b829b7a), u.push($783faa7ec18221fc$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e484c752f3f06549$var$xe, ""), l = $783faa7ec18221fc$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e484c752f3f06549$var$Ve(l, i.namespace));
        var p = [];
        return $783faa7ec18221fc$export$dfdc1655ccc5b9cb(l, $783faa7ec18221fc$export$5a7767152ae0305f(u.concat($783faa7ec18221fc$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e484c752f3f06549$var$he(15), $e484c752f3f06549$var$M(e, t.name);
    }, $e484c752f3f06549$var$F).toString() : "", p;
}
var $e484c752f3f06549$var$Me = new $e484c752f3f06549$var$ke, $e484c752f3f06549$var$ze = $e484c752f3f06549$var$Fe(), $e484c752f3f06549$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e484c752f3f06549$var$Me,
    stylis: $e484c752f3f06549$var$ze
}), $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer, $e484c752f3f06549$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $e484c752f3f06549$var$Ge() {
    return (0, $bh6RR.useContext)($e484c752f3f06549$export$8c190ef828af4c86);
}
function $e484c752f3f06549$export$a473771da2f0ff7c(e) {
    var t = (0, $bh6RR.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e484c752f3f06549$var$Ge().styleSheet, l = (0, $bh6RR.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $bh6RR.useMemo)(function() {
        return $e484c752f3f06549$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $bh6RR.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($53a106364dbd0a1b$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $bh6RR.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$var$Le.Provider, {
        value: u
    }, e.children));
}
var $e484c752f3f06549$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e484c752f3f06549$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e484c752f3f06549$var$ue(this, function() {
            throw $e484c752f3f06549$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e484c752f3f06549$var$ze), this.name + e.hash;
    }, e;
}(), $e484c752f3f06549$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $e484c752f3f06549$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e484c752f3f06549$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e484c752f3f06549$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $e484c752f3f06549$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e484c752f3f06549$var$Ue(i) && (Array.isArray(i) && i.isCss || $e484c752f3f06549$var$re(i) ? r.push("".concat($e484c752f3f06549$var$He(s), ":"), i, ";") : $e484c752f3f06549$var$ce(i) ? r.push.apply(r, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)((0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e484c752f3f06549$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e484c752f3f06549$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $78b52bced097bc64$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e484c752f3f06549$var$Xe(e, t, n, o) {
    if ($e484c752f3f06549$var$Ue(e)) return [];
    if ($e484c752f3f06549$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e484c752f3f06549$var$re(e)) {
        if (!$e484c752f3f06549$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e484c752f3f06549$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $e484c752f3f06549$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e484c752f3f06549$var$ce(e) ? $e484c752f3f06549$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($e484c752f3f06549$var$_, e.map(function(e) {
        return $e484c752f3f06549$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e484c752f3f06549$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e484c752f3f06549$var$re(n) && !$e484c752f3f06549$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e484c752f3f06549$var$Ke = $e484c752f3f06549$var$z($e484c752f3f06549$export$83d89fbfd8236492), $e484c752f3f06549$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e484c752f3f06549$var$Ze(e), this.componentId = t, this.baseHash = $e484c752f3f06549$var$M($e484c752f3f06549$var$Ke, t), this.baseStyle = n, $e484c752f3f06549$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e484c752f3f06549$var$ie(o, this.staticRulesId);
            else {
                var r = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, e, t, n)), s = $e484c752f3f06549$var$x($e484c752f3f06549$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e484c752f3f06549$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e484c752f3f06549$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(u, e, t, n));
                    a = $e484c752f3f06549$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e484c752f3f06549$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e484c752f3f06549$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e484c752f3f06549$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0), $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
function $e484c752f3f06549$export$93d4e7f90805808f() {
    var e = (0, $bh6RR.useContext)($e484c752f3f06549$export$2c657da244d00bd6);
    if (!e) throw $e484c752f3f06549$var$he(18);
    return e;
}
function $e484c752f3f06549$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, $bh6RR.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e484c752f3f06549$var$he(14);
            if ($e484c752f3f06549$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e484c752f3f06549$var$he(8);
            return n ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e484c752f3f06549$var$rt = {}, $e484c752f3f06549$var$st = new Set;
function $e484c752f3f06549$var$it(e, r, s) {
    var i = $e484c752f3f06549$export$7ba318d8d2f06c76(e), a = e, c = !$e484c752f3f06549$var$L(e), p = r.attrs, d = void 0 === p ? $e484c752f3f06549$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e484c752f3f06549$var$R(e);
        $e484c752f3f06549$var$rt[n] = ($e484c752f3f06549$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e484c752f3f06549$var$$($e484c752f3f06549$export$83d89fbfd8236492 + n + $e484c752f3f06549$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e484c752f3f06549$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e484c752f3f06549$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e484c752f3f06549$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e484c752f3f06549$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), m = $e484c752f3f06549$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e484c752f3f06549$var$I(r, f, c) || $e484c752f3f06549$var$C, g = function(e, n, o) {
                for(var r, s = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e484c752f3f06549$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e484c752f3f06549$var$ie(s[c], a[c]) : "style" === c ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e484c752f3f06549$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e484c752f3f06549$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e484c752f3f06549$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e484c752f3f06549$var$L(S) && !$e484c752f3f06549$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $bh6RR.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e484c752f3f06549$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e484c752f3f06549$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e484c752f3f06549$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e484c752f3f06549$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e484c752f3f06549$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e484c752f3f06549$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e484c752f3f06549$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e484c752f3f06549$var$re(t) || $e484c752f3f06549$var$ce(t)) return $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at($e484c752f3f06549$var$_, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e484c752f3f06549$var$Xe(r) : $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at(r, n)));
}
function $e484c752f3f06549$var$ut(n, o, r) {
    if (void 0 === r && (r = $e484c752f3f06549$var$C), !o) throw $e484c752f3f06549$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e484c752f3f06549$var$pt = function(e) {
    return $e484c752f3f06549$var$ut($e484c752f3f06549$var$it, e);
}, $e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$pt;
$e484c752f3f06549$var$A.forEach(function(e) {
    $e484c752f3f06549$export$2e2bcd8739ae039[e] = $e484c752f3f06549$var$pt(e);
});
var $e484c752f3f06549$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e484c752f3f06549$var$Ze(e), $e484c752f3f06549$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e484c752f3f06549$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e484c752f3f06549$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e484c752f3f06549$var$$(JSON.stringify(i))), c = new $e484c752f3f06549$var$ht(i, a);
    var l = function(e) {
        var t = $e484c752f3f06549$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e484c752f3f06549$var$b, o, s);
        else {
            var i = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                theme: $e484c752f3f06549$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(l);
}
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e484c752f3f06549$var$ae($e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e484c752f3f06549$var$$(r);
    return new $e484c752f3f06549$var$We(s, r);
}
function $e484c752f3f06549$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(n, r) {
        var s = $e484c752f3f06549$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(e, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e484c752f3f06549$var$B(e), ")"), $e484c752f3f06549$var$oe(n, e);
}
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e484c752f3f06549$var$Ce(), o = $e484c752f3f06549$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e484c752f3f06549$var$f, '="true"'),
                "".concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$e484c752f3f06549$var$f] = "", n[$e484c752f3f06549$var$y] = $e484c752f3f06549$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $e484c752f3f06549$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e484c752f3f06549$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e484c752f3f06549$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e484c752f3f06549$var$he(3);
    }, e;
}(), $e484c752f3f06549$export$5c87cfe6c475f500 = {
    StyleSheet: $e484c752f3f06549$var$ke,
    mainSheet: $e484c752f3f06549$var$Me
};
var $e484c752f3f06549$var$St = "__sc-".concat($e484c752f3f06549$var$f, "__");


const $ddb89bb066eb98c1$var$SettingsIcon = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M9.46 1.81L14.54 1.81L13.89 4.43L17.61 6.58L19.55 4.71L22.09 9.11L19.5 9.85L19.5 14.15L22.09 14.89L19.55 19.29L17.61 17.42L13.89 19.57L14.54 22.19L9.46 22.19L10.11 19.57L6.39 17.42L4.45 19.29L1.91 14.89L4.5 14.15L4.5 9.85L1.91 9.11L4.45 4.71L6.39 6.58L10.11 4.43Z",
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3",
                stroke: "currentColor",
                strokeWidth: "1.5",
                fill: "none"
            })
        ]
    });
function $ddb89bb066eb98c1$var$NavBar() {
    const { currentMode: currentMode , setMode: setMode , muted: muted , setMuted: setMuted , volume: volume , setVolume: setVolume  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [settingsOpen, setSettingsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const settingsRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const handleClickOutside = (e)=>{
            if (settingsRef.current && !settingsRef.current.contains(e.target)) setSettingsOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const handleTabClick = (mode)=>{
        setMode(mode);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($ddb89bb066eb98c1$var$Nav, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                className: currentMode === "builder" ? "active" : "",
                onClick: ()=>handleTabClick("builder"),
                children: "Builder"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                className: currentMode === "trainer" ? "active" : "",
                onClick: ()=>handleTabClick("trainer"),
                children: "Trainer"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$NavItem, {
                className: currentMode === "openingTree" ? "active" : "",
                onClick: ()=>handleTabClick("openingTree"),
                children: "Tree"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$Divider, {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($ddb89bb066eb98c1$var$SettingsWrapper, {
                ref: settingsRef,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$SettingsButton, {
                        onClick: ()=>setSettingsOpen(!settingsOpen),
                        className: settingsOpen ? "open" : "",
                        "aria-label": "Settings",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$SettingsIcon, {})
                    }),
                    settingsOpen && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$SettingsDropdown, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($ddb89bb066eb98c1$var$DropdownRow, {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$SoundToggle, {
                                    onClick: ()=>setMuted(!muted),
                                    children: muted ? "Muted" : "Sound"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ddb89bb066eb98c1$var$VolumeSlider, {
                                    type: "range",
                                    min: "0",
                                    max: "1",
                                    step: "0.05",
                                    value: volume,
                                    onChange: (e)=>setVolume(parseFloat(e.target.value)),
                                    disabled: muted
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($ddb89bb066eb98c1$var$VolumeLabel, {
                                    children: [
                                        Math.round(volume * 100),
                                        "%"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $ddb89bb066eb98c1$export$2e2bcd8739ae039 = $ddb89bb066eb98c1$var$NavBar;
const $ddb89bb066eb98c1$var$Nav = (0, $e484c752f3f06549$export$2e2bcd8739ae039).nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 7px;
  border-radius: 999px;
  background: rgba(255, 249, 241, 0.92);
  border: 1px solid var(--border);
  overflow: visible;
`;
const $ddb89bb066eb98c1$var$NavItem = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 12px 21px;
  cursor: pointer;
  color: var(--text-soft);
  font-size: 1.23rem;
  border-radius: 999px;
  border: 1px solid transparent;
  background: none;
  transition:
    color 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(159, 109, 76, 0.1);
    color: var(--text);
    transform: translateY(-1px);
  }

  &.active {
    color: var(--accent-strong);
    font-weight: 600;
    background: rgba(159, 109, 76, 0.12);
    border-color: rgba(159, 109, 76, 0.18);
  }
`;
const $ddb89bb066eb98c1$var$Divider = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  width: 1px;
  height: 30px;
  background: var(--border);
  margin: 0 3px;
  flex-shrink: 0;
`;
const $ddb89bb066eb98c1$var$SettingsWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
`;
const $ddb89bb066eb98c1$var$SettingsButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 999px;
  border: 1px solid transparent;
  cursor: pointer;
  color: var(--text-soft);
  background: none;
  transition:
    color 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease;

  &:hover,
  &.open {
    background: rgba(159, 109, 76, 0.1);
    color: var(--text);
    border-color: rgba(159, 109, 76, 0.12);
  }
`;
const $ddb89bb066eb98c1$var$SettingsDropdown = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-md);
  padding: 14px 16px;
  z-index: 100;
  min-width: 240px;
`;
const $ddb89bb066eb98c1$var$DropdownRow = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $ddb89bb066eb98c1$var$SoundToggle = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 6px 12px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  color: var(--accent-strong);
  background: var(--accent-ghost);
  border: 1px solid rgba(159, 109, 76, 0.22);
  border-radius: 999px;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(159, 109, 76, 0.18);
  }
`;
const $ddb89bb066eb98c1$var$VolumeSlider = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input`
  flex: 1;
  height: 4px;
  -webkit-appearance: none;
  background: var(--accent-soft);
  outline: none;
  transition: opacity 0.2s;
  border-radius: 999px;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 14px;
    height: 14px;
    background: var(--accent);
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(95, 67, 46, 0.28);
  }

  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    background: var(--accent);
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(95, 67, 46, 0.28);
    border: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const $ddb89bb066eb98c1$var$VolumeLabel = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-size: 0.72rem;
  color: var(--text-soft);
  min-width: 30px;
  text-align: right;
  font-variant-numeric: tabular-nums;
`;





function $02ce57c81a0104d3$var$Header() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$StyledHeader, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Logo, {
                children: "PsychoChess Trainer"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$SubheaderGrid, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$DictEntry, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$DictLine, {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Headword, {
                                        children: "шахматы"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Pronunciation, {
                                        children: "/shakh\xb7ma\xb7ty/"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$DictLine, {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$PartOfSpeech, {
                                        children: "n."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$Definition, {
                                        children: [
                                            'lit. "kill',
                                            "‑",
                                            'king"'
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Gloss, {
                                        children: "\uD83D\uDD2A♔"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$DictLine, {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Definition, {
                                    indent: true,
                                    children: "you best not miss"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$DictLine, {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Usage, {
                                        children: "see also:"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Definition, {
                                        children: "checkmate"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$EmojiRow, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$EmojiPill, {
                                children: "\uD83E\uDD34"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$EmojiPill, {
                                children: "\uD83D\uDC80"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$Blurb, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$CompactLine, {
                                children: "Pinpoint your opponent's most losing response to your repertoire."
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$BlurbSpacer, {}),
                            "And crush them."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$NavPill, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddb89bb066eb98c1$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $02ce57c81a0104d3$export$2e2bcd8739ae039 = $02ce57c81a0104d3$var$Header;
const $02ce57c81a0104d3$var$StyledHeader = (0, $e484c752f3f06549$export$2e2bcd8739ae039).header`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 2px 24px;
  padding: 16px 22px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  backdrop-filter: blur(18px);
  flex-shrink: 0;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
    padding: 14px 16px;
  }
`;
const $02ce57c81a0104d3$var$Logo = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h1`
  grid-column: 1 / -1;
  font-size: 70px;
  font-weight: 600;
  margin: 0;
  color: var(--text);
  letter-spacing: -0.01em;
  line-height: 1.15;
`;
const $02ce57c81a0104d3$var$NavPill = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  grid-column: 2;
  grid-row: 2;
  align-self: center;

  @media (max-width: 980px) {
    grid-column: 1;
    grid-row: 3;
  }
`;
const $02ce57c81a0104d3$var$DictEntry = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 6px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-faint);
  border: 1.5px dashed rgba(139, 90, 43, 0.35);
  border-radius: 8px;
  width: fit-content;
`;
const $02ce57c81a0104d3$var$DictLine = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 0.35em;
`;
const $02ce57c81a0104d3$var$Headword = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-weight: 700;
  font-style: italic;
  color: var(--text-soft);
  letter-spacing: 0.02em;
`;
const $02ce57c81a0104d3$var$Pronunciation = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-style: italic;
  opacity: 0.55;
  letter-spacing: 0.01em;
`;
const $02ce57c81a0104d3$var$PartOfSpeech = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-style: italic;
  font-weight: 600;
  opacity: 0.45;
`;
const $02ce57c81a0104d3$var$Definition = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  color: var(--text-soft);
  ${(p)=>p.indent && "padding-left: 1em;"}
`;
const $02ce57c81a0104d3$var$Usage = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-style: italic;
  opacity: 0.6;
`;
const $02ce57c81a0104d3$var$Gloss = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-style: normal;
`;
const $02ce57c81a0104d3$var$SubheaderGrid = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 8px 16px;
  margin-top: 6px;
  align-items: start;
`;
const $02ce57c81a0104d3$var$Blurb = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  grid-column: 2;
  grid-row: 1 / 3;
  padding: 14px 18px;
  font-size: 26px;
  line-height: 1.5;
  color: var(--text-soft);
  border: 1.5px dashed rgba(139, 90, 43, 0.35);
  border-radius: 8px;
  max-width: 500px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const $02ce57c81a0104d3$var$BlurbSpacer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  height: 0.5em;
`;
const $02ce57c81a0104d3$var$CompactLine = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  line-height: 1.15;
`;
const $02ce57c81a0104d3$var$EmojiRow = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
`;
const $02ce57c81a0104d3$var$EmojiPill = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  font-size: 38px;
  line-height: 1;
  padding: 4px 10px;
  border: 1px dashed rgba(139, 90, 43, 0.35);
  border-radius: 999px;
`;




parcelRequire("bh6RR");

parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $700bf53ed0e34a6e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
const $700bf53ed0e34a6e$var$COLUMNS = "abcdefgh".split("");
const $700bf53ed0e34a6e$var$START_POSITION_OBJECT = {
    a8: "bR",
    b8: "bN",
    c8: "bB",
    d8: "bQ",
    e8: "bK",
    f8: "bB",
    g8: "bN",
    h8: "bR",
    a7: "bP",
    b7: "bP",
    c7: "bP",
    d7: "bP",
    e7: "bP",
    f7: "bP",
    g7: "bP",
    h7: "bP",
    a2: "wP",
    b2: "wP",
    c2: "wP",
    d2: "wP",
    e2: "wP",
    f2: "wP",
    g2: "wP",
    h2: "wP",
    a1: "wR",
    b1: "wN",
    c1: "wB",
    d1: "wQ",
    e1: "wK",
    f1: "wB",
    g1: "wN",
    h1: "wR"
};
const $700bf53ed0e34a6e$var$WHITE_COLUMN_VALUES = {
    a: 0,
    b: 1,
    c: 2,
    d: 3,
    e: 4,
    f: 5,
    g: 6,
    h: 7
};
const $700bf53ed0e34a6e$var$BLACK_COLUMN_VALUES = {
    a: 7,
    b: 6,
    c: 5,
    d: 4,
    e: 3,
    f: 2,
    g: 1,
    h: 0
};
const $700bf53ed0e34a6e$var$WHITE_ROWS = [
    7,
    6,
    5,
    4,
    3,
    2,
    1,
    0
];
const $700bf53ed0e34a6e$var$BLACK_ROWS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7
];
// https://commons.wikimedia.org/wiki/Category:SVG_chess_pieces
// By en:User:Cburnett - Own work
// This W3C - unspecified vector image was created with Inkscape., CC BY - SA 3.0, https://commons.wikimedia.org/w/index.php?curid=1499810
const $700bf53ed0e34a6e$var$defaultPieces = {
    wP: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z",
            style: {
                opacity: "1",
                fill: "#ffffff",
                fillOpacity: "1",
                fillRule: "nonzero",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "miter",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        })
    })),
    wR: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "#ffffff",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 34,14 L 31,17 L 14,17 L 11,14"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 31,17 L 31,29.5 L 14,29.5 L 14,17",
                    style: {
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 34,14",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    wN: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
                    transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                })
            ]
        }))
    })),
    wB: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillRule: "evenodd",
                fillOpacity: "1",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }, {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
                        })
                    ]
                })),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    wQ: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "#ffffff",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 11,36 11,36 C 9.5,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11.5,30 C 15,29 30,29 33.5,30",
                    style: {
                        fill: "none"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,33.5 C 18,32.5 27,32.5 33,33.5",
                    style: {
                        fill: "none"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "6",
                    cy: "12",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "14",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "22.5",
                    cy: "8",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "31",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "39",
                    cy: "12",
                    r: "2"
                })
            ]
        }))
    })),
    wK: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,11.63 L 22.5,6",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 20,8 L 25,8",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,30 C 18,27 27,27 32.5,30",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,34 27,34 32.5,37",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                })
            ]
        }))
    })),
    bP: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z",
            style: {
                opacity: "1",
                fill: "#000000",
                fillOpacity: "1",
                fillRule: "nonzero",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "miter",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        })
    })),
    bR: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "#000000",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z ",
                    style: {
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12,35.5 L 33,35.5 L 33,35.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 13,31.5 L 32,31.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,29.5 L 31,29.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 14,16.5 L 31,16.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,14 L 34,14",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    bN: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
                    style: {
                        fill: "#ffffff",
                        stroke: "#ffffff"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
                    transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
                    style: {
                        fill: "#ffffff",
                        stroke: "#ffffff"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 24.55,10.4 L 24.1,11.85 L 24.6,12 C 27.75,13 30.25,14.49 32.5,18.75 C 34.75,23.01 35.75,29.06 35.25,39 L 35.2,39.5 L 37.45,39.5 L 37.5,39 C 38,28.94 36.62,22.15 34.25,17.66 C 31.88,13.17 28.46,11.02 25.06,10.5 L 24.55,10.4 z ",
                    style: {
                        fill: "#ffffff",
                        stroke: "none"
                    }
                })
            ]
        }))
    })),
    bB: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillRule: "evenodd",
                fillOpacity: "1",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "#000000",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }, {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
                        })
                    ]
                })),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    bQ: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "#000000",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z",
                    style: {
                        strokeLinecap: "butt",
                        fill: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "m 9,26 c 0,2 1.5,2 2.5,4 1,1.5 1,1 0.5,3.5 -1.5,1 -1,2.5 -1,2.5 -1.5,1.5 0,2.5 0,2.5 6.5,1 16.5,1 23,0 0,0 1.5,-1 0,-2.5 0,0 0.5,-1.5 -1,-2.5 -0.5,-2.5 -0.5,-2 0.5,-3.5 1,-2 2.5,-2 2.5,-4 -8.5,-1.5 -18.5,-1.5 -27,0 z"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11.5,30 C 15,29 30,29 33.5,30"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "m 12,33.5 c 6,-1 15,-1 21,0"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "6",
                    cy: "12",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "14",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "22.5",
                    cy: "8",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "31",
                    cy: "9",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "39",
                    cy: "12",
                    r: "2"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 11,38.5 A 35,35 1 0 0 34,38.5",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                }, {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 11,29 A 35,35 1 0 1 34,29"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 12.5,31.5 L 32.5,31.5"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 11.5,34.5 A 35,35 1 0 0 33.5,34.5"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: "M 10.5,37.5 A 35,35 1 0 0 34.5,37.5"
                        })
                    ]
                }))
            ]
        }))
    })),
    bK: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", Object.assign({
            style: {
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,11.63 L 22.5,6",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    },
                    id: "path6570"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
                    style: {
                        fill: "#000000",
                        fillOpacity: "1",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 20,8 L 25,8",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 32,29.5 C 32,29.5 40.5,25.5 38.03,19.85 C 34.15,14 25,18 22.5,24.5 L 22.5,26.6 L 22.5,24.5 C 20,18 10.85,14 6.97,19.85 C 4.5,25.5 13,29.5 13,29.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M 12.5,30 C 18,27 27,27 32.5,30 M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5 M 12.5,37 C 18,34 27,34 32.5,37",
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                })
            ]
        }))
    }))
};
/**
 * Retrieves the coordinates at the centre of the requested square, relative to the top left of the board (0, 0).
 */ function $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, square) {
    const squareWidth = boardWidth / 8;
    const columns = boardOrientation === "white" ? $700bf53ed0e34a6e$var$WHITE_COLUMN_VALUES : $700bf53ed0e34a6e$var$BLACK_COLUMN_VALUES;
    const rows = boardOrientation === "white" ? $700bf53ed0e34a6e$var$WHITE_ROWS : $700bf53ed0e34a6e$var$BLACK_ROWS;
    const x = columns[square[0]] * squareWidth + squareWidth / 2;
    const y = rows[parseInt(square[1], 10) - 1] * squareWidth + squareWidth / 2;
    return {
        x: x,
        y: y
    };
}
/**
 * Returns whether the passed position is different from the start position.
 */ function $700bf53ed0e34a6e$var$isDifferentFromStart(newPosition) {
    let isDifferent = false;
    Object.keys($700bf53ed0e34a6e$var$START_POSITION_OBJECT).forEach((square)=>{
        if (newPosition[square] !== $700bf53ed0e34a6e$var$START_POSITION_OBJECT[square]) isDifferent = true;
    });
    Object.keys(newPosition).forEach((square)=>{
        if ($700bf53ed0e34a6e$var$START_POSITION_OBJECT[square] !== newPosition[square]) isDifferent = true;
    });
    return isDifferent;
}
/**
 * Returns what pieces have been added and what pieces have been removed between board positions.
 */ function $700bf53ed0e34a6e$var$getPositionDifferences(currentPosition, newPosition) {
    const difference = {
        removed: {},
        added: {}
    };
    // removed from current
    Object.keys(currentPosition).forEach((square)=>{
        if (newPosition[square] !== currentPosition[square]) difference.removed[square] = currentPosition[square];
    });
    // added from new
    Object.keys(newPosition).forEach((square)=>{
        if (currentPosition[square] !== newPosition[square]) difference.added[square] = newPosition[square];
    });
    return difference;
}
/**
 * Converts a fen string or existing position object to a position object.
 */ function $700bf53ed0e34a6e$var$convertPositionToObject(position) {
    if (position === "start") return $700bf53ed0e34a6e$var$START_POSITION_OBJECT;
    if (typeof position === "string") // attempt to convert fen to position object
    return $700bf53ed0e34a6e$var$fenToObj(position);
    return position;
}
/**
 * Converts a fen string to a position object.
 */ function $700bf53ed0e34a6e$var$fenToObj(fen) {
    if (!$700bf53ed0e34a6e$var$isValidFen(fen)) return {};
    // cut off any move, castling, etc info from the end. we're only interested in position information
    fen = fen.replace(/ .+$/, "");
    const rows = fen.split("/");
    const position = {};
    let currentRow = 8;
    for(let i = 0; i < 8; i++){
        const row = rows[i].split("");
        let colIdx = 0;
        // loop through each character in the FEN section
        for(let j = 0; j < row.length; j++)// number / empty squares
        if (row[j].search(/[1-8]/) !== -1) {
            const numEmptySquares = parseInt(row[j], 10);
            colIdx = colIdx + numEmptySquares;
        } else {
            // piece
            const square = $700bf53ed0e34a6e$var$COLUMNS[colIdx] + currentRow;
            position[square] = $700bf53ed0e34a6e$var$fenToPieceCode(row[j]);
            colIdx = colIdx + 1;
        }
        currentRow = currentRow - 1;
    }
    return position;
}
/**
 * Returns whether string is valid fen notation.
 */ function $700bf53ed0e34a6e$var$isValidFen(fen) {
    // cut off any move, castling, etc info from the end. we're only interested in position information
    fen = fen.replace(/ .+$/, "");
    // expand the empty square numbers to just 1s
    fen = $700bf53ed0e34a6e$var$expandFenEmptySquares(fen);
    // fen should be 8 sections separated by slashes
    const chunks = fen.split("/");
    if (chunks.length !== 8) return false;
    // check each section
    for(let i = 0; i < 8; i++){
        if (chunks[i].length !== 8 || chunks[i].search(/[^kqrnbpKQRNBP1]/) !== -1) return false;
    }
    return true;
}
/**
 * Expand out fen notation to countable characters for validation
 */ function $700bf53ed0e34a6e$var$expandFenEmptySquares(fen) {
    return fen.replace(/8/g, "11111111").replace(/7/g, "1111111").replace(/6/g, "111111").replace(/5/g, "11111").replace(/4/g, "1111").replace(/3/g, "111").replace(/2/g, "11");
}
/**
 * Convert fen piece code to camel case notation. e.g. bP, wK.
 */ function $700bf53ed0e34a6e$var$fenToPieceCode(piece) {
    // black piece
    if (piece.toLowerCase() === piece) return "b" + piece.toUpperCase();
    // white piece
    return "w" + piece.toUpperCase();
}
const $700bf53ed0e34a6e$var$useArrows = (customArrows, areArrowsAllowed = true, onArrowsChange, customArrowColor)=>{
    // arrows passed programatically to `ChessBoard` as a react prop
    const [customArrowsSet, setCustomArrows] = (0, $bh6RR.useState)([]);
    // arrows drawn with mouse by user on the board
    const [arrows, setArrows] = (0, $bh6RR.useState)([]);
    // active arrow which user draws while dragging mouse
    const [newArrow, setNewArrow] = (0, $bh6RR.useState)();
    // handle external `customArrows` props changes
    (0, $bh6RR.useEffect)(()=>{
        if (Array.isArray(customArrows)) {
            // so that custom arrows overwrite temporary arrows
            clearArrows();
            setCustomArrows(//filter out arrows which starts and ends in the same square
            customArrows === null || customArrows === void 0 ? void 0 : customArrows.filter((arrow)=>arrow[0] !== arrow[1]));
        }
    }, [
        customArrows
    ]);
    // callback when arrows changed after user interaction
    (0, $bh6RR.useEffect)(()=>{
        onArrowsChange === null || onArrowsChange === void 0 || onArrowsChange(arrows);
    }, [
        arrows
    ]);
    // function clears all arrows drawed by user
    function clearArrows() {
        setArrows([]);
        setNewArrow(undefined);
    }
    const drawNewArrow = (fromSquare, toSquare)=>{
        if (!areArrowsAllowed) return;
        setNewArrow([
            fromSquare,
            toSquare,
            customArrowColor
        ]);
    };
    const allBoardArrows = [
        ...arrows,
        ...customArrowsSet
    ];
    const onArrowDrawEnd = (fromSquare, toSquare)=>{
        if (fromSquare === toSquare || !areArrowsAllowed) return;
        let arrowsCopy;
        const newArrow = [
            fromSquare,
            toSquare,
            customArrowColor
        ];
        const isNewArrowUnique = allBoardArrows.every(([arrowFrom, arrowTo])=>{
            return !(arrowFrom === fromSquare && arrowTo === toSquare);
        });
        // add the newArrow to arrows array if it is unique
        if (isNewArrowUnique) arrowsCopy = [
            ...arrows,
            newArrow
        ];
        else arrowsCopy = arrows.filter(([arrowFrom, arrowTo])=>{
            return !(arrowFrom === fromSquare && arrowTo === toSquare);
        });
        setNewArrow(undefined);
        setArrows(arrowsCopy);
    };
    return {
        arrows: allBoardArrows,
        newArrow: newArrow,
        clearArrows: clearArrows,
        drawNewArrow: drawNewArrow,
        setArrows: setArrows,
        onArrowDrawEnd: onArrowDrawEnd
    };
};
const $700bf53ed0e34a6e$var$ChessboardContext = (0, $bh6RR.createContext)({});
const $700bf53ed0e34a6e$var$useChessboard = ()=>(0, $bh6RR.useContext)($700bf53ed0e34a6e$var$ChessboardContext);
const $700bf53ed0e34a6e$var$ChessboardProvider = (0, $bh6RR.forwardRef)(({ allowDragOutsideBoard: allowDragOutsideBoard = true , animationDuration: animationDuration = 300 , areArrowsAllowed: areArrowsAllowed = true , arePiecesDraggable: arePiecesDraggable = true , arePremovesAllowed: arePremovesAllowed = false , autoPromoteToQueen: autoPromoteToQueen = false , boardOrientation: boardOrientation = "white" , boardWidth: boardWidth , children: children , clearPremovesOnRightClick: clearPremovesOnRightClick = true , customArrows: customArrows , customArrowColor: customArrowColor = "rgb(255,170,0)" , customBoardStyle: customBoardStyle , customNotationStyle: customNotationStyle , customDarkSquareStyle: customDarkSquareStyle = {
    backgroundColor: "#B58863"
} , customDropSquareStyle: customDropSquareStyle = {
    boxShadow: "inset 0 0 1px 6px rgba(255,255,255,0.75)"
} , customLightSquareStyle: customLightSquareStyle = {
    backgroundColor: "#F0D9B5"
} , customPieces: customPieces , customPremoveDarkSquareStyle: customPremoveDarkSquareStyle = {
    backgroundColor: "#A42323"
} , customPremoveLightSquareStyle: customPremoveLightSquareStyle = {
    backgroundColor: "#BD2828"
} , customSquare: customSquare = "div" , customSquareStyles: customSquareStyles , dropOffBoardAction: dropOffBoardAction = "snapback" , id: id = 0 , isDraggablePiece: isDraggablePiece = ()=>true , getPositionObject: getPositionObject = ()=>{} , onArrowsChange: onArrowsChange = ()=>{} , onDragOverSquare: onDragOverSquare = ()=>{} , onMouseOutSquare: onMouseOutSquare = ()=>{} , onMouseOverSquare: onMouseOverSquare = ()=>{} , onPieceClick: onPieceClick = ()=>{} , onPieceDragBegin: onPieceDragBegin = ()=>{} , onPieceDragEnd: onPieceDragEnd = ()=>{} , onPieceDrop: onPieceDrop = ()=>true , onPieceDropOffBoard: onPieceDropOffBoard = ()=>{} , onPromotionCheck: onPromotionCheck = (sourceSquare, targetSquare, piece)=>{
    return (piece === "wP" && sourceSquare[1] === "7" && targetSquare[1] === "8" || piece === "bP" && sourceSquare[1] === "2" && targetSquare[1] === "1") && Math.abs(sourceSquare.charCodeAt(0) - targetSquare.charCodeAt(0)) <= 1;
} , onPromotionPieceSelect: onPromotionPieceSelect = ()=>true , onSparePieceDrop: onSparePieceDrop = ()=>true , onSquareClick: onSquareClick = ()=>{} , onSquareRightClick: onSquareRightClick = ()=>{} , position: position = "start" , promotionDialogVariant: promotionDialogVariant = "default" , promotionToSquare: promotionToSquare = null , showBoardNotation: showBoardNotation = true , showPromotionDialog: showPromotionDialog = false , snapToCursor: snapToCursor = true  }, ref)=>{
    // position stored and displayed on board
    const [currentPosition, setCurrentPosition] = (0, $bh6RR.useState)($700bf53ed0e34a6e$var$convertPositionToObject(position));
    // calculated differences between current and incoming positions
    const [positionDifferences, setPositionDifferences] = (0, $bh6RR.useState)({
        removed: {},
        added: {}
    });
    // colour of last piece moved to determine if premoving
    const [lastPieceColour, setLastPieceColour] = (0, $bh6RR.useState)(undefined);
    // show / hide promotion dialog
    const [showPromoteDialog, setShowPromoteDialog] = (0, $bh6RR.useState)(showPromotionDialog && !autoPromoteToQueen);
    // which square a pawn is being promoted to
    const [promoteFromSquare, setPromoteFromSquare] = (0, $bh6RR.useState)(null);
    const [promoteToSquare, setPromoteToSquare] = (0, $bh6RR.useState)(promotionToSquare);
    // current premoves
    const [premoves, setPremoves] = (0, $bh6RR.useState)([]);
    // ref used to access current value during timeouts (closures)
    const premovesRef = (0, $bh6RR.useRef)(premoves);
    // current right mouse down square
    const [currentRightClickDown, setCurrentRightClickDown] = (0, $bh6RR.useState)();
    // chess pieces/styling
    const [chessPieces, setChessPieces] = (0, $bh6RR.useState)(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$defaultPieces), customPieces));
    // whether the last move was a manual drop or not
    const [wasManualDrop, setWasManualDrop] = (0, $bh6RR.useState)(false);
    // the most recent timeout whilst waiting for animation to complete
    const previousTimeoutRef = (0, $bh6RR.useRef)();
    // if currently waiting for an animation to finish
    const [isWaitingForAnimation, setIsWaitingForAnimation] = (0, $bh6RR.useState)(false);
    // last square dragged over for checking in touch events
    const [lastSquareDraggedOver, setLastSquareDraggedOver] = (0, $bh6RR.useState)(null);
    // open clearPremoves() to allow user to call on undo/reset/whenever
    (0, $bh6RR.useImperativeHandle)(ref, ()=>({
            clearPremoves (clearLastPieceColour = true) {
                clearPremoves(clearLastPieceColour);
            }
        }));
    // handle custom pieces change
    (0, $bh6RR.useEffect)(()=>{
        setChessPieces(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$defaultPieces), customPieces));
    }, [
        customPieces
    ]);
    // handle promote changes
    (0, $bh6RR.useEffect)(()=>{
        setShowPromoteDialog(showPromotionDialog);
        setPromoteToSquare(promotionToSquare);
    }, [
        promotionToSquare,
        showPromotionDialog
    ]);
    // handle external position change
    (0, $bh6RR.useEffect)(()=>{
        var _a, _b, _c;
        // clear any open promotion dialogs
        clearPromotion();
        const newPosition = $700bf53ed0e34a6e$var$convertPositionToObject(position);
        const differences = $700bf53ed0e34a6e$var$getPositionDifferences(currentPosition, newPosition);
        const newPieceColour = ((_a = Object.keys(differences.added)) === null || _a === void 0 ? void 0 : _a.length) <= 2 ? (_c = (_b = Object.entries(differences.added)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c[1][0] : undefined;
        // external move has come in before animation is over
        // cancel animation and immediately update position
        if (isWaitingForAnimation) {
            setCurrentPosition(newPosition);
            setIsWaitingForAnimation(false);
            arePremovesAllowed && attemptPremove(newPieceColour);
            if (previousTimeoutRef.current) clearTimeout(previousTimeoutRef.current);
        } else // move was made using drag and drop
        if (wasManualDrop) {
            setCurrentPosition(newPosition);
            setIsWaitingForAnimation(false);
            arePremovesAllowed && attemptPremove(newPieceColour);
        } else {
            // move was made by external position change
            // if position === start then don't override newPieceColour
            // needs isDifferentFromStart in scenario where premoves have been cleared upon board reset but first move is made by computer, the last move colour would need to be updated
            if ($700bf53ed0e34a6e$var$isDifferentFromStart(newPosition) && lastPieceColour !== undefined) setLastPieceColour(newPieceColour);
            else if (!$700bf53ed0e34a6e$var$isDifferentFromStart(newPosition)) // position === start, likely a board reset. set to black to allow black to make premoves on first move
            setLastPieceColour("b");
            else setLastPieceColour(undefined);
            setPositionDifferences(differences);
            // animate external move
            setIsWaitingForAnimation(true);
            const newTimeout = setTimeout(()=>{
                setCurrentPosition(newPosition);
                setIsWaitingForAnimation(false);
                arePremovesAllowed && attemptPremove(newPieceColour);
            }, animationDuration);
            previousTimeoutRef.current = newTimeout;
        }
        // reset manual drop, ready for next move to be made by user or external
        setWasManualDrop(false);
        // inform latest position information
        getPositionObject(newPosition);
        // clear arrows
        clearArrows();
        // clear timeout on unmount
        return ()=>{
            clearTimeout(previousTimeoutRef.current);
        };
    }, [
        position
    ]);
    const { arrows: arrows , newArrow: newArrow , clearArrows: clearArrows , drawNewArrow: drawNewArrow , onArrowDrawEnd: onArrowDrawEnd  } = $700bf53ed0e34a6e$var$useArrows(customArrows, areArrowsAllowed, onArrowsChange, customArrowColor);
    // handle drop position change
    function handleSetPosition(sourceSq, targetSq, piece, wasManualDropOverride) {
        // if dropped back down, don't do anything
        if (sourceSq === targetSq) return;
        clearArrows();
        // if second move is made for same colour, or there are still premoves queued, then this move needs to be added to premove queue instead of played
        // premoves length check for colour is added in because white could make 3 premoves, and then black responds to the first move (changing the last piece colour) and then white pre-moves again
        if (arePremovesAllowed && isWaitingForAnimation || arePremovesAllowed && (lastPieceColour === piece[0] || premovesRef.current.filter((p)=>p.piece[0] === piece[0]).length > 0)) {
            const oldPremoves = [
                ...premovesRef.current
            ];
            oldPremoves.push({
                sourceSq: sourceSq,
                targetSq: targetSq,
                piece: piece
            });
            premovesRef.current = oldPremoves;
            setPremoves([
                ...oldPremoves
            ]);
            clearPromotion();
            return;
        }
        // if transitioning, don't allow new drop
        if (!arePremovesAllowed && isWaitingForAnimation) return;
        const newOnDropPosition = Object.assign({}, currentPosition);
        setWasManualDrop(!!wasManualDropOverride);
        setLastPieceColour(piece[0]);
        // if onPieceDrop function provided, execute it, position must be updated externally and captured by useEffect above for this move to show on board
        if (onPieceDrop.length) {
            const isValidMove = onPieceDrop(sourceSq, targetSq, piece);
            if (!isValidMove) {
                clearPremoves();
                setWasManualDrop(false);
            }
        } else {
            // delete source piece
            delete newOnDropPosition[sourceSq];
            // add piece in new position
            newOnDropPosition[targetSq] = piece;
            setCurrentPosition(newOnDropPosition);
        }
        clearPromotion();
        // inform latest position information
        getPositionObject(newOnDropPosition);
    }
    function deletePieceFromSquare(square) {
        const positionCopy = Object.assign({}, currentPosition);
        delete positionCopy[square];
        setCurrentPosition(positionCopy);
        // inform latest position information
        getPositionObject(positionCopy);
    }
    function attemptPremove(newPieceColour) {
        if (premovesRef.current.length === 0) return;
        // get current value of premove as this is called in a timeout so value may have changed since timeout was set
        const premove = premovesRef.current[0];
        // if premove is a differing colour to last move made, then this move can be made
        if (premove.piece[0] !== undefined && premove.piece[0] !== newPieceColour && onPieceDrop.length) {
            setLastPieceColour(premove.piece[0]);
            setWasManualDrop(true); // pre-move doesn't need animation
            const isValidMove = onPieceDrop(premove.sourceSq, premove.targetSq, premove.piece);
            // premove was successful and can be removed from queue
            if (isValidMove) {
                const oldPremoves = [
                    ...premovesRef.current
                ];
                oldPremoves.shift();
                premovesRef.current = oldPremoves;
                setPremoves([
                    ...oldPremoves
                ]);
            } else // premove wasn't successful, clear premove queue
            clearPremoves();
        }
    }
    function handleSparePieceDrop(piece, targetSq) {
        const isValidDrop = onSparePieceDrop(piece, targetSq);
        if (!isValidDrop) return;
        const newOnDropPosition = Object.assign({}, currentPosition);
        // add piece in new position
        newOnDropPosition[targetSq] = piece;
        setCurrentPosition(newOnDropPosition);
        // inform latest position information
        getPositionObject(newOnDropPosition);
    }
    function clearPremoves(clearLastPieceColour = true) {
        // don't clear when right clicking to clear, otherwise you won't be able to premove again before next go
        if (clearLastPieceColour) setLastPieceColour(undefined);
        premovesRef.current = [];
        setPremoves([]);
    }
    function clearPromotion() {
        setPromoteFromSquare(null);
        setPromoteToSquare(null);
        setShowPromoteDialog(false);
    }
    function onRightClickDown(square) {
        setCurrentRightClickDown(square);
    }
    function onRightClickUp(square) {
        if (currentRightClickDown) // same square, don't draw an arrow, but do clear premoves and run onSquareRightClick
        {
            if (currentRightClickDown === square) {
                setCurrentRightClickDown(undefined);
                clearPremovesOnRightClick && clearPremoves(false);
                onSquareRightClick(square);
                return;
            }
        } else setCurrentRightClickDown(undefined);
    }
    function clearCurrentRightClickDown() {
        setCurrentRightClickDown(undefined);
    }
    const ChessboardProviderContextValue = {
        allowDragOutsideBoard: allowDragOutsideBoard,
        animationDuration: animationDuration,
        arePiecesDraggable: arePiecesDraggable,
        arePremovesAllowed: arePremovesAllowed,
        arrows: arrows,
        autoPromoteToQueen: autoPromoteToQueen,
        boardOrientation: boardOrientation,
        boardWidth: boardWidth,
        chessPieces: chessPieces,
        clearArrows: clearArrows,
        clearCurrentRightClickDown: clearCurrentRightClickDown,
        currentPosition: currentPosition,
        currentRightClickDown: currentRightClickDown,
        customArrowColor: customArrowColor,
        customBoardStyle: customBoardStyle,
        customDarkSquareStyle: customDarkSquareStyle,
        customDropSquareStyle: customDropSquareStyle,
        customLightSquareStyle: customLightSquareStyle,
        customNotationStyle: customNotationStyle,
        customPremoveDarkSquareStyle: customPremoveDarkSquareStyle,
        customPremoveLightSquareStyle: customPremoveLightSquareStyle,
        customSquare: customSquare,
        customSquareStyles: customSquareStyles,
        deletePieceFromSquare: deletePieceFromSquare,
        drawNewArrow: drawNewArrow,
        dropOffBoardAction: dropOffBoardAction,
        handleSetPosition: handleSetPosition,
        handleSparePieceDrop: handleSparePieceDrop,
        id: id,
        isDraggablePiece: isDraggablePiece,
        isWaitingForAnimation: isWaitingForAnimation,
        lastPieceColour: lastPieceColour,
        lastSquareDraggedOver: lastSquareDraggedOver,
        newArrow: newArrow,
        onArrowDrawEnd: onArrowDrawEnd,
        onDragOverSquare: onDragOverSquare,
        onMouseOutSquare: onMouseOutSquare,
        onMouseOverSquare: onMouseOverSquare,
        onPieceClick: onPieceClick,
        onPieceDragBegin: onPieceDragBegin,
        onPieceDragEnd: onPieceDragEnd,
        onPieceDrop: onPieceDrop,
        onPieceDropOffBoard: onPieceDropOffBoard,
        onPromotionCheck: onPromotionCheck,
        onPromotionPieceSelect: onPromotionPieceSelect,
        onRightClickDown: onRightClickDown,
        onRightClickUp: onRightClickUp,
        onSparePieceDrop: onSparePieceDrop,
        onSquareClick: onSquareClick,
        positionDifferences: positionDifferences,
        premoves: premoves,
        promoteFromSquare: promoteFromSquare,
        promoteToSquare: promoteToSquare,
        promotionDialogVariant: promotionDialogVariant,
        setLastSquareDraggedOver: setLastSquareDraggedOver,
        setPromoteFromSquare: setPromoteFromSquare,
        setPromoteToSquare: setPromoteToSquare,
        setShowPromoteDialog: setShowPromoteDialog,
        showBoardNotation: showBoardNotation,
        showPromoteDialog: showPromoteDialog,
        snapToCursor: snapToCursor
    };
    return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ChessboardContext.Provider, Object.assign({
        value: ChessboardProviderContextValue
    }, {
        children: children
    }));
});
function $700bf53ed0e34a6e$var$Notation({ row: row , col: col  }) {
    const { boardOrientation: boardOrientation , boardWidth: boardWidth , customDarkSquareStyle: customDarkSquareStyle , customLightSquareStyle: customLightSquareStyle , customNotationStyle: customNotationStyle  } = $700bf53ed0e34a6e$var$useChessboard();
    const whiteColor = customLightSquareStyle.backgroundColor;
    const blackColor = customDarkSquareStyle.backgroundColor;
    const isRow = col === 0;
    const isColumn = row === 7;
    const isBottomLeftSquare = isRow && isColumn;
    function getRow() {
        return boardOrientation === "white" ? 8 - row : row + 1;
    }
    function getColumn() {
        return boardOrientation === "black" ? $700bf53ed0e34a6e$var$COLUMNS[7 - col] : $700bf53ed0e34a6e$var$COLUMNS[col];
    }
    function renderBottomLeft() {
        return (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                    style: Object.assign(Object.assign({
                        zIndex: 3,
                        position: "absolute"
                    }, {
                        color: whiteColor
                    }), $700bf53ed0e34a6e$var$numericStyle(boardWidth, customNotationStyle))
                }, {
                    children: getRow()
                })),
                (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                    style: Object.assign(Object.assign({
                        zIndex: 3,
                        position: "absolute"
                    }, {
                        color: whiteColor
                    }), $700bf53ed0e34a6e$var$alphaStyle(boardWidth, customNotationStyle))
                }, {
                    children: getColumn()
                }))
            ]
        });
    }
    function renderLetters() {
        return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: Object.assign(Object.assign({
                userSelect: "none",
                zIndex: 3,
                position: "absolute"
            }, {
                color: col % 2 !== 0 ? blackColor : whiteColor
            }), $700bf53ed0e34a6e$var$alphaStyle(boardWidth, customNotationStyle))
        }, {
            children: getColumn()
        }));
    }
    function renderNumbers() {
        return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: Object.assign(Object.assign({
                userSelect: "none",
                zIndex: 3,
                position: "absolute"
            }, boardOrientation === "black" ? {
                color: row % 2 === 0 ? blackColor : whiteColor
            } : {
                color: row % 2 === 0 ? blackColor : whiteColor
            }), $700bf53ed0e34a6e$var$numericStyle(boardWidth, customNotationStyle))
        }, {
            children: getRow()
        }));
    }
    if (isBottomLeftSquare) return renderBottomLeft();
    if (isColumn) return renderLetters();
    if (isRow) return renderNumbers();
    return null;
}
const $700bf53ed0e34a6e$var$alphaStyle = (width, customNotationStyle)=>Object.assign({
        alignSelf: "flex-end",
        paddingLeft: width / 8 - width / 48,
        fontSize: width / 48
    }, customNotationStyle);
const $700bf53ed0e34a6e$var$numericStyle = (width, customNotationStyle)=>Object.assign({
        alignSelf: "flex-start",
        paddingRight: width / 8 - width / 48,
        fontSize: width / 48
    }, customNotationStyle);
/**
 * Create the React Context
 */ const $700bf53ed0e34a6e$var$DndContext = (0, $bh6RR.createContext)({
    dragDropManager: undefined
});
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $700bf53ed0e34a6e$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $700bf53ed0e34a6e$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $700bf53ed0e34a6e$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $700bf53ed0e34a6e$var$ActionTypes = {
    INIT: "@@redux/INIT" + $700bf53ed0e34a6e$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $700bf53ed0e34a6e$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $700bf53ed0e34a6e$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $700bf53ed0e34a6e$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $700bf53ed0e34a6e$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($700bf53ed0e34a6e$var$isDate(val)) return "date";
    if ($700bf53ed0e34a6e$var$isError(val)) return "error";
    var constructorName = $700bf53ed0e34a6e$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $700bf53ed0e34a6e$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $700bf53ed0e34a6e$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $700bf53ed0e34a6e$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $700bf53ed0e34a6e$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $700bf53ed0e34a6e$var$createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(1));
        return enhancer($700bf53ed0e34a6e$var$createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$700bf53ed0e34a6e$var$isPlainObject(action)) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $700bf53ed0e34a6e$var$ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($700bf53ed0e34a6e$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$700bf53ed0e34a6e$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $700bf53ed0e34a6e$var$ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$700bf53ed0e34a6e$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $700bf53ed0e34a6e$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $700bf53ed0e34a6e$var$isCrushed() {}
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $700bf53ed0e34a6e$var$invariant(condition, format, ...args) {
    if ($700bf53ed0e34a6e$var$isProduction()) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $700bf53ed0e34a6e$var$isProduction() {
    return typeof $391299e0893a3dfa$exports !== "undefined" && true;
}
// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $700bf53ed0e34a6e$var$get(obj, path, defaultValue) {
    return path.split(".").reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
/**
 * drop-in replacement for _.without
 */ function $700bf53ed0e34a6e$var$without$1(items, item) {
    return items.filter((i)=>i !== item);
}
/**
 * drop-in replacement for _.isString
 * @param input
 */ function $700bf53ed0e34a6e$var$isObject(input) {
    return typeof input === "object";
}
/**
 * replacement for _.xor
 * @param itemsA
 * @param itemsB
 */ function $700bf53ed0e34a6e$var$xor(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */ function $700bf53ed0e34a6e$var$intersection(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}
const $700bf53ed0e34a6e$var$INIT_COORDS = "dnd-core/INIT_COORDS";
const $700bf53ed0e34a6e$var$BEGIN_DRAG = "dnd-core/BEGIN_DRAG";
const $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE";
const $700bf53ed0e34a6e$var$HOVER = "dnd-core/HOVER";
const $700bf53ed0e34a6e$var$DROP = "dnd-core/DROP";
const $700bf53ed0e34a6e$var$END_DRAG = "dnd-core/END_DRAG";
function $700bf53ed0e34a6e$var$setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: $700bf53ed0e34a6e$var$INIT_COORDS,
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}
const $700bf53ed0e34a6e$var$ResetCoordinatesAction = {
    type: $700bf53ed0e34a6e$var$INIT_COORDS,
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $700bf53ed0e34a6e$var$createBeginDrag(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true , clientOffset: clientOffset , getSourceClientOffset: getSourceClientOffset  } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch($700bf53ed0e34a6e$var$setClientOffset(clientOffset));
        $700bf53ed0e34a6e$var$verifyInvariants$1(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $700bf53ed0e34a6e$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($700bf53ed0e34a6e$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $700bf53ed0e34a6e$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch($700bf53ed0e34a6e$var$setClientOffset(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $700bf53ed0e34a6e$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: $700bf53ed0e34a6e$var$BEGIN_DRAG,
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $700bf53ed0e34a6e$var$verifyInvariants$1(sourceIds, monitor, registry) {
    $700bf53ed0e34a6e$var$invariant(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        $700bf53ed0e34a6e$var$invariant(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $700bf53ed0e34a6e$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    $700bf53ed0e34a6e$var$invariant(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $700bf53ed0e34a6e$var$verifyItemIsObject(item) {
    $700bf53ed0e34a6e$var$invariant($700bf53ed0e34a6e$var$isObject(item), "Item must be an object.");
}
function $700bf53ed0e34a6e$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}
function $700bf53ed0e34a6e$var$_defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function $700bf53ed0e34a6e$var$createDrop(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $700bf53ed0e34a6e$var$verifyInvariants(monitor);
        const targetIds = $700bf53ed0e34a6e$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $700bf53ed0e34a6e$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: $700bf53ed0e34a6e$var$DROP,
                payload: {
                    dropResult: $700bf53ed0e34a6e$var$_objectSpread$4({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $700bf53ed0e34a6e$var$verifyInvariants(monitor) {
    $700bf53ed0e34a6e$var$invariant(monitor.isDragging(), "Cannot call drop while not dragging.");
    $700bf53ed0e34a6e$var$invariant(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $700bf53ed0e34a6e$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $700bf53ed0e34a6e$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $700bf53ed0e34a6e$var$verifyDropResultType(dropResult) {
    $700bf53ed0e34a6e$var$invariant(typeof dropResult === "undefined" || $700bf53ed0e34a6e$var$isObject(dropResult), "Drop result must either be an object or undefined.");
}
function $700bf53ed0e34a6e$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}
function $700bf53ed0e34a6e$var$createEndDrag(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $700bf53ed0e34a6e$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: $700bf53ed0e34a6e$var$END_DRAG
        };
    };
}
function $700bf53ed0e34a6e$var$verifyIsDragging(monitor) {
    $700bf53ed0e34a6e$var$invariant(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}
function $700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}
function $700bf53ed0e34a6e$var$createHover(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset  } = {}) {
        $700bf53ed0e34a6e$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        $700bf53ed0e34a6e$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $700bf53ed0e34a6e$var$checkInvariants(targetIds, monitor, registry);
        $700bf53ed0e34a6e$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: $700bf53ed0e34a6e$var$HOVER,
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $700bf53ed0e34a6e$var$verifyTargetIdsIsArray(targetIdsArg) {
    $700bf53ed0e34a6e$var$invariant(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $700bf53ed0e34a6e$var$checkInvariants(targetIds, monitor, registry) {
    $700bf53ed0e34a6e$var$invariant(monitor.isDragging(), "Cannot call hover while not dragging.");
    $700bf53ed0e34a6e$var$invariant(!monitor.didDrop(), "Cannot call hover after drop.");
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        $700bf53ed0e34a6e$var$invariant(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        const target = registry.getTarget(targetId);
        $700bf53ed0e34a6e$var$invariant(target, "Expected targetIds to be registered.");
    }
}
function $700bf53ed0e34a6e$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!$700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $700bf53ed0e34a6e$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}
function $700bf53ed0e34a6e$var$createPublishDragSource(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE
        };
        return;
    };
}
function $700bf53ed0e34a6e$var$createDragDropActions(manager) {
    return {
        beginDrag: $700bf53ed0e34a6e$var$createBeginDrag(manager),
        publishDragSource: $700bf53ed0e34a6e$var$createPublishDragSource(manager),
        hover: $700bf53ed0e34a6e$var$createHover(manager),
        drop: $700bf53ed0e34a6e$var$createDrop(manager),
        endDrag: $700bf53ed0e34a6e$var$createEndDrag(manager)
    };
}
class $700bf53ed0e34a6e$var$DragDropManagerImpl {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch  } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== "undefined") dispatch(action);
            };
        }
        const actions = $700bf53ed0e34a6e$var$createDragDropActions(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $700bf53ed0e34a6e$var$add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $700bf53ed0e34a6e$var$subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */ function $700bf53ed0e34a6e$var$getSourceClientOffset(state) {
    const { clientOffset: clientOffset , initialClientOffset: initialClientOffset , initialSourceClientOffset: initialSourceClientOffset  } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $700bf53ed0e34a6e$var$subtract($700bf53ed0e34a6e$var$add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */ function $700bf53ed0e34a6e$var$getDifferenceFromInitialOffset(state) {
    const { clientOffset: clientOffset , initialClientOffset: initialClientOffset  } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $700bf53ed0e34a6e$var$subtract(clientOffset, initialClientOffset);
}
const $700bf53ed0e34a6e$var$NONE = [];
const $700bf53ed0e34a6e$var$ALL = [];
$700bf53ed0e34a6e$var$NONE.__IS_NONE__ = true;
$700bf53ed0e34a6e$var$ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */ function $700bf53ed0e34a6e$var$areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === $700bf53ed0e34a6e$var$NONE) return false;
    if (dirtyIds === $700bf53ed0e34a6e$var$ALL || typeof handlerIds === "undefined") return true;
    const commonIds = $700bf53ed0e34a6e$var$intersection(handlerIds, dirtyIds);
    return commonIds.length > 0;
}
class $700bf53ed0e34a6e$var$DragDropMonitorImpl {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds  } = options;
        $700bf53ed0e34a6e$var$invariant(typeof listener === "function", "listener must be a function.");
        $700bf53ed0e34a6e$var$invariant(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !$700bf53ed0e34a6e$var$areDirty(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        $700bf53ed0e34a6e$var$invariant(typeof listener === "function", "listener must be a function.");
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        $700bf53ed0e34a6e$var$invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        $700bf53ed0e34a6e$var$invariant(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return $700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        $700bf53ed0e34a6e$var$invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow  } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !$700bf53ed0e34a6e$var$matchesType(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return $700bf53ed0e34a6e$var$getSourceClientOffset(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return $700bf53ed0e34a6e$var$getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $700bf53ed0e34a6e$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $700bf53ed0e34a6e$var$BrowserMutationObserver = $700bf53ed0e34a6e$var$scope.MutationObserver || $700bf53ed0e34a6e$var$scope.WebKitMutationObserver;
function $700bf53ed0e34a6e$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function $700bf53ed0e34a6e$var$makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new $700bf53ed0e34a6e$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $700bf53ed0e34a6e$var$makeRequestCall = typeof $700bf53ed0e34a6e$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$700bf53ed0e34a6e$var$makeRequestCallFromMutationObserver : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$700bf53ed0e34a6e$var$makeRequestCallFromTimer;
class $700bf53ed0e34a6e$var$AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q , requestFlush: requestFlush  } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q  } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = $700bf53ed0e34a6e$var$makeRequestCall(this.flush);
        this.requestErrorThrow = $700bf53ed0e34a6e$var$makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// // its existence.
// rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
// `call`, just like a function.
class $700bf53ed0e34a6e$var$RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}
class $700bf53ed0e34a6e$var$TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new $700bf53ed0e34a6e$var$RawTask(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}
const $700bf53ed0e34a6e$var$asapQueue = new $700bf53ed0e34a6e$var$AsapQueue();
const $700bf53ed0e34a6e$var$taskFactory = new $700bf53ed0e34a6e$var$TaskFactory($700bf53ed0e34a6e$var$asapQueue.registerPendingError);
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ function $700bf53ed0e34a6e$var$asap(task) {
    $700bf53ed0e34a6e$var$asapQueue.enqueueTask($700bf53ed0e34a6e$var$taskFactory.create(task));
}
const $700bf53ed0e34a6e$var$ADD_SOURCE = "dnd-core/ADD_SOURCE";
const $700bf53ed0e34a6e$var$ADD_TARGET = "dnd-core/ADD_TARGET";
const $700bf53ed0e34a6e$var$REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE";
const $700bf53ed0e34a6e$var$REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function $700bf53ed0e34a6e$var$addSource(sourceId) {
    return {
        type: $700bf53ed0e34a6e$var$ADD_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function $700bf53ed0e34a6e$var$addTarget(targetId) {
    return {
        type: $700bf53ed0e34a6e$var$ADD_TARGET,
        payload: {
            targetId: targetId
        }
    };
}
function $700bf53ed0e34a6e$var$removeSource(sourceId) {
    return {
        type: $700bf53ed0e34a6e$var$REMOVE_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function $700bf53ed0e34a6e$var$removeTarget(targetId) {
    return {
        type: $700bf53ed0e34a6e$var$REMOVE_TARGET,
        payload: {
            targetId: targetId
        }
    };
}
function $700bf53ed0e34a6e$var$validateSourceContract(source) {
    $700bf53ed0e34a6e$var$invariant(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $700bf53ed0e34a6e$var$validateTargetContract(target) {
    $700bf53ed0e34a6e$var$invariant(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof target.hover === "function", "Expected hover to be a function.");
    $700bf53ed0e34a6e$var$invariant(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $700bf53ed0e34a6e$var$validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$700bf53ed0e34a6e$var$validateType(t, false));
        return;
    }
    $700bf53ed0e34a6e$var$invariant(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var $700bf53ed0e34a6e$var$HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($700bf53ed0e34a6e$var$HandlerRole || ($700bf53ed0e34a6e$var$HandlerRole = {}));
let $700bf53ed0e34a6e$var$nextUniqueId = 0;
function $700bf53ed0e34a6e$var$getNextUniqueId() {
    return $700bf53ed0e34a6e$var$nextUniqueId++;
}
function $700bf53ed0e34a6e$var$getNextHandlerId(role) {
    const id = $700bf53ed0e34a6e$var$getNextUniqueId().toString();
    switch(role){
        case $700bf53ed0e34a6e$var$HandlerRole.SOURCE:
            return `S${id}`;
        case $700bf53ed0e34a6e$var$HandlerRole.TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $700bf53ed0e34a6e$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return $700bf53ed0e34a6e$var$HandlerRole.SOURCE;
        case "T":
            return $700bf53ed0e34a6e$var$HandlerRole.TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $700bf53ed0e34a6e$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done , value: [, value]  } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $700bf53ed0e34a6e$var$HandlerRegistryImpl {
    addSource(type, source) {
        $700bf53ed0e34a6e$var$validateType(type);
        $700bf53ed0e34a6e$var$validateSourceContract(source);
        const sourceId = this.addHandler($700bf53ed0e34a6e$var$HandlerRole.SOURCE, type, source);
        this.store.dispatch($700bf53ed0e34a6e$var$addSource(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        $700bf53ed0e34a6e$var$validateType(type, true);
        $700bf53ed0e34a6e$var$validateTargetContract(target);
        const targetId = this.addHandler($700bf53ed0e34a6e$var$HandlerRole.TARGET, type, target);
        this.store.dispatch($700bf53ed0e34a6e$var$addTarget(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $700bf53ed0e34a6e$var$mapContainsValue(this.dragSources, handler) || $700bf53ed0e34a6e$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        $700bf53ed0e34a6e$var$invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        $700bf53ed0e34a6e$var$invariant(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        $700bf53ed0e34a6e$var$invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        $700bf53ed0e34a6e$var$invariant(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $700bf53ed0e34a6e$var$parseRoleFromHandlerId(handlerId);
        return role === $700bf53ed0e34a6e$var$HandlerRole.SOURCE;
    }
    isTargetId(handlerId) {
        const role = $700bf53ed0e34a6e$var$parseRoleFromHandlerId(handlerId);
        return role === $700bf53ed0e34a6e$var$HandlerRole.TARGET;
    }
    removeSource(sourceId) {
        $700bf53ed0e34a6e$var$invariant(this.getSource(sourceId), "Expected an existing source.");
        this.store.dispatch($700bf53ed0e34a6e$var$removeSource(sourceId));
        $700bf53ed0e34a6e$var$asap(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        $700bf53ed0e34a6e$var$invariant(this.getTarget(targetId), "Expected an existing target.");
        this.store.dispatch($700bf53ed0e34a6e$var$removeTarget(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        $700bf53ed0e34a6e$var$invariant(source, "Expected an existing source.");
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        $700bf53ed0e34a6e$var$invariant(this.pinnedSource, "No source is pinned at the time.");
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $700bf53ed0e34a6e$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === $700bf53ed0e34a6e$var$HandlerRole.SOURCE) this.dragSources.set(id, handler);
        else if (role === $700bf53ed0e34a6e$var$HandlerRole.TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}
const $700bf53ed0e34a6e$var$strictEquality = (a, b)=>a === b;
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */ function $700bf53ed0e34a6e$var$areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */ function $700bf53ed0e34a6e$var$areArraysEqual(a, b, isEqual = $700bf53ed0e34a6e$var$strictEquality) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}
function $700bf53ed0e34a6e$var$reduce$5(_state = $700bf53ed0e34a6e$var$NONE, action) {
    switch(action.type){
        case $700bf53ed0e34a6e$var$HOVER:
            break;
        case $700bf53ed0e34a6e$var$ADD_SOURCE:
        case $700bf53ed0e34a6e$var$ADD_TARGET:
        case $700bf53ed0e34a6e$var$REMOVE_TARGET:
        case $700bf53ed0e34a6e$var$REMOVE_SOURCE:
            return $700bf53ed0e34a6e$var$NONE;
        case $700bf53ed0e34a6e$var$BEGIN_DRAG:
        case $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE:
        case $700bf53ed0e34a6e$var$END_DRAG:
        case $700bf53ed0e34a6e$var$DROP:
        default:
            return $700bf53ed0e34a6e$var$ALL;
    }
    const { targetIds: targetIds = [] , prevTargetIds: prevTargetIds = []  } = action.payload;
    const result = $700bf53ed0e34a6e$var$xor(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !$700bf53ed0e34a6e$var$areArraysEqual(targetIds, prevTargetIds);
    if (!didChange) return $700bf53ed0e34a6e$var$NONE;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}
function $700bf53ed0e34a6e$var$_defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
const $700bf53ed0e34a6e$var$initialState$1 = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $700bf53ed0e34a6e$var$reduce$4(state = $700bf53ed0e34a6e$var$initialState$1, action) {
    const { payload: payload  } = action;
    switch(action.type){
        case $700bf53ed0e34a6e$var$INIT_COORDS:
        case $700bf53ed0e34a6e$var$BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case $700bf53ed0e34a6e$var$HOVER:
            if ($700bf53ed0e34a6e$var$areCoordsEqual(state.clientOffset, payload.clientOffset)) return state;
            return $700bf53ed0e34a6e$var$_objectSpread$3({}, state, {
                clientOffset: payload.clientOffset
            });
        case $700bf53ed0e34a6e$var$END_DRAG:
        case $700bf53ed0e34a6e$var$DROP:
            return $700bf53ed0e34a6e$var$initialState$1;
        default:
            return state;
    }
}
function $700bf53ed0e34a6e$var$_defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
const $700bf53ed0e34a6e$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $700bf53ed0e34a6e$var$reduce$3(state = $700bf53ed0e34a6e$var$initialState, action) {
    const { payload: payload  } = action;
    switch(action.type){
        case $700bf53ed0e34a6e$var$BEGIN_DRAG:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case $700bf53ed0e34a6e$var$PUBLISH_DRAG_SOURCE:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                isSourcePublic: true
            });
        case $700bf53ed0e34a6e$var$HOVER:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                targetIds: payload.targetIds
            });
        case $700bf53ed0e34a6e$var$REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                targetIds: $700bf53ed0e34a6e$var$without$1(state.targetIds, payload.targetId)
            });
        case $700bf53ed0e34a6e$var$DROP:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case $700bf53ed0e34a6e$var$END_DRAG:
            return $700bf53ed0e34a6e$var$_objectSpread$2({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}
function $700bf53ed0e34a6e$var$reduce$2(state = 0, action) {
    switch(action.type){
        case $700bf53ed0e34a6e$var$ADD_SOURCE:
        case $700bf53ed0e34a6e$var$ADD_TARGET:
            return state + 1;
        case $700bf53ed0e34a6e$var$REMOVE_SOURCE:
        case $700bf53ed0e34a6e$var$REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}
function $700bf53ed0e34a6e$var$reduce$1(state = 0) {
    return state + 1;
}
function $700bf53ed0e34a6e$var$_defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function $700bf53ed0e34a6e$var$reduce(state = {}, action) {
    return {
        dirtyHandlerIds: $700bf53ed0e34a6e$var$reduce$5(state.dirtyHandlerIds, {
            type: action.type,
            payload: $700bf53ed0e34a6e$var$_objectSpread$1({}, action.payload, {
                prevTargetIds: $700bf53ed0e34a6e$var$get(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: $700bf53ed0e34a6e$var$reduce$4(state.dragOffset, action),
        refCount: $700bf53ed0e34a6e$var$reduce$2(state.refCount, action),
        dragOperation: $700bf53ed0e34a6e$var$reduce$3(state.dragOperation, action),
        stateId: $700bf53ed0e34a6e$var$reduce$1(state.stateId)
    };
}
function $700bf53ed0e34a6e$var$createDragDropManager(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $700bf53ed0e34a6e$var$makeStoreInstance(debugMode);
    const monitor = new $700bf53ed0e34a6e$var$DragDropMonitorImpl(store, new $700bf53ed0e34a6e$var$HandlerRegistryImpl(store));
    const manager = new $700bf53ed0e34a6e$var$DragDropManagerImpl(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $700bf53ed0e34a6e$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return $700bf53ed0e34a6e$var$createStore($700bf53ed0e34a6e$var$reduce, debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}
function $700bf53ed0e34a6e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $700bf53ed0e34a6e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $700bf53ed0e34a6e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $700bf53ed0e34a6e$var$refCount = 0;
const $700bf53ed0e34a6e$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $700bf53ed0e34a6e$var$DndProvider = /*#__PURE__*/ (0, $bh6RR.memo)(function DndProvider(_param) {
    var { children: children  } = _param, props = $700bf53ed0e34a6e$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $700bf53ed0e34a6e$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $bh6RR.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $700bf53ed0e34a6e$var$getGlobalContext();
            ++$700bf53ed0e34a6e$var$refCount;
            return ()=>{
                if (--$700bf53ed0e34a6e$var$refCount === 0) context[$700bf53ed0e34a6e$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$DndContext.Provider, {
        value: manager,
        children: children
    });
});
function $700bf53ed0e34a6e$var$getDndContextValue(props) {
    if ("manager" in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $700bf53ed0e34a6e$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $700bf53ed0e34a6e$var$createSingletonDndContext(backend, context = $700bf53ed0e34a6e$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$700bf53ed0e34a6e$var$INSTANCE_SYM]) ctx[$700bf53ed0e34a6e$var$INSTANCE_SYM] = {
        dragDropManager: $700bf53ed0e34a6e$var$createDragDropManager(backend, context, options, debugMode)
    };
    return ctx[$700bf53ed0e34a6e$var$INSTANCE_SYM];
}
function $700bf53ed0e34a6e$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}
// do not edit .js files directly - edit src/index.jst
var $700bf53ed0e34a6e$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
// suppress the useLayoutEffect warning on server side.
const $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */ function $700bf53ed0e34a6e$var$useCollector(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $bh6RR.useState)(()=>collect(monitor));
    const updateCollected = (0, $bh6RR.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!$700bf53ed0e34a6e$var$fastDeepEqual(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(updateCollected);
    return [
        collected,
        updateCollected
    ];
}
function $700bf53ed0e34a6e$var$useMonitorOutput(monitor, collect, onCollect) {
    const [collected, updateCollected] = $700bf53ed0e34a6e$var$useCollector(monitor, collect, onCollect);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}
function $700bf53ed0e34a6e$var$useCollectedProps(collector, monitor, connector) {
    return $700bf53ed0e34a6e$var$useMonitorOutput(monitor, collector || (()=>({})), ()=>connector.reconnect());
}
function $700bf53ed0e34a6e$var$useOptionalFactory(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== "function") memoDeps.push(arg);
    return (0, $bh6RR.useMemo)(()=>{
        return typeof arg === "function" ? arg() : arg;
    }, memoDeps);
}
function $700bf53ed0e34a6e$var$useConnectDragSource(connector) {
    return (0, $bh6RR.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $700bf53ed0e34a6e$var$useConnectDragPreview(connector) {
    return (0, $bh6RR.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}
let $700bf53ed0e34a6e$var$isCallingCanDrag = false;
let $700bf53ed0e34a6e$var$isCallingIsDragging = false;
class $700bf53ed0e34a6e$var$DragSourceMonitorImpl {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $700bf53ed0e34a6e$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $700bf53ed0e34a6e$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $700bf53ed0e34a6e$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $700bf53ed0e34a6e$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
let $700bf53ed0e34a6e$var$isCallingCanDrop = false;
class $700bf53ed0e34a6e$var$DropTargetMonitorImpl {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $700bf53ed0e34a6e$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $700bf53ed0e34a6e$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
function $700bf53ed0e34a6e$var$registerTarget(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $700bf53ed0e34a6e$var$registerSource(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}
function $700bf53ed0e34a6e$var$shallowEqual(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}
function $700bf53ed0e34a6e$var$isRef(obj) {
    return obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}
function $700bf53ed0e34a6e$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    const displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + `You can either wrap ${displayName} into a <div>, or turn it into a ` + "drag source or a drop target itself.");
}
function $700bf53ed0e34a6e$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $bh6RR.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $700bf53ed0e34a6e$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $700bf53ed0e34a6e$var$cloneWithRef(element, ref);
    };
}
function $700bf53ed0e34a6e$var$wrapConnectorHooks(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $700bf53ed0e34a6e$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $700bf53ed0e34a6e$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $700bf53ed0e34a6e$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    $700bf53ed0e34a6e$var$invariant(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $bh6RR.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $bh6RR.cloneElement)(element, {
        ref: (node)=>{
            $700bf53ed0e34a6e$var$setRef(previousRef, node);
            $700bf53ed0e34a6e$var$setRef(newRef, node);
        }
    });
}
class $700bf53ed0e34a6e$var$SourceConnector {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !$700bf53ed0e34a6e$var$shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !$700bf53ed0e34a6e$var$shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = $700bf53ed0e34a6e$var$wrapConnectorHooks({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ($700bf53ed0e34a6e$var$isRef(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ($700bf53ed0e34a6e$var$isRef(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}
class $700bf53ed0e34a6e$var$TargetConnector {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !$700bf53ed0e34a6e$var$shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = $700bf53ed0e34a6e$var$wrapConnectorHooks({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ($700bf53ed0e34a6e$var$isRef(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}
/**
 * A hook to retrieve the DragDropManager from Context
 */ function $700bf53ed0e34a6e$var$useDragDropManager() {
    const { dragDropManager: dragDropManager  } = (0, $bh6RR.useContext)($700bf53ed0e34a6e$var$DndContext);
    $700bf53ed0e34a6e$var$invariant(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}
function $700bf53ed0e34a6e$var$useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const connector = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$SourceConnector(manager.getBackend()), [
        manager
    ]);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}
function $700bf53ed0e34a6e$var$useDragSourceMonitor() {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    return (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DragSourceMonitorImpl(manager), [
        manager
    ]);
}
class $700bf53ed0e34a6e$var$DragSourceImpl {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === "object") result = spec.item;
        else if (typeof spec.item === "function") result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === "boolean") return spec.canDrag;
        else if (typeof spec.canDrag === "function") return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging  } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end  } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}
function $700bf53ed0e34a6e$var$useDragSource(spec, monitor, connector) {
    const handler = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DragSourceImpl(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $bh6RR.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}
function $700bf53ed0e34a6e$var$useDragType(spec) {
    return (0, $bh6RR.useMemo)(()=>{
        const result = spec.type;
        $700bf53ed0e34a6e$var$invariant(result != null, "spec.type must be defined");
        return result;
    }, [
        spec
    ]);
}
function $700bf53ed0e34a6e$var$useRegisteredDragSource(spec, monitor, connector) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const handler = $700bf53ed0e34a6e$var$useDragSource(spec, monitor, connector);
    const itemType = $700bf53ed0e34a6e$var$useDragType(spec);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = $700bf53ed0e34a6e$var$registerSource(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}
/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function $700bf53ed0e34a6e$var$useDrag(specArg, deps) {
    const spec = $700bf53ed0e34a6e$var$useOptionalFactory(specArg, deps);
    $700bf53ed0e34a6e$var$invariant(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = $700bf53ed0e34a6e$var$useDragSourceMonitor();
    const connector = $700bf53ed0e34a6e$var$useDragSourceConnector(spec.options, spec.previewOptions);
    $700bf53ed0e34a6e$var$useRegisteredDragSource(spec, monitor, connector);
    return [
        $700bf53ed0e34a6e$var$useCollectedProps(spec.collect, monitor, connector),
        $700bf53ed0e34a6e$var$useConnectDragSource(connector),
        $700bf53ed0e34a6e$var$useConnectDragPreview(connector)
    ];
}
/**
 * useDragLayer Hook
 * @param collector The property collector
 */ function $700bf53ed0e34a6e$var$useDragLayer(collect) {
    const dragDropManager = $700bf53ed0e34a6e$var$useDragDropManager();
    const monitor = dragDropManager.getMonitor();
    const [collected, updateCollected] = $700bf53ed0e34a6e$var$useCollector(monitor, collect);
    (0, $bh6RR.useEffect)(()=>monitor.subscribeToOffsetChange(updateCollected));
    (0, $bh6RR.useEffect)(()=>monitor.subscribeToStateChange(updateCollected));
    return collected;
}
function $700bf53ed0e34a6e$var$useConnectDropTarget(connector) {
    return (0, $bh6RR.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}
function $700bf53ed0e34a6e$var$useDropTargetConnector(options) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const connector = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$TargetConnector(manager.getBackend()), [
        manager
    ]);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}
function $700bf53ed0e34a6e$var$useDropTargetMonitor() {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    return (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DropTargetMonitorImpl(manager), [
        manager
    ]);
}
/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */ function $700bf53ed0e34a6e$var$useAccept(spec) {
    const { accept: accept  } = spec;
    return (0, $bh6RR.useMemo)(()=>{
        $700bf53ed0e34a6e$var$invariant(spec.accept != null, "accept must be defined");
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}
class $700bf53ed0e34a6e$var$DropTargetImpl {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}
function $700bf53ed0e34a6e$var$useDropTarget(spec, monitor) {
    const dropTarget = (0, $bh6RR.useMemo)(()=>new $700bf53ed0e34a6e$var$DropTargetImpl(spec, monitor), [
        monitor
    ]);
    (0, $bh6RR.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}
function $700bf53ed0e34a6e$var$useRegisteredDropTarget(spec, monitor, connector) {
    const manager = $700bf53ed0e34a6e$var$useDragDropManager();
    const dropTarget = $700bf53ed0e34a6e$var$useDropTarget(spec, monitor);
    const accept = $700bf53ed0e34a6e$var$useAccept(spec);
    $700bf53ed0e34a6e$var$useIsomorphicLayoutEffect(function registerDropTarget() {
        const [handlerId, unregister] = $700bf53ed0e34a6e$var$registerTarget(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join("|")
    ]);
}
/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function $700bf53ed0e34a6e$var$useDrop(specArg, deps) {
    const spec = $700bf53ed0e34a6e$var$useOptionalFactory(specArg, deps);
    const monitor = $700bf53ed0e34a6e$var$useDropTargetMonitor();
    const connector = $700bf53ed0e34a6e$var$useDropTargetConnector(spec.options);
    $700bf53ed0e34a6e$var$useRegisteredDropTarget(spec, monitor, connector);
    return [
        $700bf53ed0e34a6e$var$useCollectedProps(spec.collect, monitor, connector),
        $700bf53ed0e34a6e$var$useConnectDropTarget(connector)
    ];
}
// cheap lodash replacements
function $700bf53ed0e34a6e$var$memoize(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
/**
 * drop-in replacement for _.without
 */ function $700bf53ed0e34a6e$var$without(items, item) {
    return items.filter((i)=>i !== item);
}
function $700bf53ed0e34a6e$var$union(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}
class $700bf53ed0e34a6e$var$EnterLeaveCounter {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = $700bf53ed0e34a6e$var$union(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = $700bf53ed0e34a6e$var$without(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}
class $700bf53ed0e34a6e$var$NativeDragSource {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}
const $700bf53ed0e34a6e$var$FILE = "__NATIVE_FILE__";
const $700bf53ed0e34a6e$var$URL = "__NATIVE_URL__";
const $700bf53ed0e34a6e$var$TEXT = "__NATIVE_TEXT__";
const $700bf53ed0e34a6e$var$HTML = "__NATIVE_HTML__";
var $700bf53ed0e34a6e$var$NativeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    FILE: $700bf53ed0e34a6e$var$FILE,
    HTML: $700bf53ed0e34a6e$var$HTML,
    TEXT: $700bf53ed0e34a6e$var$TEXT,
    URL: $700bf53ed0e34a6e$var$URL
});
function $700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), "");
    return result != null ? result : defaultValue;
}
const $700bf53ed0e34a6e$var$nativeTypesConfig = {
    [$700bf53ed0e34a6e$var$FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Files"
        ]
    },
    [$700bf53ed0e34a6e$var$HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>$700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Html",
            "text/html"
        ]
    },
    [$700bf53ed0e34a6e$var$URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>$700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, matchesTypes, "").split("\n"),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Url",
            "text/uri-list"
        ]
    },
    [$700bf53ed0e34a6e$var$TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>$700bf53ed0e34a6e$var$getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Text",
            "text/plain"
        ]
    }
};
function $700bf53ed0e34a6e$var$createNativeDragSource(type, dataTransfer) {
    const config = $700bf53ed0e34a6e$var$nativeTypesConfig[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new $700bf53ed0e34a6e$var$NativeDragSource(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $700bf53ed0e34a6e$var$matchNativeItemType(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys($700bf53ed0e34a6e$var$nativeTypesConfig).filter((nativeItemType)=>{
        const typeConfig = $700bf53ed0e34a6e$var$nativeTypesConfig[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}
const $700bf53ed0e34a6e$var$isFirefox = $700bf53ed0e34a6e$var$memoize(()=>/firefox/i.test(navigator.userAgent));
const $700bf53ed0e34a6e$var$isSafari = $700bf53ed0e34a6e$var$memoize(()=>Boolean(window.safari));
class $700bf53ed0e34a6e$var$MonotonicInterpolant {
    interpolate(x) {
        const { xs: xs , ys: ys , c1s: c1s , c2s: c2s , c3s: c3s  } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length  } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}
const $700bf53ed0e34a6e$var$ELEMENT_NODE$1 = 1;
function $700bf53ed0e34a6e$var$getNodeClientOffset$1(node) {
    const el = node.nodeType === $700bf53ed0e34a6e$var$ELEMENT_NODE$1 ? node : node.parentElement;
    if (!el) return null;
    const { top: top , left: left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $700bf53ed0e34a6e$var$getEventClientOffset$1(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $700bf53ed0e34a6e$var$isImageNode(node) {
    var ref;
    return node.nodeName === "IMG" && ($700bf53ed0e34a6e$var$isFirefox() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $700bf53ed0e34a6e$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ($700bf53ed0e34a6e$var$isSafari() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $700bf53ed0e34a6e$var$getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $700bf53ed0e34a6e$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $700bf53ed0e34a6e$var$getNodeClientOffset$1(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth , offsetHeight: sourceHeight  } = sourceNode;
    const { anchorX: anchorX , anchorY: anchorY  } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth , dragPreviewHeight: dragPreviewHeight  } = $700bf53ed0e34a6e$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new $700bf53ed0e34a6e$var$MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ($700bf53ed0e34a6e$var$isSafari() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new $700bf53ed0e34a6e$var$MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX , offsetY: offsetY  } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}
let $700bf53ed0e34a6e$var$OptionsReader$1 = class OptionsReader {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
};
function $700bf53ed0e34a6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $700bf53ed0e34a6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $700bf53ed0e34a6e$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $700bf53ed0e34a6e$var$HTML5BackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute("draggable", "true");
        node.addEventListener("dragstart", handleDragStart);
        node.addEventListener("selectstart", handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener("dragstart", handleDragStart);
            node.removeEventListener("selectstart", handleSelectStart);
            node.setAttribute("draggable", "false");
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener("dragenter", handleDragEnter);
        node.addEventListener("dragover", handleDragOver);
        node.addEventListener("drop", handleDrop);
        return ()=>{
            node.removeEventListener("dragenter", handleDragEnter);
            node.removeEventListener("dragover", handleDragOver);
            node.removeEventListener("drop", handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener("dragstart", this.handleTopDragStart);
        target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.addEventListener("dragend", this.handleTopDragEndCapture, true);
        target.addEventListener("dragenter", this.handleTopDragEnter);
        target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.addEventListener("dragover", this.handleTopDragOver);
        target.addEventListener("dragover", this.handleTopDragOverCapture, true);
        target.addEventListener("drop", this.handleTopDrop);
        target.addEventListener("drop", this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener("dragstart", this.handleTopDragStart);
        target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
        target.removeEventListener("dragenter", this.handleTopDragEnter);
        target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.removeEventListener("dragover", this.handleTopDragOver);
        target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
        target.removeEventListener("drop", this.handleTopDrop);
        target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $700bf53ed0e34a6e$var$_objectSpread({
            dropEffect: this.altKeyPressed ? "copy" : "move"
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return "copy";
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $700bf53ed0e34a6e$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($700bf53ed0e34a6e$var$NativeTypes).some((key)=>$700bf53ed0e34a6e$var$NativeTypes[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = $700bf53ed0e34a6e$var$createNativeDragSource(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && $700bf53ed0e34a6e$var$getNodeClientOffset$1(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds  } = this;
            this.dragStartSourceIds = null;
            const clientOffset = $700bf53ed0e34a6e$var$getEventClientOffset$1(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer  } = e;
            const nativeType = $700bf53ed0e34a6e$var$matchNativeItemType(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX , anchorY: anchorY , offsetX: offsetX , offsetY: offsetY  } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = $700bf53ed0e34a6e$var$getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState  } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer  } = e;
            const nativeType = $700bf53ed0e34a6e$var$matchNativeItemType(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds  } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: $700bf53ed0e34a6e$var$getEventClientOffset$1(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds  } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = $700bf53ed0e34a6e$var$getEventClientOffset$1(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ($700bf53ed0e34a6e$var$matchNativeItemType(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds  } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: $700bf53ed0e34a6e$var$getEventClientOffset$1(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
            // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new $700bf53ed0e34a6e$var$OptionsReader$1(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new $700bf53ed0e34a6e$var$EnterLeaveCounter(this.isNodeInDocument);
    }
}
let $700bf53ed0e34a6e$var$emptyImage;
function $700bf53ed0e34a6e$var$getEmptyImage() {
    if (!$700bf53ed0e34a6e$var$emptyImage) {
        $700bf53ed0e34a6e$var$emptyImage = new Image();
        $700bf53ed0e34a6e$var$emptyImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    }
    return $700bf53ed0e34a6e$var$emptyImage;
}
const $700bf53ed0e34a6e$var$HTML5Backend = function createBackend(manager, context, options) {
    return new $700bf53ed0e34a6e$var$HTML5BackendImpl(manager, context, options);
};
function $700bf53ed0e34a6e$var$Piece({ isPremovedPiece: isPremovedPiece = false , piece: piece , square: square , squares: squares  }) {
    const { animationDuration: animationDuration , arePiecesDraggable: arePiecesDraggable , boardWidth: boardWidth , boardOrientation: boardOrientation , chessPieces: chessPieces , currentPosition: currentPosition , deletePieceFromSquare: deletePieceFromSquare , dropOffBoardAction: dropOffBoardAction , id: id , isDraggablePiece: isDraggablePiece , isWaitingForAnimation: isWaitingForAnimation , onPieceClick: onPieceClick , onPieceDragBegin: onPieceDragBegin , onPieceDragEnd: onPieceDragEnd , onPieceDropOffBoard: onPieceDropOffBoard , onPromotionCheck: onPromotionCheck , positionDifferences: positionDifferences  } = $700bf53ed0e34a6e$var$useChessboard();
    const [pieceStyle, setPieceStyle] = (0, $bh6RR.useState)({
        opacity: 1,
        zIndex: 5,
        touchAction: "none",
        cursor: arePiecesDraggable && isDraggablePiece({
            piece: piece,
            sourceSquare: square
        }) ? "-webkit-grab" : "default"
    });
    const [{ canDrag: canDrag , isDragging: isDragging  }, drag, dragPreview] = $700bf53ed0e34a6e$var$useDrag(()=>({
            type: "piece",
            item: ()=>{
                onPieceDragBegin(piece, square);
                return {
                    piece: piece,
                    square: square,
                    id: id
                };
            },
            end: (item, monitor)=>{
                onPieceDragEnd(piece, square);
                const wasDropOutsideTheBoard = !monitor.didDrop();
                if (wasDropOutsideTheBoard) {
                    if (dropOffBoardAction === "trash") deletePieceFromSquare(square);
                    onPieceDropOffBoard === null || onPieceDropOffBoard === void 0 || onPieceDropOffBoard(square, piece);
                }
            },
            collect: (monitor)=>({
                    canDrag: isDraggablePiece({
                        piece: piece,
                        sourceSquare: square
                    }),
                    isDragging: !!monitor.isDragging()
                })
        }), [
        piece,
        square,
        currentPosition,
        id
    ]);
    // hide the default preview
    dragPreview($700bf53ed0e34a6e$var$getEmptyImage(), {
        captureDraggingState: true
    });
    // hide piece on drag
    (0, $bh6RR.useEffect)(()=>{
        setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                opacity: isDragging ? 0 : 1
            }));
    }, [
        isDragging
    ]);
    // new move has come in
    // if waiting for animation, then animation has started and we can perform animation
    // we need to head towards where we need to go, we are the source, we are heading towards the target
    (0, $bh6RR.useEffect)(()=>{
        var _a;
        const removedPiece = (_a = positionDifferences.removed) === null || _a === void 0 ? void 0 : _a[square];
        // return as null and not loaded yet
        if (!positionDifferences.added || !removedPiece) return;
        // check if piece matches or if removed piece was a pawn and new square is on 1st or 8th rank (promotion)
        const newSquare = Object.entries(positionDifferences.added).find(([s, p])=>p === removedPiece || onPromotionCheck(square, s, removedPiece));
        // we can perform animation if our square was in removed, AND the matching piece is in added AND this isn't a premoved piece
        if (isWaitingForAnimation && removedPiece && newSquare && !isPremovedPiece) {
            const sourceSq = square;
            const targetSq = newSquare[0];
            if (sourceSq && targetSq) {
                const squareWidth = boardWidth / 8;
                setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                        transform: `translate(${(boardOrientation === "black" ? -1 : 1) * (targetSq.charCodeAt(0) - sourceSq.charCodeAt(0)) * squareWidth}px, ${(boardOrientation === "black" ? -1 : 1) * (Number(sourceSq[1]) - Number(targetSq[1])) * squareWidth}px)`,
                        transition: `transform ${animationDuration}ms`,
                        zIndex: 6
                    }));
            }
        }
    }, [
        positionDifferences
    ]);
    // translate to their own positions (repaint on undo)
    (0, $bh6RR.useEffect)(()=>{
        const { sourceSq: sourceSq  } = getSingleSquareCoordinates();
        if (sourceSq) setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                transform: `translate(${0}px, ${0}px)`,
                transition: `transform ${0}ms`
            }));
    }, [
        currentPosition
    ]);
    // update is piece draggable
    (0, $bh6RR.useEffect)(()=>{
        setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                cursor: arePiecesDraggable && isDraggablePiece({
                    piece: piece,
                    sourceSquare: square
                }) ? "-webkit-grab" : "default"
            }));
    }, [
        square,
        currentPosition,
        arePiecesDraggable
    ]);
    function getSingleSquareCoordinates() {
        return {
            sourceSq: squares[square]
        };
    }
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        ref: arePiecesDraggable && canDrag ? drag : null,
        onClick: ()=>onPieceClick(piece, square),
        "data-piece": piece,
        style: pieceStyle
    }, {
        children: typeof chessPieces[piece] === "function" ? chessPieces[piece]({
            squareWidth: boardWidth / 8,
            isDragging: isDragging,
            square: square
        }) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: boardWidth / 8,
            height: boardWidth / 8,
            style: {
                display: "block"
            }
        }, {
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                children: chessPieces[piece]
            })
        }))
    }));
}
function $700bf53ed0e34a6e$var$Square({ square: square , squareColor: squareColor , setSquares: setSquares , squareHasPremove: squareHasPremove , children: children  }) {
    const squareRef = (0, $bh6RR.useRef)(null);
    const { autoPromoteToQueen: autoPromoteToQueen , boardWidth: boardWidth , boardOrientation: boardOrientation , clearArrows: clearArrows , currentPosition: currentPosition , currentRightClickDown: currentRightClickDown , customBoardStyle: customBoardStyle , customDarkSquareStyle: customDarkSquareStyle , customDropSquareStyle: customDropSquareStyle , customLightSquareStyle: customLightSquareStyle , customPremoveDarkSquareStyle: customPremoveDarkSquareStyle , customPremoveLightSquareStyle: customPremoveLightSquareStyle , customSquare: CustomSquare , customSquareStyles: customSquareStyles , drawNewArrow: drawNewArrow , handleSetPosition: handleSetPosition , handleSparePieceDrop: handleSparePieceDrop , isWaitingForAnimation: isWaitingForAnimation , lastPieceColour: lastPieceColour , lastSquareDraggedOver: lastSquareDraggedOver , onArrowDrawEnd: onArrowDrawEnd , onDragOverSquare: onDragOverSquare , onMouseOutSquare: onMouseOutSquare , onMouseOverSquare: onMouseOverSquare , onPieceDrop: onPieceDrop , onPromotionCheck: onPromotionCheck , onRightClickDown: onRightClickDown , onRightClickUp: onRightClickUp , onSquareClick: onSquareClick , setLastSquareDraggedOver: setLastSquareDraggedOver , setPromoteFromSquare: setPromoteFromSquare , setPromoteToSquare: setPromoteToSquare , setShowPromoteDialog: setShowPromoteDialog  } = $700bf53ed0e34a6e$var$useChessboard();
    const [{ isOver: isOver  }, drop] = $700bf53ed0e34a6e$var$useDrop(()=>({
            accept: "piece",
            drop: handleDrop,
            collect: (monitor)=>({
                    isOver: !!monitor.isOver()
                })
        }), [
        square,
        currentPosition,
        onPieceDrop,
        isWaitingForAnimation,
        lastPieceColour
    ]);
    function handleDrop(item) {
        if (item.isSpare) {
            handleSparePieceDrop(item.piece, square);
            return;
        }
        if (onPromotionCheck(item.square, square, item.piece)) {
            if (autoPromoteToQueen) handleSetPosition(item.square, square, item.piece[0] === "w" ? "wQ" : "bQ");
            else {
                setPromoteFromSquare(item.square);
                setPromoteToSquare(square);
                setShowPromoteDialog(true);
            }
        } else handleSetPosition(item.square, square, item.piece, true);
    }
    (0, $bh6RR.useEffect)(()=>{
        if (squareRef.current) {
            const { x: x , y: y  } = squareRef.current.getBoundingClientRect();
            setSquares((oldSquares)=>Object.assign(Object.assign({}, oldSquares), {
                    [square]: {
                        x: x,
                        y: y
                    }
                }));
        }
    }, [
        boardWidth,
        boardOrientation
    ]);
    const defaultSquareStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$borderRadius(square, boardOrientation, customBoardStyle)), squareColor === "black" ? customDarkSquareStyle : customLightSquareStyle), squareHasPremove && (squareColor === "black" ? customPremoveDarkSquareStyle : customPremoveLightSquareStyle)), isOver && customDropSquareStyle);
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        ref: drop,
        style: defaultSquareStyle,
        "data-square-color": squareColor,
        "data-square": square,
        onTouchMove: (e)=>{
            var _a;
            // Handle touch events on tablet and mobile not covered by onMouseOver/onDragEnter
            const touchLocation = e.touches[0];
            const touchElement = document.elementsFromPoint(touchLocation.clientX, touchLocation.clientY);
            const draggedOverSquare = (_a = touchElement === null || touchElement === void 0 ? void 0 : touchElement.find((el)=>el.getAttribute("data-square"))) === null || _a === void 0 ? void 0 : _a.getAttribute("data-square");
            if (draggedOverSquare && draggedOverSquare !== lastSquareDraggedOver) {
                setLastSquareDraggedOver(draggedOverSquare);
                onDragOverSquare(draggedOverSquare);
            }
        },
        onMouseOver: (e)=>{
            // noop if moving from child of square into square.
            if (e.buttons === 2 && currentRightClickDown) drawNewArrow(currentRightClickDown, square);
            if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
            onMouseOverSquare(square);
        },
        onMouseOut: (e)=>{
            // noop if moving from square into a child of square.
            if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
            onMouseOutSquare(square);
        },
        onMouseDown: (e)=>{
            if (e.button === 2) onRightClickDown(square);
        },
        onMouseUp: (e)=>{
            if (e.button === 2) {
                if (currentRightClickDown) onArrowDrawEnd(currentRightClickDown, square);
                onRightClickUp(square);
            }
        },
        onDragEnter: ()=>onDragOverSquare(square),
        onClick: ()=>{
            const piece = currentPosition[square];
            onSquareClick(square, piece);
            clearArrows();
        },
        onContextMenu: (e)=>{
            e.preventDefault();
        }
    }, {
        children: typeof CustomSquare === "string" ? (0, $d4dab640dcbe486c$exports.jsx)(CustomSquare, Object.assign({
            // Type is too complex to properly evaluate, so ignore this line.
            // @ts-ignore
            ref: squareRef,
            style: Object.assign(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$size(boardWidth)), $700bf53ed0e34a6e$var$center), !squareHasPremove && (customSquareStyles === null || customSquareStyles === void 0 ? void 0 : customSquareStyles[square]))
        }, {
            children: children
        })) : (0, $d4dab640dcbe486c$exports.jsx)(CustomSquare, Object.assign({
            ref: squareRef,
            square: square,
            squareColor: squareColor,
            style: Object.assign(Object.assign(Object.assign({}, $700bf53ed0e34a6e$var$size(boardWidth)), $700bf53ed0e34a6e$var$center), !squareHasPremove && (customSquareStyles === null || customSquareStyles === void 0 ? void 0 : customSquareStyles[square]))
        }, {
            children: children
        }))
    }));
}
const $700bf53ed0e34a6e$var$center = {
    display: "flex",
    justifyContent: "center"
};
const $700bf53ed0e34a6e$var$size = (width)=>({
        width: width / 8,
        height: width / 8
    });
const $700bf53ed0e34a6e$var$borderRadius = (square, boardOrientation, customBoardStyle)=>{
    if (!(customBoardStyle === null || customBoardStyle === void 0 ? void 0 : customBoardStyle.borderRadius)) return {};
    if (square === "a1") return boardOrientation === "white" ? {
        borderBottomLeftRadius: customBoardStyle.borderRadius
    } : {
        borderTopRightRadius: customBoardStyle.borderRadius
    };
    if (square === "a8") return boardOrientation === "white" ? {
        borderTopLeftRadius: customBoardStyle.borderRadius
    } : {
        borderBottomRightRadius: customBoardStyle.borderRadius
    };
    if (square === "h1") return boardOrientation === "white" ? {
        borderBottomRightRadius: customBoardStyle.borderRadius
    } : {
        borderTopLeftRadius: customBoardStyle.borderRadius
    };
    if (square === "h8") return boardOrientation === "white" ? {
        borderTopRightRadius: customBoardStyle.borderRadius
    } : {
        borderBottomLeftRadius: customBoardStyle.borderRadius
    };
    return {};
};
function $700bf53ed0e34a6e$var$Squares() {
    const [squares, setSquares] = (0, $bh6RR.useState)({});
    const { arePremovesAllowed: arePremovesAllowed , boardOrientation: boardOrientation , boardWidth: boardWidth , currentPosition: currentPosition , id: id , premoves: premoves , showBoardNotation: showBoardNotation  } = $700bf53ed0e34a6e$var$useChessboard();
    const premovesHistory = (0, $bh6RR.useMemo)(()=>{
        const result = [];
        // if premoves aren't allowed, don't waste time on calculations
        if (!arePremovesAllowed) return [];
        premoves.forEach((premove, index)=>{
            const { sourceSq: sourceSq , targetSq: targetSq , piece: piece  } = premove;
            // determine if the premove is made by an already premoved piece
            const relatedPremovedPiece = result.find((p)=>{
                var _a;
                return p.piece === piece && ((_a = p.premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.targetSq) === sourceSq;
            });
            // if premove has been made by already premoved piece then write the move to its `premovesRoute` field to be able find its final destination later
            if (relatedPremovedPiece) relatedPremovedPiece.premovesRoute.push({
                sourceSq: sourceSq,
                targetSq: targetSq,
                index: index
            });
            else result.push({
                piece: piece,
                // index is useful for scenarios where two or more pieces are targeting the same square
                premovesRoute: [
                    {
                        sourceSq: sourceSq,
                        targetSq: targetSq,
                        index: index
                    }
                ]
            });
        });
        return result;
    }, [
        premoves
    ]);
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        "data-boardid": id
    }, {
        children: [
            ...Array(8)
        ].map((_, r)=>{
            return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                style: {
                    display: "flex",
                    flexWrap: "nowrap",
                    width: boardWidth
                }
            }, {
                children: [
                    ...Array(8)
                ].map((_, c)=>{
                    const square = boardOrientation === "black" ? $700bf53ed0e34a6e$var$COLUMNS[7 - c] + (r + 1) : $700bf53ed0e34a6e$var$COLUMNS[c] + (8 - r);
                    const squareColor = c % 2 === r % 2 ? "white" : "black";
                    const squareHasPremove = premoves.find((p)=>p.sourceSq === square || p.targetSq === square);
                    const squareHasPremoveTarget = premovesHistory.filter(({ premovesRoute: premovesRoute  })=>{
                        var _a;
                        return ((_a = premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.targetSq) === square;
                    })//the premoved piece with the higher index will be shown, as it is the latest one
                    .sort((a, b)=>{
                        var _a, _b;
                        return ((_a = b.premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.index) - ((_b = a.premovesRoute.at(-1)) === null || _b === void 0 ? void 0 : _b.index);
                    }).at(0);
                    return (0, $d4dab640dcbe486c$exports.jsxs)($700bf53ed0e34a6e$var$Square, Object.assign({
                        square: square,
                        squareColor: squareColor,
                        setSquares: setSquares,
                        squareHasPremove: !!squareHasPremove
                    }, {
                        children: [
                            !squareHasPremove && currentPosition[square] && (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Piece, {
                                piece: currentPosition[square],
                                square: square,
                                squares: squares
                            }),
                            squareHasPremoveTarget && (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Piece, {
                                isPremovedPiece: true,
                                piece: squareHasPremoveTarget.piece,
                                square: square,
                                squares: squares
                            }),
                            showBoardNotation && (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Notation, {
                                row: r,
                                col: c
                            })
                        ]
                    }), `${c}${r}`);
                })
            }), r.toString());
        })
    }));
}
const $700bf53ed0e34a6e$var$Arrows = ()=>{
    const { arrows: arrows , newArrow: newArrow , boardOrientation: boardOrientation , boardWidth: boardWidth , customArrowColor: primaryArrowCollor  } = $700bf53ed0e34a6e$var$useChessboard();
    const arrowsList = [
        ...arrows,
        newArrow
    ].filter(Boolean);
    return (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        width: boardWidth,
        height: boardWidth,
        style: {
            position: "absolute",
            top: "0",
            left: "0",
            pointerEvents: "none",
            zIndex: "10"
        }
    }, {
        children: arrowsList.map((arrow, i)=>{
            const [arrowStartField, arrowEndField, arrowColor] = arrow;
            if (arrowStartField === arrowEndField) return null;
            const from = $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, arrowStartField);
            const to = $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, arrowEndField);
            let ARROW_LENGTH_REDUCER = boardWidth / 32;
            const isArrowActive = i === arrows.length;
            // if there are different arrows targeting the same square make their length a bit shorter
            if (arrows.some((restArrow)=>restArrow[0] !== arrowStartField && restArrow[1] === arrowEndField) && !isArrowActive) ARROW_LENGTH_REDUCER = boardWidth / 16;
            const dx = to.x - from.x;
            const dy = to.y - from.y;
            const r = Math.hypot(dy, dx);
            const end = {
                x: from.x + dx * (r - ARROW_LENGTH_REDUCER) / r,
                y: from.y + dy * (r - ARROW_LENGTH_REDUCER) / r
            };
            return (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("marker", Object.assign({
                        id: `arrowhead-${i}`,
                        markerWidth: "2",
                        markerHeight: "2.5",
                        refX: "1.25",
                        refY: "1.25",
                        orient: "auto"
                    }, {
                        children: (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                            points: "0.3 0, 2 1.25, 0.3 2.5",
                            fill: arrowColor !== null && arrowColor !== void 0 ? arrowColor : primaryArrowCollor
                        })
                    })),
                    (0, $d4dab640dcbe486c$exports.jsx)("line", {
                        x1: from.x,
                        y1: from.y,
                        x2: end.x,
                        y2: end.y,
                        opacity: isArrowActive ? "0.5" : "0.65",
                        stroke: arrowColor !== null && arrowColor !== void 0 ? arrowColor : primaryArrowCollor,
                        strokeWidth: isArrowActive ? 0.9 * boardWidth / 40 : boardWidth / 40,
                        markerEnd: `url(#arrowhead-${i})`
                    })
                ]
            }, `${arrowStartField}-${arrowEndField}${isArrowActive ? "-active" : ""}`);
        })
    }));
};
function $700bf53ed0e34a6e$var$PromotionOption({ option: option  }) {
    const [isHover, setIsHover] = (0, $bh6RR.useState)(false);
    const { boardWidth: boardWidth , chessPieces: chessPieces , customDarkSquareStyle: customDarkSquareStyle , customLightSquareStyle: customLightSquareStyle , handleSetPosition: handleSetPosition , onPromotionPieceSelect: onPromotionPieceSelect , promoteFromSquare: promoteFromSquare , promoteToSquare: promoteToSquare , promotionDialogVariant: promotionDialogVariant  } = $700bf53ed0e34a6e$var$useChessboard();
    const backgroundColor = ()=>{
        switch(option[1]){
            case "Q":
                return customDarkSquareStyle.backgroundColor;
            case "R":
                return customLightSquareStyle.backgroundColor;
            case "N":
                return promotionDialogVariant === "default" ? customLightSquareStyle.backgroundColor : customDarkSquareStyle.backgroundColor;
            case "B":
                return promotionDialogVariant === "default" ? customDarkSquareStyle.backgroundColor : customLightSquareStyle.backgroundColor;
        }
    };
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        onClick: ()=>{
            if (onPromotionPieceSelect(option, promoteFromSquare !== null && promoteFromSquare !== void 0 ? promoteFromSquare : undefined, promoteToSquare !== null && promoteToSquare !== void 0 ? promoteToSquare : undefined)) handleSetPosition(promoteFromSquare, promoteToSquare, option, true);
        },
        onMouseOver: ()=>setIsHover(true),
        onMouseOut: ()=>setIsHover(false),
        "data-piece": option,
        style: {
            cursor: "pointer",
            backgroundColor: isHover ? backgroundColor() : `${backgroundColor()}aa`,
            borderRadius: "4px",
            transition: "all 0.1s ease-out"
        }
    }, {
        children: typeof chessPieces[option] === "function" ? (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: {
                transition: "all 0.1s ease-out",
                transform: isHover ? "scale(1)" : "scale(0.85)"
            }
        }, {
            children: chessPieces[option]({
                squareWidth: boardWidth / 8,
                isDragging: false
            })
        })) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: boardWidth / 8,
            height: boardWidth / 8,
            style: {
                transition: "all 0.1s ease-out",
                transform: isHover ? "scale(1)" : "scale(0.85)"
            }
        }, {
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                children: chessPieces[option]
            })
        }))
    }));
}
function $700bf53ed0e34a6e$var$PromotionDialog() {
    const { boardOrientation: boardOrientation , boardWidth: boardWidth , promotionDialogVariant: promotionDialogVariant , promoteToSquare: promoteToSquare  } = $700bf53ed0e34a6e$var$useChessboard();
    const promotePieceColor = (promoteToSquare === null || promoteToSquare === void 0 ? void 0 : promoteToSquare[1]) === "1" ? "b" : "w";
    const promotionOptions = [
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}Q`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}R`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}N`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}B`
    ];
    const dialogStyles = {
        default: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            transform: `translate(${-boardWidth / 8}px, ${-boardWidth / 8}px)`
        },
        vertical: {
            transform: `translate(${-boardWidth / 16}px, ${-boardWidth / 16}px)`
        },
        modal: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: `translate(0px, ${3 * boardWidth / 8}px)`,
            width: "100%",
            height: `${boardWidth / 4}px`,
            top: 0,
            backgroundColor: "white",
            left: 0
        }
    };
    const dialogCoords = $700bf53ed0e34a6e$var$getRelativeCoords(boardOrientation, boardWidth, promoteToSquare || "a8");
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        style: Object.assign({
            position: "absolute",
            top: `${dialogCoords === null || dialogCoords === void 0 ? void 0 : dialogCoords.y}px`,
            left: `${dialogCoords === null || dialogCoords === void 0 ? void 0 : dialogCoords.x}px`,
            zIndex: 1000
        }, dialogStyles[promotionDialogVariant]),
        title: "Choose promotion piece"
    }, {
        children: promotionOptions.map((option)=>(0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$PromotionOption, {
                option: option
            }, option))
    }));
}
const $700bf53ed0e34a6e$var$errorImage = {
    whiteKing: (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        style: {
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "crisp-edges"
        },
        viewBox: "0 0 4210 12970",
        x: "0px",
        y: "0px",
        fillRule: "evenodd",
        clipRule: "evenodd",
        width: "250",
        height: "250"
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
            children: (0, $d4dab640dcbe486c$exports.jsx)("path", {
                style: {
                    fill: "black",
                    fillRule: "nonzero"
                },
                d: "M2105 0c169,0 286,160 249,315l200 0c-172,266 -231,479 -256,792 315,-24 530,-86 792,-255l0 897c-265,-171 -479,-231 -792,-256 18,234 75,495 185,682l339 0c233,0 369,269 225,456l545 0 -595 1916c130,94 158,275 59,402 465,0 416,568 51,568l-334 0 465 2867 332 0c250,0 381,306 199,485 162,63 273,220 273,399l0 633 168 0 0 475c-1403,0 -2807,0 -4210,0l0 -475 167 0 0 -633c0,-179 112,-336 274,-399 -181,-178 -52,-485 199,-485l332 0 465 -2867 -335 0c-353,0 -418,-568 51,-568 -98,-127 -70,-308 59,-402l-594 -1916c181,0 363,0 545,0 -144,-187 -9,-456 225,-456l339 0c110,-187 167,-448 185,-682 -315,25 -530,87 -793,256l0 -897c266,171 480,231 793,255 -25,-315 -87,-529 -256,-792l199 0c-36,-155 81,-315 250,-315zm-1994 10012l0 253 3988 0 0 -253c-1330,0 -2659,0 -3988,0zm484 -1060c-174,0 -316,142 -316,316l0 633 3652 0 0 -633c0,-174 -142,-316 -316,-316 -1007,0 -2013,0 -3020,0zm45 -457c-230,0 -225,345 0,345l2930 0c230,0 225,-345 0,-345 -977,0 -1953,0 -2930,0zm2020 -2978l-1111 0 -465 2867 2041 0 -465 -2867zm-1558 -456c-229,0 -224,345 0,345 669,0 1337,0 2005,0 230,0 225,-345 0,-345 -668,0 -1336,0 -2005,0zm1730 -457l-1454 0c-229,0 -224,345 0,345l1454 0c229,0 224,-345 0,-345zm-2064 -1862l544 1751c529,0 1057,0 1586,0l544 -1751c-892,0 -1783,0 -2674,0zm1085 -567l504 0c-126,-247 -163,-526 -177,-800 273,15 553,52 800,177l0 -504c-247,126 -527,163 -800,177 14,-273 51,-552 177,-799 -168,0 -336,0 -504,0 125,247 162,526 177,799 -274,-14 -553,-51 -800,-177l0 504c247,-125 527,-162 800,-177 -15,274 -52,553 -177,800zm969 111l-1434 0c-230,0 -225,345 0,345l1434 0c230,0 225,-345 0,-345zm-717 -2175c-105,0 -175,109 -133,204l266 0c42,-96 -30,-205 -133,-204z"
            })
        })
    }))
};
function $700bf53ed0e34a6e$var$ErrorBoundary({ children: children  }) {
    try {
        return (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: children
        });
    } catch (error) {
        console.log(error);
        return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$WhiteKing, {
            showError: true
        });
    }
}
function $700bf53ed0e34a6e$var$WhiteKing({ showError: showError = false  }) {
    return (0, $d4dab640dcbe486c$exports.jsxs)("div", Object.assign({
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }
    }, {
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
                style: {
                    width: 250,
                    height: 250,
                    transform: "rotate(90deg)"
                }
            }, {
                children: $700bf53ed0e34a6e$var$errorImage.whiteKing
            })),
            showError && (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Something went wrong"
            })
        ]
    }));
}
function $700bf53ed0e34a6e$var$Board() {
    const boardRef = (0, $bh6RR.useRef)(null);
    const { boardWidth: boardWidth , clearCurrentRightClickDown: clearCurrentRightClickDown , onPromotionPieceSelect: onPromotionPieceSelect , setShowPromoteDialog: setShowPromoteDialog , showPromoteDialog: showPromoteDialog , customBoardStyle: customBoardStyle  } = $700bf53ed0e34a6e$var$useChessboard();
    (0, $bh6RR.useEffect)(()=>{
        function handleClickOutside(event) {
            if (boardRef.current && !boardRef.current.contains(event.target)) clearCurrentRightClickDown();
        }
        document.addEventListener("mouseup", handleClickOutside);
        return ()=>{
            document.removeEventListener("mouseup", handleClickOutside);
        };
    }, []);
    return boardWidth ? (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        style: {
            perspective: "1000px"
        }
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("div", Object.assign({
            ref: boardRef,
            style: Object.assign(Object.assign({
                position: "relative"
            }, $700bf53ed0e34a6e$var$boardStyles(boardWidth)), customBoardStyle)
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Squares, {}),
                (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Arrows, {}),
                showPromoteDialog && (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            onClick: ()=>{
                                setShowPromoteDialog(false);
                                onPromotionPieceSelect === null || onPromotionPieceSelect === void 0 || onPromotionPieceSelect();
                            },
                            style: {
                                position: "absolute",
                                top: "0",
                                left: "0",
                                zIndex: "100",
                                backgroundColor: "rgba(22,21,18,.7)",
                                width: boardWidth,
                                height: boardWidth
                            }
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$PromotionDialog, {})
                    ]
                })
            ]
        }))
    })) : (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$WhiteKing, {});
}
const $700bf53ed0e34a6e$var$boardStyles = (width)=>({
        cursor: "default",
        height: width,
        width: width
    });
var $700bf53ed0e34a6e$var$ListenerType;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})($700bf53ed0e34a6e$var$ListenerType || ($700bf53ed0e34a6e$var$ListenerType = {}));
class $700bf53ed0e34a6e$var$OptionsReader {
    get delay() {
        var _delay;
        return (_delay = this.args.delay) !== null && _delay !== void 0 ? _delay : 0;
    }
    get scrollAngleRanges() {
        return this.args.scrollAngleRanges;
    }
    get getDropTargetElementsAtPoint() {
        return this.args.getDropTargetElementsAtPoint;
    }
    get ignoreContextMenu() {
        var _ignoreContextMenu;
        return (_ignoreContextMenu = this.args.ignoreContextMenu) !== null && _ignoreContextMenu !== void 0 ? _ignoreContextMenu : false;
    }
    get enableHoverOutsideTarget() {
        var _enableHoverOutsideTarget;
        return (_enableHoverOutsideTarget = this.args.enableHoverOutsideTarget) !== null && _enableHoverOutsideTarget !== void 0 ? _enableHoverOutsideTarget : false;
    }
    get enableKeyboardEvents() {
        var _enableKeyboardEvents;
        return (_enableKeyboardEvents = this.args.enableKeyboardEvents) !== null && _enableKeyboardEvents !== void 0 ? _enableKeyboardEvents : false;
    }
    get enableMouseEvents() {
        var _enableMouseEvents;
        return (_enableMouseEvents = this.args.enableMouseEvents) !== null && _enableMouseEvents !== void 0 ? _enableMouseEvents : false;
    }
    get enableTouchEvents() {
        var _enableTouchEvents;
        return (_enableTouchEvents = this.args.enableTouchEvents) !== null && _enableTouchEvents !== void 0 ? _enableTouchEvents : true;
    }
    get touchSlop() {
        return this.args.touchSlop || 0;
    }
    get delayTouchStart() {
        var ref, ref1;
        var ref2, ref3;
        return (ref3 = (ref2 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayTouchStart) !== null && ref2 !== void 0 ? ref2 : (ref1 = this.args) === null || ref1 === void 0 ? void 0 : ref1.delay) !== null && ref3 !== void 0 ? ref3 : 0;
    }
    get delayMouseStart() {
        var ref, ref4;
        var ref5, ref6;
        return (ref6 = (ref5 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayMouseStart) !== null && ref5 !== void 0 ? ref5 : (ref4 = this.args) === null || ref4 === void 0 ? void 0 : ref4.delay) !== null && ref6 !== void 0 ? ref6 : 0;
    }
    get window() {
        if (this.context && this.context.window) return this.context.window;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : ref.document) return this.context.document;
        if (this.window) return this.window.document;
        return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.args) === null || ref === void 0 ? void 0 : ref.rootElement) || this.document;
    }
    constructor(args, context){
        this.args = args;
        this.context = context;
    }
}
function $700bf53ed0e34a6e$var$distance(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function $700bf53ed0e34a6e$var$inAngleRanges(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) return false;
    const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;
    for(let i = 0; i < angleRanges.length; ++i){
        const ar = angleRanges[i];
        if (ar && (ar.start == null || angle >= ar.start) && (ar.end == null || angle <= ar.end)) return true;
    }
    return false;
}
// Used for MouseEvent.buttons (note the s on the end).
const $700bf53ed0e34a6e$var$MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
};
// Used for e.button (note the lack of an s on the end).
const $700bf53ed0e34a6e$var$MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
};
/**
 * Only touch events and mouse events where the left button is pressed should initiate a drag.
 * @param {MouseEvent | TouchEvent} e The event
 */ function $700bf53ed0e34a6e$var$eventShouldStartDrag(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === $700bf53ed0e34a6e$var$MouseButton.Left;
}
/**
 * Only touch events and mouse events where the left mouse button is no longer held should end a drag.
 * It's possible the user mouse downs with the left mouse button, then mouse down and ups with the right mouse button.
 * We don't want releasing the right mouse button to end the drag.
 * @param {MouseEvent | TouchEvent} e The event
 */ function $700bf53ed0e34a6e$var$eventShouldEndDrag(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & $700bf53ed0e34a6e$var$MouseButtons.Left) === 0;
}
function $700bf53ed0e34a6e$var$isTouchEvent(e) {
    return !!e.targetTouches;
}
const $700bf53ed0e34a6e$var$ELEMENT_NODE = 1;
function $700bf53ed0e34a6e$var$getNodeClientOffset(node) {
    const el = node.nodeType === $700bf53ed0e34a6e$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return undefined;
    const { top: top , left: left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $700bf53ed0e34a6e$var$getEventClientTouchOffset(e, lastTargetTouchFallback) {
    if (e.targetTouches.length === 1) return $700bf53ed0e34a6e$var$getEventClientOffset(e.targetTouches[0]);
    else if (lastTargetTouchFallback && e.touches.length === 1) {
        if (e.touches[0].target === lastTargetTouchFallback.target) return $700bf53ed0e34a6e$var$getEventClientOffset(e.touches[0]);
    }
    return;
}
function $700bf53ed0e34a6e$var$getEventClientOffset(e, lastTargetTouchFallback) {
    if ($700bf53ed0e34a6e$var$isTouchEvent(e)) return $700bf53ed0e34a6e$var$getEventClientTouchOffset(e, lastTargetTouchFallback);
    else return {
        x: e.clientX,
        y: e.clientY
    };
}
const $700bf53ed0e34a6e$var$supportsPassive = (()=>{
    // simular to jQuery's test
    let supported = false;
    try {
        addEventListener("test", ()=>{
        // do nothing
        }, Object.defineProperty({}, "passive", {
            get () {
                supported = true;
                return true;
            }
        }));
    } catch (e) {
    // do nothing
    }
    return supported;
})();
const $700bf53ed0e34a6e$var$eventNames = {
    [$700bf53ed0e34a6e$var$ListenerType.mouse]: {
        start: "mousedown",
        move: "mousemove",
        end: "mouseup",
        contextmenu: "contextmenu"
    },
    [$700bf53ed0e34a6e$var$ListenerType.touch]: {
        start: "touchstart",
        move: "touchmove",
        end: "touchend"
    },
    [$700bf53ed0e34a6e$var$ListenerType.keyboard]: {
        keydown: "keydown"
    }
};
class $700bf53ed0e34a6e$var$TouchBackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref;
        return {
            sourceNodes: this.sourceNodes.size,
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            targetNodes: this.targetNodes.size,
            dragOverTargetIds: ((ref = this.dragOverTargetIds) === null || ref === void 0 ? void 0 : ref.length) || 0
        };
    }
    // public for test
    get document() {
        return this.options.document;
    }
    setup() {
        const root = this.options.rootElement;
        if (!root) return;
        $700bf53ed0e34a6e$var$invariant(!$700bf53ed0e34a6e$var$TouchBackendImpl.isSetUp, "Cannot have two Touch backends at the same time.");
        $700bf53ed0e34a6e$var$TouchBackendImpl.isSetUp = true;
        this.addEventListener(root, "start", this.getTopMoveStartHandler());
        this.addEventListener(root, "start", this.handleTopMoveStartCapture, true);
        this.addEventListener(root, "move", this.handleTopMove);
        this.addEventListener(root, "move", this.handleTopMoveCapture, true);
        this.addEventListener(root, "end", this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.addEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.addEventListener(root, "keydown", this.handleCancelOnEscape, true);
    }
    teardown() {
        const root = this.options.rootElement;
        if (!root) return;
        $700bf53ed0e34a6e$var$TouchBackendImpl.isSetUp = false;
        this._mouseClientOffset = {};
        this.removeEventListener(root, "start", this.handleTopMoveStartCapture, true);
        this.removeEventListener(root, "start", this.handleTopMoveStart);
        this.removeEventListener(root, "move", this.handleTopMoveCapture, true);
        this.removeEventListener(root, "move", this.handleTopMove);
        this.removeEventListener(root, "end", this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.removeEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.removeEventListener(root, "keydown", this.handleCancelOnEscape, true);
        this.uninstallSourceNodeRemovalObserver();
    }
    addEventListener(subject, event, handler, capture = false) {
        const options = $700bf53ed0e34a6e$var$supportsPassive ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $700bf53ed0e34a6e$var$eventNames[listenerType][event];
            if (evt) subject.addEventListener(evt, handler, options);
        });
    }
    removeEventListener(subject, event, handler, capture = false) {
        const options = $700bf53ed0e34a6e$var$supportsPassive ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $700bf53ed0e34a6e$var$eventNames[listenerType][event];
            if (evt) subject.removeEventListener(evt, handler, options);
        });
    }
    connectDragSource(sourceId, node) {
        const handleMoveStart = this.handleMoveStart.bind(this, sourceId);
        this.sourceNodes.set(sourceId, node);
        this.addEventListener(node, "start", handleMoveStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.removeEventListener(node, "start", handleMoveStart);
        };
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDropTarget(targetId, node) {
        const root = this.options.rootElement;
        if (!this.document || !root) return ()=>{
        /* noop */ };
        const handleMove = (e)=>{
            if (!this.document || !root || !this.monitor.isDragging()) return;
            let coords;
            /**
			 * Grab the coordinates for the current mouse/touch position
			 */ switch(e.type){
                case $700bf53ed0e34a6e$var$eventNames.mouse.move:
                    coords = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    break;
                case $700bf53ed0e34a6e$var$eventNames.touch.move:
                    var ref, ref1;
                    coords = {
                        x: ((ref = e.touches[0]) === null || ref === void 0 ? void 0 : ref.clientX) || 0,
                        y: ((ref1 = e.touches[0]) === null || ref1 === void 0 ? void 0 : ref1.clientY) || 0
                    };
                    break;
            }
            /**
			 * Use the coordinates to grab the element the drag ended on.
			 * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
			 */ const droppedOn = coords != null ? this.document.elementFromPoint(coords.x, coords.y) : undefined;
            const childMatch = droppedOn && node.contains(droppedOn);
            if (droppedOn === node || childMatch) return this.handleMove(e, targetId);
        };
        /**
		 * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
		 */ this.addEventListener(this.document.body, "move", handleMove);
        this.targetNodes.set(targetId, node);
        return ()=>{
            if (this.document) {
                this.targetNodes.delete(targetId);
                this.removeEventListener(this.document.body, "move", handleMove);
            }
        };
    }
    getTopMoveStartHandler() {
        if (!this.options.delayTouchStart && !this.options.delayMouseStart) return this.handleTopMoveStart;
        return this.handleTopMoveStartDelay;
    }
    installSourceNodeRemovalObserver(node) {
        this.uninstallSourceNodeRemovalObserver();
        this.draggedSourceNode = node;
        this.draggedSourceNodeRemovalObserver = new MutationObserver(()=>{
            if (node && !node.parentElement) {
                this.resurrectSourceNode();
                this.uninstallSourceNodeRemovalObserver();
            }
        });
        if (!node || !node.parentElement) return;
        this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
            childList: true
        });
    }
    resurrectSourceNode() {
        if (this.document && this.draggedSourceNode) {
            this.draggedSourceNode.style.display = "none";
            this.draggedSourceNode.removeAttribute("data-reactid");
            this.document.body.appendChild(this.draggedSourceNode);
        }
    }
    uninstallSourceNodeRemovalObserver() {
        if (this.draggedSourceNodeRemovalObserver) this.draggedSourceNodeRemovalObserver.disconnect();
        this.draggedSourceNodeRemovalObserver = undefined;
        this.draggedSourceNode = undefined;
    }
    constructor(manager, context, options){
        this.getSourceClientOffset = (sourceId)=>{
            const element = this.sourceNodes.get(sourceId);
            return element && $700bf53ed0e34a6e$var$getNodeClientOffset(element);
        };
        this.handleTopMoveStartCapture = (e)=>{
            if (!$700bf53ed0e34a6e$var$eventShouldStartDrag(e)) return;
            this.moveStartSourceIds = [];
        };
        this.handleMoveStart = (sourceId)=>{
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(this.moveStartSourceIds)) this.moveStartSourceIds.unshift(sourceId);
        };
        this.handleTopMoveStart = (e)=>{
            if (!$700bf53ed0e34a6e$var$eventShouldStartDrag(e)) return;
            // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link
            const clientOffset = $700bf53ed0e34a6e$var$getEventClientOffset(e);
            if (clientOffset) {
                if ($700bf53ed0e34a6e$var$isTouchEvent(e)) this.lastTargetTouchFallback = e.targetTouches[0];
                this._mouseClientOffset = clientOffset;
            }
            this.waitingForDelay = false;
        };
        this.handleTopMoveStartDelay = (e)=>{
            if (!$700bf53ed0e34a6e$var$eventShouldStartDrag(e)) return;
            const delay = e.type === $700bf53ed0e34a6e$var$eventNames.touch.start ? this.options.delayTouchStart : this.options.delayMouseStart;
            this.timeout = setTimeout(this.handleTopMoveStart.bind(this, e), delay);
            this.waitingForDelay = true;
        };
        this.handleTopMoveCapture = ()=>{
            this.dragOverTargetIds = [];
        };
        this.handleMove = (_evt, targetId)=>{
            if (this.dragOverTargetIds) this.dragOverTargetIds.unshift(targetId);
        };
        this.handleTopMove = (e1)=>{
            if (this.timeout) clearTimeout(this.timeout);
            if (!this.document || this.waitingForDelay) return;
            const { moveStartSourceIds: moveStartSourceIds , dragOverTargetIds: dragOverTargetIds  } = this;
            const enableHoverOutsideTarget = this.options.enableHoverOutsideTarget;
            const clientOffset = $700bf53ed0e34a6e$var$getEventClientOffset(e1, this.lastTargetTouchFallback);
            if (!clientOffset) return;
            // If the touch move started as a scroll, or is is between the scroll angles
            if (this._isScrolling || !this.monitor.isDragging() && $700bf53ed0e34a6e$var$inAngleRanges(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, this.options.scrollAngleRanges)) {
                this._isScrolling = true;
                return;
            }
            // If we're not dragging and we've moved a little, that counts as a drag start
            if (!this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
            this._mouseClientOffset.hasOwnProperty("x") && moveStartSourceIds && $700bf53ed0e34a6e$var$distance(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (this.options.touchSlop ? this.options.touchSlop : 0)) {
                this.moveStartSourceIds = undefined;
                this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: this._mouseClientOffset,
                    getSourceClientOffset: this.getSourceClientOffset,
                    publishSource: false
                });
            }
            if (!this.monitor.isDragging()) return;
            const sourceNode = this.sourceNodes.get(this.monitor.getSourceId());
            this.installSourceNodeRemovalObserver(sourceNode);
            this.actions.publishDragSource();
            if (e1.cancelable) e1.preventDefault();
            // Get the node elements of the hovered DropTargets
            const dragOverTargetNodes = (dragOverTargetIds || []).map((key)=>this.targetNodes.get(key)).filter((e)=>!!e);
            // Get the a ordered list of nodes that are touched by
            const elementsAtPoint = this.options.getDropTargetElementsAtPoint ? this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : this.document.elementsFromPoint(clientOffset.x, clientOffset.y);
            // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)
            const elementsAtPointExtended = [];
            for(const nodeId in elementsAtPoint){
                // eslint-disable-next-line no-prototype-builtins
                if (!elementsAtPoint.hasOwnProperty(nodeId)) continue;
                let currentNode = elementsAtPoint[nodeId];
                if (currentNode != null) elementsAtPointExtended.push(currentNode);
                while(currentNode){
                    currentNode = currentNode.parentElement;
                    if (currentNode && elementsAtPointExtended.indexOf(currentNode) === -1) elementsAtPointExtended.push(currentNode);
                }
            }
            const orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
            .filter((node)=>dragOverTargetNodes.indexOf(node) > -1) // Map back the nodes elements to targetIds
            .map((node)=>this._getDropTargetId(node)) // Filter off possible null rows
            .filter((node)=>!!node).filter((id, index, ids)=>ids.indexOf(id) === index);
            // Invoke hover for drop targets when source node is still over and pointer is outside
            if (enableHoverOutsideTarget) for(const targetId in this.targetNodes){
                const targetNode = this.targetNodes.get(targetId);
                if (sourceNode && targetNode && targetNode.contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
                    orderedDragOverTargetIds.unshift(targetId);
                    break;
                }
            }
            // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();
            this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        };
        /**
	 *
	 * visible for testing
	 */ this._getDropTargetId = (node)=>{
            const keys = this.targetNodes.keys();
            let next = keys.next();
            while(next.done === false){
                const targetId = next.value;
                if (node === this.targetNodes.get(targetId)) return targetId;
                else next = keys.next();
            }
            return undefined;
        };
        this.handleTopMoveEndCapture = (e)=>{
            this._isScrolling = false;
            this.lastTargetTouchFallback = undefined;
            if (!$700bf53ed0e34a6e$var$eventShouldEndDrag(e)) return;
            if (!this.monitor.isDragging() || this.monitor.didDrop()) {
                this.moveStartSourceIds = undefined;
                return;
            }
            if (e.cancelable) e.preventDefault();
            this._mouseClientOffset = {};
            this.uninstallSourceNodeRemovalObserver();
            this.actions.drop();
            this.actions.endDrag();
        };
        this.handleCancelOnEscape = (e)=>{
            if (e.key === "Escape" && this.monitor.isDragging()) {
                this._mouseClientOffset = {};
                this.uninstallSourceNodeRemovalObserver();
                this.actions.endDrag();
            }
        };
        this.options = new $700bf53ed0e34a6e$var$OptionsReader(options, context);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.sourceNodes = new Map();
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.targetNodes = new Map();
        this.listenerTypes = [];
        this._mouseClientOffset = {};
        this._isScrolling = false;
        if (this.options.enableMouseEvents) this.listenerTypes.push($700bf53ed0e34a6e$var$ListenerType.mouse);
        if (this.options.enableTouchEvents) this.listenerTypes.push($700bf53ed0e34a6e$var$ListenerType.touch);
        if (this.options.enableKeyboardEvents) this.listenerTypes.push($700bf53ed0e34a6e$var$ListenerType.keyboard);
    }
}
const $700bf53ed0e34a6e$var$TouchBackend = function createBackend(manager, context = {}, options = {}) {
    return new $700bf53ed0e34a6e$var$TouchBackendImpl(manager, context, options);
};
const $700bf53ed0e34a6e$var$ChessboardDnDContext = (0, $bh6RR.createContext)({
    isCustomDndProviderSet: false
});
const $700bf53ed0e34a6e$var$EmptyProvider = ({ children: children  })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: children
    });
};
const $700bf53ed0e34a6e$export$5058efb00df7de8c = ({ children: children , backend: backend , context: context , options: options , debugMode: debugMode  })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ChessboardDnDContext.Provider, Object.assign({
        value: {
            isCustomDndProviderSet: true
        }
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$DndProvider, Object.assign({
            backend: backend || ("ontouchstart" in window ? $700bf53ed0e34a6e$var$TouchBackend : $700bf53ed0e34a6e$var$HTML5Backend),
            context: context,
            options: options,
            debugMode: debugMode !== null && debugMode !== void 0 ? debugMode : false
        }, {
            children: children
        }))
    }));
};
const $700bf53ed0e34a6e$var$ChessboardDnDRoot = ({ customDndBackend: customDndBackend , customDndBackendOptions: customDndBackendOptions , children: children  })=>{
    const [clientWindow, setClientWindow] = (0, $bh6RR.useState)();
    const [backendSet, setBackendSet] = (0, $bh6RR.useState)(false);
    const [isMobile, setIsMobile] = (0, $bh6RR.useState)(false);
    const { isCustomDndProviderSet: isCustomDndProviderSet  } = (0, $bh6RR.useContext)($700bf53ed0e34a6e$var$ChessboardDnDContext);
    (0, $bh6RR.useEffect)(()=>{
        setIsMobile("ontouchstart" in window);
        setBackendSet(true);
        setClientWindow(window);
    }, []);
    // in case we already wrapped `<Chessboard/>`  with `<DnDProvider/>` we don't need to create a new one
    const DnDWrapper = isCustomDndProviderSet ? $700bf53ed0e34a6e$var$EmptyProvider : $700bf53ed0e34a6e$var$DndProvider;
    if (!backendSet) return null;
    return clientWindow ? (0, $d4dab640dcbe486c$exports.jsx)(DnDWrapper, Object.assign({
        backend: customDndBackend || (isMobile ? $700bf53ed0e34a6e$var$TouchBackend : $700bf53ed0e34a6e$var$HTML5Backend),
        context: clientWindow,
        options: customDndBackend ? customDndBackendOptions : undefined
    }, {
        children: children
    })) : (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: children
    });
};
function $700bf53ed0e34a6e$var$CustomDragLayer({ boardContainer: boardContainer  }) {
    const { boardWidth: boardWidth , chessPieces: chessPieces , id: id , snapToCursor: snapToCursor , allowDragOutsideBoard: allowDragOutsideBoard  } = $700bf53ed0e34a6e$var$useChessboard();
    const collectedProps = $700bf53ed0e34a6e$var$useDragLayer((monitor)=>({
            item: monitor.getItem(),
            clientOffset: monitor.getClientOffset(),
            sourceClientOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging()
        }));
    const { isDragging: isDragging , item: item , clientOffset: clientOffset , sourceClientOffset: sourceClientOffset  } = collectedProps;
    const getItemStyle = (0, $bh6RR.useCallback)((clientOffset, sourceClientOffset)=>{
        if (!clientOffset || !sourceClientOffset) return {
            display: "none"
        };
        let { x: x , y: y  } = snapToCursor ? clientOffset : sourceClientOffset;
        const halfSquareWidth = boardWidth / 8 / 2;
        if (snapToCursor) {
            x -= halfSquareWidth;
            y -= halfSquareWidth;
        }
        if (!allowDragOutsideBoard) {
            const { left: left , top: top  } = boardContainer;
            // half square so the piece reaches the board
            const maxLeft = left - halfSquareWidth;
            const maxTop = top - halfSquareWidth;
            const maxRight = left + boardWidth - halfSquareWidth;
            const maxBottom = top + boardWidth - halfSquareWidth;
            x = Math.max(maxLeft, Math.min(x, maxRight));
            y = Math.max(maxTop, Math.min(y, maxBottom));
        }
        const transform = `translate(${x}px, ${y}px)`;
        return {
            transform: transform,
            WebkitTransform: transform,
            touchAction: "none"
        };
    }, [
        boardWidth,
        allowDragOutsideBoard,
        snapToCursor,
        boardContainer
    ]);
    return isDragging && item.id === id ? (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        style: {
            position: "fixed",
            pointerEvents: "none",
            zIndex: 10,
            left: 0,
            top: 0
        }
    }, {
        children: (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
            style: getItemStyle(clientOffset, sourceClientOffset)
        }, {
            children: typeof chessPieces[item.piece] === "function" ? chessPieces[item.piece]({
                squareWidth: boardWidth / 8,
                isDragging: true
            }) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
                viewBox: "1 1 43 43",
                width: boardWidth / 8,
                height: boardWidth / 8
            }, {
                children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    children: chessPieces[item.piece]
                })
            }))
        }))
    })) : null;
}
const $700bf53ed0e34a6e$export$10d0f5ecf473d343 = ({ piece: piece , width: width , customPieceJSX: customPieceJSX , dndId: dndId  })=>{
    const renderPiece = customPieceJSX !== null && customPieceJSX !== void 0 ? customPieceJSX : $700bf53ed0e34a6e$var$defaultPieces[piece];
    const [{ canDrag: canDrag , isDragging: isDragging  }, drag, dragPreview] = $700bf53ed0e34a6e$var$useDrag(()=>({
            type: "piece",
            item: ()=>{
                return {
                    piece: piece,
                    isSpare: true,
                    id: dndId
                };
            },
            collect: (monitor)=>({
                    canDrag: true,
                    isDragging: !!monitor.isDragging()
                })
        }), [
        piece,
        dndId
    ]);
    // hide the default preview
    dragPreview($700bf53ed0e34a6e$var$getEmptyImage(), {
        captureDraggingState: true
    });
    return (0, $d4dab640dcbe486c$exports.jsx)("div", Object.assign({
        ref: canDrag ? drag : null,
        "data-piece": piece,
        style: {
            cursor: "move"
        }
    }, {
        children: typeof renderPiece === "function" ? renderPiece({
            squareWidth: width,
            isDragging: isDragging
        }) : (0, $d4dab640dcbe486c$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: width,
            height: width
        }, {
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                children: renderPiece
            })
        }))
    }));
};
const $700bf53ed0e34a6e$export$2b996ae5040ad8f1 = (0, $bh6RR.forwardRef)((props, ref)=>{
    const { customDndBackend: customDndBackend , customDndBackendOptions: customDndBackendOptions , onBoardWidthChange: onBoardWidthChange  } = props, otherProps = $700bf53ed0e34a6e$var$__rest(props, [
        "customDndBackend",
        "customDndBackendOptions",
        "onBoardWidthChange"
    ]);
    const [boardWidth, setBoardWidth] = (0, $bh6RR.useState)(props.boardWidth);
    const boardRef = (0, $bh6RR.useRef)(null);
    const boardContainerRef = (0, $bh6RR.useRef)(null);
    const [boardContainerPos, setBoardContainerPos] = (0, $bh6RR.useState)({
        left: 0,
        top: 0
    });
    const metrics = (0, $bh6RR.useMemo)(()=>{
        var _a;
        return (_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    }, [
        boardRef.current
    ]);
    (0, $bh6RR.useEffect)(()=>{
        boardWidth && (onBoardWidthChange === null || onBoardWidthChange === void 0 || onBoardWidthChange(boardWidth));
    }, [
        boardWidth
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setBoardContainerPos({
            left: (metrics === null || metrics === void 0 ? void 0 : metrics.left) ? metrics === null || metrics === void 0 ? void 0 : metrics.left : 0,
            top: (metrics === null || metrics === void 0 ? void 0 : metrics.top) ? metrics === null || metrics === void 0 ? void 0 : metrics.top : 0
        });
    }, [
        metrics
    ]);
    (0, $bh6RR.useEffect)(()=>{
        var _a;
        if (props.boardWidth === undefined && ((_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)) {
            const resizeObserver = new ResizeObserver(()=>{
                var _a;
                setBoardWidth((_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
            });
            resizeObserver.observe(boardRef.current);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        boardRef.current
    ]);
    return (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ErrorBoundary, {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("div", Object.assign({
            ref: boardContainerRef,
            style: {
                display: "flex",
                flexDirection: "column",
                width: "100%"
            }
        }, {
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    ref: boardRef,
                    style: {
                        width: "100%"
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$ChessboardDnDRoot, Object.assign({
                    customDndBackend: customDndBackend,
                    customDndBackendOptions: customDndBackendOptions
                }, {
                    children: boardWidth && (0, $d4dab640dcbe486c$exports.jsxs)($700bf53ed0e34a6e$var$ChessboardProvider, Object.assign({
                        boardWidth: boardWidth
                    }, otherProps, {
                        ref: ref
                    }, {
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$CustomDragLayer, {
                                boardContainer: boardContainerPos
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)($700bf53ed0e34a6e$var$Board, {})
                        ]
                    }))
                }))
            ]
        }))
    });
});




const $4e5ef8436bf532a5$var$START_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
function $4e5ef8436bf532a5$var$ChessBoardWrapper() {
    const { fen: fen , makeMove: makeMove , makeTrainingMove: makeTrainingMove , currentRepertoireId: currentRepertoireId , currentMode: currentMode , trainingState: trainingState , currentNode: currentNode , boardOrientation: boardOrientation , toggleBoardOrientation: toggleBoardOrientation , highlightedSquares: highlightedSquares , customArrows: customArrows , showHint: showHint , startTraining: startTraining , stopTraining: stopTraining  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    function onDrop(sourceSquare, targetSquare) {
        if (!currentRepertoireId) {
            alert("Please select or create a repertoire first.");
            return false;
        }
        if (currentMode === "trainer" && trainingState.isActive) {
            const chessTurn = fen.includes(" w ") ? "white" : "black";
            const userColor = trainingState.userColor;
            if (chessTurn !== userColor) return false;
            const move = makeTrainingMove({
                from: sourceSquare,
                to: targetSquare
            });
            if (move === null) return false;
            return true;
        } else {
            const move = makeMove({
                from: sourceSquare,
                to: targetSquare
            });
            if (move === null) return false;
            return true;
        }
    }
    const isUserTurn = ()=>{
        if (!trainingState.isActive) return false;
        const chessTurn = fen.includes(" w ") ? "white" : "black";
        return chessTurn === trainingState.userColor;
    };
    const userTurn = isUserTurn();
    const [toastDismissed, setToastDismissed] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const isFirstMoveAsWhite = trainingState.isActive && trainingState.userColor === "white" && fen === $4e5ef8436bf532a5$var$START_FEN;
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setToastDismissed(false);
    }, [
        trainingState.isActive
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$BoardContainer, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$BoardHeader, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$FlipButton, {
                    onClick: toggleBoardOrientation,
                    children: boardOrientation === "white" ? "View from black" : "View from white"
                })
            }),
            !currentRepertoireId && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$NoRepertoireBox, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$NoRepertoireText, {
                        children: "Welcome to the study board"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$NoRepertoireSubtext, {
                        children: "Create your first repertoire or select an existing one to start building your opening knowledge"
                    })
                ]
            }),
            currentMode === "trainer" && isFirstMoveAsWhite && !toastDismissed && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$FirstMoveToast, {
                children: [
                    "Your move",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$ToastDismiss, {
                        onClick: ()=>setToastDismissed(true),
                        children: "\xd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$BoardWithSide, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $700bf53ed0e34a6e$export$2b996ae5040ad8f1), {
                        id: "RepertoireBoard",
                        position: fen || $4e5ef8436bf532a5$var$START_FEN,
                        boardOrientation: boardOrientation,
                        onPieceDrop: onDrop,
                        customSquareStyles: highlightedSquares,
                        customArrows: customArrows,
                        customDarkSquareStyle: {
                            backgroundColor: "#D97757"
                        },
                        customLightSquareStyle: {
                            backgroundColor: "#FFF5EB"
                        },
                        customBoardStyle: {
                            borderRadius: "4px",
                            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)"
                        },
                        customDropSquareStyle: {
                            boxShadow: "inset 0 0 0 3px rgba(193, 95, 60, 0.4)"
                        },
                        customPremoveDarkSquareStyle: {
                            backgroundColor: "#C46B4F"
                        },
                        customPremoveLightSquareStyle: {
                            backgroundColor: "#FFE8D6"
                        }
                    }),
                    currentMode === "trainer" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$SidePanel, {
                        children: [
                            trainingState.isActive && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$SideButton, {
                                onClick: showHint,
                                disabled: !trainingState.nextMove,
                                title: "Show hint for next move",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$SideEmoji, {
                                        children: "\uD83D\uDE48"
                                    }),
                                    "Reveal",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                    "hint"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$SideButton, {
                                onClick: trainingState.isActive ? stopTraining : ()=>startTraining(boardOrientation),
                                $secondary: trainingState.isActive,
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$SideEmoji, {
                                        children: trainingState.isActive ? "\uD83D\uDED1" : "\uD83D\uDEA6"
                                    }),
                                    trainingState.isActive ? "Stop" : "Begin"
                                ]
                            })
                        ]
                    })
                ]
            }),
            currentMode === "trainer" && trainingState.isActive && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$TrainingInfoBox, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$TrainingProgress, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$ProgressBar, {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$ProgressFill, {
                                    $progress: trainingState.progress
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($4e5ef8436bf532a5$var$ProgressText, {
                                children: [
                                    trainingState.progress,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    currentNode && currentNode.comment && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e5ef8436bf532a5$var$PositionNote, {
                        children: currentNode.comment
                    })
                ]
            })
        ]
    });
}
var $4e5ef8436bf532a5$export$2e2bcd8739ae039 = $4e5ef8436bf532a5$var$ChessBoardWrapper;
const $4e5ef8436bf532a5$var$BoardContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 98vh;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $4e5ef8436bf532a5$var$BoardWithSide = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;
const $4e5ef8436bf532a5$var$SidePanel = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $4e5ef8436bf532a5$var$SideButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 14px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  cursor: pointer;
  color: ${(props)=>props.$secondary ? "var(--text-soft)" : "var(--accent-strong)"};
  background: var(--surface-strong);
  border: 1px solid rgba(159, 109, 76, 0.18);
  border-radius: 16px;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  &:hover:not(:disabled) {
    background: var(--accent-ghost);
    transform: translateY(-1px);
    box-shadow: 0 14px 26px rgba(86, 62, 43, 0.16);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background-color: rgba(255, 249, 241, 0.75);
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
const $4e5ef8436bf532a5$var$SideEmoji = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  font-size: 1.64rem;
  line-height: 1;
  margin-bottom: 4px;
`;
const $4e5ef8436bf532a5$var$BoardHeader = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
`;
const $4e5ef8436bf532a5$var$FlipButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 11px 18px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  color: var(--accent-strong);
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: 999px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent-ghost);
    transform: translateY(-1px);
    box-shadow: 0 12px 24px rgba(86, 62, 43, 0.12);
  }

  &:active {
    transform: translateY(0);
  }
`;
const $4e5ef8436bf532a5$var$TrainingInfoBox = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 14px 18px;
  box-sizing: border-box;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: var(--shadow-md);
`;
const $4e5ef8436bf532a5$var$TrainingProgress = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-bottom: 4px;
`;
const $4e5ef8436bf532a5$var$ProgressBar = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  width: 100%;
  margin: 0 auto 6px;
  height: 8px;
  background-color: var(--accent-soft);
  border-radius: 999px;
  overflow: hidden;
`;
const $4e5ef8436bf532a5$var$ProgressFill = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  height: 100%;
  background: var(--accent);
  width: ${(props)=>props.$progress}%;
  transition: width 0.3s ease;
`;
const $4e5ef8436bf532a5$var$ProgressText = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  text-align: center;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-soft);
`;
const $4e5ef8436bf532a5$var$FirstMoveToast = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 16px;
  font-size: 0.82rem;
  color: var(--text-soft);
  background: rgba(255, 249, 241, 0.92);
  border: 1px dashed rgba(139, 90, 43, 0.3);
  border-radius: 999px;
  align-self: center;
`;
const $4e5ef8436bf532a5$var$ToastDismiss = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-faint);
  font-size: 1rem;
  line-height: 1;
  padding: 0 2px;

  &:hover {
    color: var(--text-soft);
  }
`;
const $4e5ef8436bf532a5$var$PositionNote = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  text-align: center;
  font-size: 0.84rem;
  color: var(--text-soft);
  margin-top: 12px;
  padding: 10px 12px;
  background-color: rgba(255, 249, 241, 0.8);
  border: 1px solid var(--border);
  border-radius: 14px;
`;
const $4e5ef8436bf532a5$var$NoRepertoireBox = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  width: 100%;
  min-height: 110px;
  padding: 18px;
  box-sizing: border-box;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: var(--shadow-md);
`;
const $4e5ef8436bf532a5$var$NoRepertoireText = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h3`
  margin-bottom: 8px;
  color: var(--text);
`;
const $4e5ef8436bf532a5$var$NoRepertoireSubtext = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  font-size: 0.9rem;
  color: var(--text-soft);
  max-width: 30ch;
`;






var $bh6RR = parcelRequire("bh6RR");


function $027cd14b0d670db0$var$PgnViewer() {
    const { pgnTreeRoot: pgnTreeRoot , currentNode: currentNode , navigateToNode: navigateToNode , repertoires: repertoires , currentRepertoireId: currentRepertoireId , currentMode: currentMode , deleteMove: deleteMove  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [contextMenu, setContextMenu] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({
        visible: false,
        x: 0,
        y: 0,
        targetNode: null,
        isDeleting: false
    });
    const currentRepertoire = repertoires.find((r)=>r.id === currentRepertoireId);
    const handleContextMenu = (event, node)=>{
        event.preventDefault();
        const x = Math.min(event.clientX, window.innerWidth - 160);
        const y = Math.min(event.clientY, window.innerHeight - 50);
        const finalX = x > 0 ? x : window.innerWidth / 2;
        const finalY = y > 0 ? y : window.innerHeight / 2;
        setContextMenu({
            visible: true,
            x: finalX,
            y: finalY,
            targetNode: node,
            isDeleting: false
        });
    };
    const handleDeleteMove = async ()=>{
        if (contextMenu.targetNode) {
            setContextMenu((prev)=>({
                    ...prev,
                    isDeleting: true
                }));
            const success = await deleteMove(contextMenu.targetNode);
            if (!success) {
                console.error("Failed to delete move");
                alert("Failed to delete move. Cannot delete the root position.");
            }
        }
        setContextMenu({
            visible: false,
            x: 0,
            y: 0,
            targetNode: null,
            isDeleting: false
        });
    };
    const handleClickOutside = (event)=>{
        if (event.target.closest("[data-context-menu]")) return;
        setContextMenu({
            visible: false,
            x: 0,
            y: 0,
            targetNode: null,
            isDeleting: false
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (contextMenu.visible) {
            const timeoutId = setTimeout(()=>{
                document.addEventListener("click", handleClickOutside);
            }, 100);
            return ()=>{
                clearTimeout(timeoutId);
                document.removeEventListener("click", handleClickOutside);
            };
        }
    }, [
        contextMenu.visible
    ]);
    const renderLine = (startNode, isFirstMoveOfVariation = false)=>{
        const elements = [];
        let tempNode = startNode;
        let isStart = isFirstMoveOfVariation;
        while(tempNode){
            const nodeForClick = tempNode;
            const move = nodeForClick.move;
            let moveStr = "";
            if (move.color === "w") moveStr += `${nodeForClick.moveNumber}. `;
            else if (isStart) moveStr += `${nodeForClick.moveNumber}... `;
            elements.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($027cd14b0d670db0$var$Move, {
                $active: nodeForClick === currentNode,
                onClick: ()=>navigateToNode(nodeForClick),
                onContextMenu: (e)=>handleContextMenu(e, nodeForClick),
                title: nodeForClick.comment || undefined,
                children: [
                    moveStr,
                    move.san,
                    nodeForClick.comment && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$NoteIndicator, {
                        children: "*"
                    })
                ]
            }, nodeForClick.fen));
            const variations = nodeForClick.children.slice(1);
            if (variations.length > 0) variations.forEach((varNode)=>{
                elements.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$VariationMarker, {
                    children: "("
                }, `var-start-${varNode.fen}`));
                elements.push(...renderLine(varNode, true));
                elements.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$VariationMarker, {
                    children: ")"
                }, `var-end-${varNode.fen}`));
            });
            tempNode = nodeForClick.children[0];
            isStart = false;
        }
        return elements;
    };
    const renderPgn = ()=>{
        if (!pgnTreeRoot || pgnTreeRoot.children.length === 0) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$EmptyState, {
            children: "Make a move on the board to start."
        });
        const elements = [];
        if (pgnTreeRoot.children[0]) elements.push(...renderLine(pgnTreeRoot.children[0], false));
        const startVariations = pgnTreeRoot.children.slice(1);
        if (startVariations.length > 0) startVariations.forEach((varNode)=>{
            elements.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}, `br-${varNode.fen}`));
            elements.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$VariationMarker, {
                children: "["
            }, `var-start-root-${varNode.fen}`));
            elements.push(...renderLine(varNode, false));
            elements.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$VariationMarker, {
                children: "]"
            }, `var-end-root-${varNode.fen}`));
        });
        return elements.map((el, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                children: [
                    el,
                    " "
                ]
            }, el.key || i));
    };
    if (currentMode === "trainer") return null;
    if (!currentRepertoire) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$ViewerWrapper, {
        children: "Please select a repertoire."
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($027cd14b0d670db0$var$ViewerWrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($027cd14b0d670db0$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                        children: currentRepertoire.name
                    }),
                    pgnTreeRoot.comment && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$RootNote, {
                        children: pgnTreeRoot.comment
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$MovesContainer, {
                children: renderPgn()
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$Footer, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$CommentArea, {
                    children: currentNode && currentNode.comment ? currentNode.comment : "Choose a move to review its note."
                })
            }),
            contextMenu.visible && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$ContextMenu, {
                "data-context-menu": true,
                style: {
                    left: contextMenu.x,
                    top: contextMenu.y
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($027cd14b0d670db0$var$ContextMenuItem, {
                    onClick: handleDeleteMove,
                    disabled: contextMenu.isDeleting,
                    children: contextMenu.isDeleting ? "Deleting move..." : "Delete move"
                })
            })
        ]
    });
}
var $027cd14b0d670db0$export$2e2bcd8739ae039 = $027cd14b0d670db0$var$PgnViewer;
const $027cd14b0d670db0$var$ViewerWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding: 22px;
  border: 1px solid var(--border);
  border-radius: 26px;
  background: var(--surface);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  box-shadow: var(--shadow-md);
`;
const $027cd14b0d670db0$var$Header = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
`;
const $027cd14b0d670db0$var$MovesContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  font-family: 'Noto Serif JP', serif;
  line-height: 2;
  white-space: pre-wrap;
  overflow-y: auto;
  color: var(--text-soft);
  font-size: 1.02rem;
`;
const $027cd14b0d670db0$var$Move = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 8px;
  transition:
    background 0.2s ease,
    color 0.2s ease;

  &:hover {
    background-color: rgba(159, 109, 76, 0.1);
    color: var(--text);
  }

  ${(props)=>props.$active && `
    background-color: var(--accent-soft);
    color: var(--accent-strong);
    font-weight: bold;
  `}
`;
const $027cd14b0d670db0$var$VariationMarker = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  color: var(--text-faint);
`;
const $027cd14b0d670db0$var$EmptyState = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  color: var(--text-faint);
  font-style: italic;
`;
const $027cd14b0d670db0$var$Footer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
`;
const $027cd14b0d670db0$var$CommentArea = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  font-size: 0.9rem;
  color: var(--text-soft);
  background: rgba(255, 249, 241, 0.9);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 12px 14px;
`;
const $027cd14b0d670db0$var$NoteIndicator = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  color: var(--accent);
  font-weight: bold;
  margin-left: 4px;
`;
const $027cd14b0d670db0$var$RootNote = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p`
  font-size: 0.9rem;
  color: var(--text-soft);
  margin-top: 8px;
  padding-left: 12px;
  border-left: 2px solid rgba(159, 109, 76, 0.28);
`;
const $027cd14b0d670db0$var$ContextMenu = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  position: fixed;
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 18px 34px rgba(65, 46, 32, 0.16);
  z-index: 9999;
  min-width: 150px;
  pointer-events: auto;
  overflow: hidden;
`;
const $027cd14b0d670db0$var$ContextMenuItem = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding: 12px 14px;
  cursor: ${(props)=>props.disabled ? "not-allowed" : "pointer"};
  font-size: 0.92rem;
  opacity: ${(props)=>props.disabled ? 0.6 : 1};
  color: var(--danger);

  &:hover {
    background-color: ${(props)=>props.disabled ? "transparent" : "rgba(158, 98, 82, 0.1)"};
  }

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;






var $bh6RR = parcelRequire("bh6RR");


function $7317fae8f1e7f82f$var$NotesInput() {
    const { currentNode: currentNode , updateNodeComment: updateNodeComment , currentMode: currentMode  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [isEditing, setIsEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [editValue, setEditValue] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (currentNode) setEditValue(currentNode.comment || "");
    }, [
        currentNode
    ]);
    const handleEdit = ()=>{
        setIsEditing(true);
    };
    const handleSave = ()=>{
        if (updateNodeComment && currentNode) {
            updateNodeComment(currentNode, editValue);
            setIsEditing(false);
        }
    };
    const handleCancel = ()=>{
        setEditValue(currentNode?.comment || "");
        setIsEditing(false);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" && e.ctrlKey) handleSave();
        else if (e.key === "Escape") handleCancel();
    };
    if (currentMode === "trainer") return null;
    if (!currentNode) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7317fae8f1e7f82f$var$NotesContainer, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$NotesHeader, {
                children: "Notes"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$NotesPlaceholder, {
                children: "Select a position to add notes"
            })
        ]
    });
    const isRootNode = !currentNode.move;
    const positionDescription = isRootNode ? "Initial Position" : `After ${currentNode.move.san}`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7317fae8f1e7f82f$var$NotesContainer, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7317fae8f1e7f82f$var$NotesHeader, {
                children: [
                    "Notes for ",
                    positionDescription,
                    currentNode.comment && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$NoteIndicator, {
                        children: "*"
                    })
                ]
            }),
            isEditing ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7317fae8f1e7f82f$var$NotesEditArea, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$NotesTextarea, {
                        value: editValue,
                        onChange: (e)=>setEditValue(e.target.value),
                        onKeyDown: handleKeyDown,
                        placeholder: "Add your note. Ctrl+Enter saves. Esc cancels.",
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7317fae8f1e7f82f$var$NotesEditButtons, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$SaveButton, {
                                onClick: handleSave,
                                children: "Save"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$CancelButton, {
                                onClick: handleCancel,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7317fae8f1e7f82f$var$NotesDisplayArea, {
                children: [
                    currentNode.comment ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$NotesText, {
                        children: currentNode.comment
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$NotesPlaceholder, {
                        children: "No note yet"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7317fae8f1e7f82f$var$EditButton, {
                        onClick: handleEdit,
                        children: "Edit note"
                    })
                ]
            })
        ]
    });
}
var $7317fae8f1e7f82f$export$2e2bcd8739ae039 = $7317fae8f1e7f82f$var$NotesInput;
const $7317fae8f1e7f82f$var$NotesContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding: 22px;
  border: 1px solid var(--border);
  border-radius: 26px;
  background: var(--surface);
  box-shadow: var(--shadow-md);
`;
const $7317fae8f1e7f82f$var$NotesHeader = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  font-weight: 600;
  margin-bottom: 14px;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 8px;
`;
const $7317fae8f1e7f82f$var$NoteIndicator = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  color: var(--accent);
  font-weight: bold;
  font-size: 1.2em;
`;
const $7317fae8f1e7f82f$var$NotesEditArea = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $7317fae8f1e7f82f$var$NotesTextarea = (0, $e484c752f3f06549$export$2e2bcd8739ae039).textarea`
  width: 100%;
  min-height: 120px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 16px;
  font-family: inherit;
  font-size: 0.9rem;
  resize: vertical;
  color: var(--text);
  background: rgba(255, 249, 241, 0.96);

  &:focus {
    outline: none;
    border-color: rgba(159, 109, 76, 0.36);
    box-shadow: 0 0 0 4px rgba(159, 109, 76, 0.14);
  }
`;
const $7317fae8f1e7f82f$var$NotesEditButtons = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;
const $7317fae8f1e7f82f$var$SaveButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 10px 16px;
  background: linear-gradient(180deg, #b17a58 0%, #8f5c3e 100%);
  color: #fffaf5;
  border: 1px solid rgba(143, 92, 62, 0.4);
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background: linear-gradient(180deg, #ba8461 0%, #986145 100%);
  }
`;
const $7317fae8f1e7f82f$var$CancelButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 10px 16px;
  background: rgba(159, 109, 76, 0.12);
  color: var(--accent-strong);
  border: 1px solid rgba(159, 109, 76, 0.18);
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background: rgba(159, 109, 76, 0.18);
  }
`;
const $7317fae8f1e7f82f$var$NotesDisplayArea = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $7317fae8f1e7f82f$var$NotesText = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background: rgba(255, 249, 241, 0.94);
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid var(--border);
  border-left: 3px solid rgba(159, 109, 76, 0.36);
  white-space: pre-wrap;
  line-height: 1.5;
  color: var(--text);
`;
const $7317fae8f1e7f82f$var$NotesPlaceholder = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  color: var(--text-faint);
  font-style: italic;
  padding: 12px;
  text-align: center;
`;
const $7317fae8f1e7f82f$var$EditButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 10px 16px;
  background: rgba(159, 109, 76, 0.12);
  color: var(--accent-strong);
  border: 1px solid rgba(159, 109, 76, 0.18);
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.9rem;
  align-self: flex-end;

  &:hover {
    background: rgba(159, 109, 76, 0.18);
  }
`;




var $bh6RR = parcelRequire("bh6RR");


function $bb61fffa3d9fd397$var$RepertoireList() {
    const { repertoires: repertoires , currentRepertoireId: currentRepertoireId , loadRepertoire: loadRepertoire , createRepertoire: createRepertoire , deleteRepertoire: deleteRepertoire  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const handleCreate = async ()=>{
        const name = prompt("Enter the name for the new repertoire:");
        if (name && name.trim() !== "") try {
            await createRepertoire(name.trim());
        } catch (error) {
            alert("Failed to create repertoire. Please try again.");
        }
    };
    const handleDelete = async (id, name)=>{
        if (window.confirm(`Are you sure you want to delete "${name}"?`)) try {
            await deleteRepertoire(id);
        } catch (error) {
            alert("Failed to delete repertoire. Please try again.");
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($bb61fffa3d9fd397$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($bb61fffa3d9fd397$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                        children: "Repertoires"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bb61fffa3d9fd397$var$CreateButton, {
                        onClick: handleCreate,
                        title: "Create New Repertoire",
                        children: "+"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bb61fffa3d9fd397$var$List, {
                children: repertoires.map((repertoire)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($bb61fffa3d9fd397$var$ListItem, {
                        $active: repertoire.id === currentRepertoireId,
                        onClick: ()=>loadRepertoire(repertoire.id),
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bb61fffa3d9fd397$var$Name, {
                                children: repertoire.name
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bb61fffa3d9fd397$var$DeleteButton, {
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleDelete(repertoire.id, repertoire.name);
                                },
                                title: "Delete",
                                children: "\xd7"
                            })
                        ]
                    }, repertoire.id))
            })
        ]
    });
}
var $bb61fffa3d9fd397$export$2e2bcd8739ae039 = $bb61fffa3d9fd397$var$RepertoireList;
const $bb61fffa3d9fd397$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  padding: 20px 22px 22px;
`;
const $bb61fffa3d9fd397$var$Header = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
`;
const $bb61fffa3d9fd397$var$CreateButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  cursor: pointer;
  color: var(--accent-strong);
  background: rgba(159, 109, 76, 0.12);
  border: 1px solid rgba(159, 109, 76, 0.18);
  border-radius: 999px;
  transition:
    transform 0.2s ease,
    background 0.2s ease;

  &:hover {
    background: rgba(159, 109, 76, 0.18);
    transform: translateY(-1px);
  }
`;
const $bb61fffa3d9fd397$var$List = (0, $e484c752f3f06549$export$2e2bcd8739ae039).ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
`;
const $bb61fffa3d9fd397$var$ListItem = (0, $e484c752f3f06549$export$2e2bcd8739ae039).li`
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border: 1px solid
    ${(props)=>props.$active ? "rgba(159, 109, 76, 0.28)" : "var(--border)"};
  background: ${(props)=>props.$active ? "rgba(159, 109, 76, 0.12)" : "rgba(255, 249, 241, 0.88)"};
  color: ${(props)=>props.$active ? "var(--accent-strong)" : "var(--text)"};
  min-width: 180px;
  transition:
    transform 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    background: ${(props)=>props.$active ? "rgba(159, 109, 76, 0.18)" : "rgba(239, 228, 213, 0.92)"};
    transform: translateY(-1px);
    box-shadow: 0 12px 20px rgba(86, 62, 43, 0.08);
  }
`;
const $bb61fffa3d9fd397$var$Name = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
`;
const $bb61fffa3d9fd397$var$DeleteButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(124, 98, 74, 0.14);
  border-radius: 999px;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  &:hover {
    opacity: 1;
    color: var(--danger);
  }
`;






var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
// src/primitive.tsx
var $93dfa6b8fe6a3629$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $93dfa6b8fe6a3629$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $93dfa6b8fe6a3629$export$f21a1ffae260145a(element) {
    if (!$93dfa6b8fe6a3629$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $93dfa6b8fe6a3629$export$b204af158042fbac(element) {
    if (!$93dfa6b8fe6a3629$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $93dfa6b8fe6a3629$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement  } = $93dfa6b8fe6a3629$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($93dfa6b8fe6a3629$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $93dfa6b8fe6a3629$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $93dfa6b8fe6a3629$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $93dfa6b8fe6a3629$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}


// packages/react/compose-refs/src/compose-refs.tsx

var $bh6RR = parcelRequire("bh6RR");
function $e52f713866128e60$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $e52f713866128e60$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $e52f713866128e60$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $e52f713866128e60$var$setRef(refs[i], null);
            }
        };
    };
}
function $e52f713866128e60$export$c7b2cbe3552a0d05(...refs) {
    return $bh6RR.useCallback($e52f713866128e60$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/create-context.tsx

var $bh6RR = parcelRequire("bh6RR");

function $1cecd1d75f085228$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $bh6RR.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children , ...context } = props;
        const value = $bh6RR.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $bh6RR.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $1cecd1d75f085228$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $bh6RR.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope , children: children , ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $bh6RR.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $bh6RR.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $bh6RR.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $bh6RR.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $1cecd1d75f085228$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $1cecd1d75f085228$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope , scopeName: scopeName  })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $bh6RR.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/id/src/id.tsx

var $bh6RR = parcelRequire("bh6RR");
// packages/react/use-layout-effect/src/use-layout-effect.tsx

var $bh6RR = parcelRequire("bh6RR");
var $8b7ab17803b8e6f8$export$e5c5a5f917a5871c = globalThis?.document ? $bh6RR.useLayoutEffect : ()=>{};


var $d172fcbd2da23bac$var$useReactId = $bh6RR[" useId ".trim().toString()] || (()=>void 0);
var $d172fcbd2da23bac$var$count = 0;
function $d172fcbd2da23bac$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($d172fcbd2da23bac$var$useReactId());
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($d172fcbd2da23bac$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// src/use-controllable-state.tsx

var $bh6RR = parcelRequire("bh6RR");

// src/use-effect-event.tsx


var $bh6RR = parcelRequire("bh6RR");
var $af16b13d7a9d69f8$var$useReactEffectEvent = $bh6RR[" useEffectEvent ".trim().toString()];
var $af16b13d7a9d69f8$var$useReactInsertionEffect = $bh6RR[" useInsertionEffect ".trim().toString()];
function $af16b13d7a9d69f8$export$7f54fc3180508a52(callback) {
    if (typeof $af16b13d7a9d69f8$var$useReactEffectEvent === "function") return $af16b13d7a9d69f8$var$useReactEffectEvent(callback);
    const ref = $bh6RR.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $af16b13d7a9d69f8$var$useReactInsertionEffect === "function") $af16b13d7a9d69f8$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $bh6RR.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $dfcfc7aa8980054c$var$useInsertionEffect = $bh6RR[" useInsertionEffect ".trim().toString()] || (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c);
function $dfcfc7aa8980054c$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{} , caller: caller  }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $dfcfc7aa8980054c$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $bh6RR.useRef(prop !== void 0);
        $bh6RR.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $bh6RR.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $dfcfc7aa8980054c$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $dfcfc7aa8980054c$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const [value, setValue] = $bh6RR.useState(defaultProp);
    const prevValueRef = $bh6RR.useRef(value);
    const onChangeRef = $bh6RR.useRef(onChange);
    $dfcfc7aa8980054c$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $bh6RR.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $dfcfc7aa8980054c$var$isFunction(value) {
    return typeof value === "function";
}
var $dfcfc7aa8980054c$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $dfcfc7aa8980054c$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState , defaultProp: defaultProp , onChange: onChangeProp , caller: caller  } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $af16b13d7a9d69f8$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $bh6RR.useRef(controlledState !== void 0);
        $bh6RR.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $bh6RR.useReducer((state2, action)=>{
        if (action.type === $dfcfc7aa8980054c$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $bh6RR.useRef(uncontrolledState);
    $bh6RR.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $bh6RR.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $bh6RR.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $dfcfc7aa8980054c$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $bh6RR = parcelRequire("bh6RR");

// src/primitive.tsx

var $bh6RR = parcelRequire("bh6RR");

// src/slot.tsx

var $bh6RR = parcelRequire("bh6RR");


// @__NO_SIDE_EFFECTS__
function $18fd289ffa468154$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $18fd289ffa468154$var$createSlotClone(ownerName);
    const Slot2 = $bh6RR.forwardRef((props, forwardedRef)=>{
        const { children: children , ...slotProps } = props;
        const childrenArray = $bh6RR.Children.toArray(children);
        const slottable = childrenArray.find($18fd289ffa468154$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($bh6RR.Children.count(newElement) > 1) return $bh6RR.Children.only(null);
                    return $bh6RR.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $bh6RR.isValidElement(newElement) ? $bh6RR.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $18fd289ffa468154$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $18fd289ffa468154$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $18fd289ffa468154$var$createSlotClone(ownerName) {
    const SlotClone = $bh6RR.forwardRef((props, forwardedRef)=>{
        const { children: children , ...slotProps } = props;
        if ($bh6RR.isValidElement(children)) {
            const childrenRef = $18fd289ffa468154$var$getElementRef(children);
            const props2 = $18fd289ffa468154$var$mergeProps(slotProps, children.props);
            if (children.type !== $bh6RR.Fragment) props2.ref = forwardedRef ? (0, $e52f713866128e60$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $bh6RR.cloneElement(children, props2);
        }
        return $bh6RR.Children.count(children) > 1 ? $bh6RR.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $18fd289ffa468154$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $18fd289ffa468154$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children  })=>{
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $18fd289ffa468154$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $18fd289ffa468154$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $18fd289ffa468154$export$bf68c29d8281d0f7("Slottable");
function $18fd289ffa468154$var$isSlottable(child) {
    return $bh6RR.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $18fd289ffa468154$var$SLOTTABLE_IDENTIFIER;
}
function $18fd289ffa468154$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $18fd289ffa468154$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}



var $793b1a0f4d9647b1$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $793b1a0f4d9647b1$export$250ffa63cdc0d034 = $793b1a0f4d9647b1$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $18fd289ffa468154$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $bh6RR.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $793b1a0f4d9647b1$export$6d1a0317bde7de7f(target, event) {
    if (target) $47cfd4084854a574$exports.flushSync(()=>target.dispatchEvent(event));
}
var $793b1a0f4d9647b1$export$be92b6f5f03c0fe9 = $793b1a0f4d9647b1$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/use-callback-ref.tsx

var $bh6RR = parcelRequire("bh6RR");
function $c901973c35f9b07b$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $bh6RR.useRef(callback);
    $bh6RR.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $bh6RR.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-escape-keydown/src/use-escape-keydown.tsx

var $bh6RR = parcelRequire("bh6RR");

function $879e0a3f7f60ef06$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $bh6RR.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $8473b83e333b07d4$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $8473b83e333b07d4$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $8473b83e333b07d4$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $8473b83e333b07d4$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $8473b83e333b07d4$var$originalBodyPointerEvents;
var $8473b83e333b07d4$var$DismissableLayerContext = $bh6RR.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $8473b83e333b07d4$export$177fb62ff3ec1f22 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = $bh6RR.useContext($8473b83e333b07d4$var$DismissableLayerContext);
    const [node, setNode] = $bh6RR.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $bh6RR.useState({});
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $8473b83e333b07d4$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $8473b83e333b07d4$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $879e0a3f7f60ef06$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $bh6RR.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $8473b83e333b07d4$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $8473b83e333b07d4$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $8473b83e333b07d4$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $bh6RR.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $8473b83e333b07d4$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $bh6RR.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($8473b83e333b07d4$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($8473b83e333b07d4$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$8473b83e333b07d4$export$177fb62ff3ec1f22.displayName = $8473b83e333b07d4$var$DISMISSABLE_LAYER_NAME;
var $8473b83e333b07d4$var$BRANCH_NAME = "DismissableLayerBranch";
var $8473b83e333b07d4$export$4d5eb2109db14228 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const context = $bh6RR.useContext($8473b83e333b07d4$var$DismissableLayerContext);
    const ref = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $bh6RR.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$8473b83e333b07d4$export$4d5eb2109db14228.displayName = $8473b83e333b07d4$var$BRANCH_NAME;
function $8473b83e333b07d4$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $bh6RR.useRef(false);
    const handleClickRef = $bh6RR.useRef(()=>{});
    $bh6RR.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $8473b83e333b07d4$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $8473b83e333b07d4$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $8473b83e333b07d4$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $8473b83e333b07d4$var$dispatchUpdate() {
    const event = new CustomEvent($8473b83e333b07d4$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $8473b83e333b07d4$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $793b1a0f4d9647b1$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $8473b83e333b07d4$export$be92b6f5f03c0fe9 = $8473b83e333b07d4$export$177fb62ff3ec1f22;
var $8473b83e333b07d4$export$aecb2ddcb55c95be = $8473b83e333b07d4$export$4d5eb2109db14228;



var $bh6RR = parcelRequire("bh6RR");




"use client";
var $0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0757534448b5e4bf$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0757534448b5e4bf$var$FOCUS_SCOPE_NAME = "FocusScope";
var $0757534448b5e4bf$export$20e40289641fbbb6 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container, setContainer] = $bh6RR.useState(null);
    const onMountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $bh6RR.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $bh6RR.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $0757534448b5e4bf$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $0757534448b5e4bf$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0757534448b5e4bf$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $bh6RR.useEffect(()=>{
        if (container) {
            $0757534448b5e4bf$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT, $0757534448b5e4bf$var$EVENT_OPTIONS);
                container.addEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0757534448b5e4bf$var$focusFirst($0757534448b5e4bf$var$removeLinks($0757534448b5e4bf$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0757534448b5e4bf$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT, $0757534448b5e4bf$var$EVENT_OPTIONS);
                    container.addEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0757534448b5e4bf$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($0757534448b5e4bf$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0757534448b5e4bf$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $bh6RR.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $0757534448b5e4bf$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$0757534448b5e4bf$export$20e40289641fbbb6.displayName = $0757534448b5e4bf$var$FOCUS_SCOPE_NAME;
function $0757534448b5e4bf$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0757534448b5e4bf$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $0757534448b5e4bf$var$getTabbableEdges(container) {
    const candidates = $0757534448b5e4bf$var$getTabbableCandidates(container);
    const first = $0757534448b5e4bf$var$findVisible(candidates, container);
    const last = $0757534448b5e4bf$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $0757534448b5e4bf$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $0757534448b5e4bf$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$0757534448b5e4bf$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0757534448b5e4bf$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0757534448b5e4bf$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0757534448b5e4bf$var$focus(element, { select: select = false  } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $0757534448b5e4bf$var$isSelectableInput(element) && select) element.select();
    }
}
var $0757534448b5e4bf$var$focusScopesStack = $0757534448b5e4bf$var$createFocusScopesStack();
function $0757534448b5e4bf$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $0757534448b5e4bf$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $0757534448b5e4bf$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $0757534448b5e4bf$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0757534448b5e4bf$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $0757534448b5e4bf$export$be92b6f5f03c0fe9 = $0757534448b5e4bf$export$20e40289641fbbb6;



var $bh6RR = parcelRequire("bh6RR");




"use client";
var $252b3d40eb00b07a$var$PORTAL_NAME = "Portal";
var $252b3d40eb00b07a$export$602eac185826482c = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { container: containerProp , ...portalProps } = props;
    const [mounted, setMounted] = $bh6RR.useState(false);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).createPortal(/* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$252b3d40eb00b07a$export$602eac185826482c.displayName = $252b3d40eb00b07a$var$PORTAL_NAME;
var $252b3d40eb00b07a$export$be92b6f5f03c0fe9 = $252b3d40eb00b07a$export$602eac185826482c;



var $bh6RR = parcelRequire("bh6RR");


"use client";
function $e651d1dc516f7371$var$useStateMachine(initialState, machine) {
    return $bh6RR.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $e651d1dc516f7371$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $e651d1dc516f7371$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $bh6RR.Children.only(children);
    const ref = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(presence.ref, $e651d1dc516f7371$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $bh6RR.cloneElement(child, {
        ref: ref
    }) : null;
};
$e651d1dc516f7371$export$99c2b779aa4e8b8b.displayName = "Presence";
function $e651d1dc516f7371$var$usePresence(present) {
    const [node, setNode] = $bh6RR.useState();
    const stylesRef = $bh6RR.useRef(null);
    const prevPresentRef = $bh6RR.useRef(present);
    const prevAnimationNameRef = $bh6RR.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e651d1dc516f7371$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $bh6RR.useEffect(()=>{
        const currentAnimationName = $e651d1dc516f7371$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e651d1dc516f7371$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e651d1dc516f7371$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $e651d1dc516f7371$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $bh6RR.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $e651d1dc516f7371$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $e651d1dc516f7371$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $e651d1dc516f7371$export$be92b6f5f03c0fe9 = $e651d1dc516f7371$export$99c2b779aa4e8b8b;




var $bh6RR = parcelRequire("bh6RR");
"use client";
var $39ae7ab2790868b6$var$count = 0;
function $39ae7ab2790868b6$export$ac5b58043b79449b(props) {
    $39ae7ab2790868b6$export$b7ece24a22aeda8c();
    return props.children;
}
function $39ae7ab2790868b6$export$b7ece24a22aeda8c() {
    $bh6RR.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $39ae7ab2790868b6$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $39ae7ab2790868b6$var$createFocusGuard());
        $39ae7ab2790868b6$var$count++;
        return ()=>{
            if ($39ae7ab2790868b6$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $39ae7ab2790868b6$var$count--;
        };
    }, []);
}
function $39ae7ab2790868b6$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f5ed4ab2a4d1861b$var$ownKeys = function(o) {
    $f5ed4ab2a4d1861b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f5ed4ab2a4d1861b$var$ownKeys(o);
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f5ed4ab2a4d1861b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f5ed4ab2a4d1861b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __esDecorate: $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0,
    __runInitializers: $f5ed4ab2a4d1861b$export$d831c04e792af3d,
    __propKey: $f5ed4ab2a4d1861b$export$6a2a36740a146cb8,
    __setFunctionName: $f5ed4ab2a4d1861b$export$d1a06452d3489bc7,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f5ed4ab2a4d1861b$export$889dfb5d17574b0b
};



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $dbb3c33b31cdcfb1$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $dbb3c33b31cdcfb1$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $dbb3c33b31cdcfb1$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $bh6RR = parcelRequire("bh6RR");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $83a050b8f7e61fc1$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $bh6RR = parcelRequire("bh6RR");
function $bcea459d6fe13dac$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $bh6RR.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $59e9bf7262dc1a6d$var$currentValues = new WeakMap();
function $59e9bf7262dc1a6d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $bcea459d6fe13dac$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $59e9bf7262dc1a6d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $59e9bf7262dc1a6d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $0647093a1b1c5afc$var$ItoI(a) {
    return a;
}
function $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $0647093a1b1c5afc$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    return $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware);
}
function $0647093a1b1c5afc$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $0647093a1b1c5afc$var$innerCreateMedium(null);
    medium.options = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $1e32631777ba14da$export$e27363444bedfeac = (0, $0647093a1b1c5afc$export$e13ec7dd7a14088d)();


var $1c1f9cd94bee4822$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $1c1f9cd94bee4822$export$22940b497e769dee = $bh6RR.forwardRef(function(props, parentRef) {
    var ref = $bh6RR.useRef(null);
    var _a = $bh6RR.useState({
        onScrollCapture: $1c1f9cd94bee4822$var$nothing,
        onWheelCapture: $1c1f9cd94bee4822$var$nothing,
        onTouchMoveCapture: $1c1f9cd94bee4822$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $59e9bf7262dc1a6d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest), callbacks);
    return $bh6RR.createElement($bh6RR.Fragment, null, enabled && $bh6RR.createElement(SideCar, {
        sideCar: (0, $1e32631777ba14da$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $bh6RR.cloneElement($bh6RR.Children.only(children), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $bh6RR.createElement(Container, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$1c1f9cd94bee4822$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$1c1f9cd94bee4822$export$22940b497e769dee.classNames = {
    fullWidth: (0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e),
    zeroRight: (0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3)
};




var $bh6RR = parcelRequire("bh6RR");
var $db1654befbc8d676$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $f5ed4ab2a4d1861b$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $bh6RR.createElement(Target, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, rest));
};
$db1654befbc8d676$var$SideCar.isSideCarExport = true;
function $db1654befbc8d676$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $db1654befbc8d676$var$SideCar;
}




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $c1a97cf4bee7a747$var$currentNonce;
var $c1a97cf4bee7a747$export$c5f670b24c0ae95a = function(nonce) {
    $c1a97cf4bee7a747$var$currentNonce = nonce;
};
var $c1a97cf4bee7a747$export$2b85b721e524d74b = function() {
    if ($c1a97cf4bee7a747$var$currentNonce) return $c1a97cf4bee7a747$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $ec0bd1fbc8093bb3$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c1a97cf4bee7a747$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $ec0bd1fbc8093bb3$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ec0bd1fbc8093bb3$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $ec0bd1fbc8093bb3$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $ec0bd1fbc8093bb3$var$makeStyleTag()) {
                    $ec0bd1fbc8093bb3$var$injectStyles(stylesheet, style);
                    $ec0bd1fbc8093bb3$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $388d9750a20580a4$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $ec0bd1fbc8093bb3$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $bh6RR.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $8f0cc34b8d78d287$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $388d9750a20580a4$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $c24b64e0e48f5c2b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $c24b64e0e48f5c2b$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $c24b64e0e48f5c2b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $c24b64e0e48f5c2b$var$parse(left),
        $c24b64e0e48f5c2b$var$parse(top),
        $c24b64e0e48f5c2b$var$parse(right)
    ];
};
var $c24b64e0e48f5c2b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $c24b64e0e48f5c2b$export$efed13b5d0ca3386;
    var offsets = $c24b64e0e48f5c2b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $a1bca04d3c994e31$var$Style = (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
var $a1bca04d3c994e31$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $a1bca04d3c994e31$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $dbb3c33b31cdcfb1$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    ").concat((0, $dbb3c33b31cdcfb1$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $a1bca04d3c994e31$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($a1bca04d3c994e31$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $a1bca04d3c994e31$export$a1939b1f9f9b02dc = function() {
    $bh6RR.useEffect(function() {
        document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, ($a1bca04d3c994e31$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $a1bca04d3c994e31$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($a1bca04d3c994e31$export$65254d5f26cb9564);
            else document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $a1bca04d3c994e31$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $a1bca04d3c994e31$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $bh6RR.useMemo(function() {
        return (0, $c24b64e0e48f5c2b$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $bh6RR.createElement($a1bca04d3c994e31$var$Style, {
        styles: $a1bca04d3c994e31$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $c3d5eca92c5827bc$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $c3d5eca92c5827bc$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $c3d5eca92c5827bc$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
    // @ts-ignore
    window.removeEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
} catch (err) {
    $c3d5eca92c5827bc$var$passiveSupported = false;
}
var $c3d5eca92c5827bc$export$10a6e88623fa9454 = $c3d5eca92c5827bc$var$passiveSupported ? {
    passive: false
} : false;


var $b2f037382e9b8811$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $b2f037382e9b8811$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$b2f037382e9b8811$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $b2f037382e9b8811$var$elementCouldBeVScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowY");
};
var $b2f037382e9b8811$var$elementCouldBeHScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowX");
};
var $b2f037382e9b8811$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $b2f037382e9b8811$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $b2f037382e9b8811$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $b2f037382e9b8811$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $b2f037382e9b8811$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $b2f037382e9b8811$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$elementCouldBeVScrolled(node) : $b2f037382e9b8811$var$elementCouldBeHScrolled(node);
};
var $b2f037382e9b8811$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$getVScrollVariables(node) : $b2f037382e9b8811$var$getHScrollVariables(node);
};
var $b2f037382e9b8811$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $b2f037382e9b8811$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $b2f037382e9b8811$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $b2f037382e9b8811$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($b2f037382e9b8811$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $0012650a668228df$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0012650a668228df$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0012650a668228df$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $0012650a668228df$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0012650a668228df$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0012650a668228df$var$idCounter = 0;
var $0012650a668228df$var$lockStack = [];
function $0012650a668228df$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $bh6RR.useRef([]);
    var touchStartRef = $bh6RR.useRef([
        0,
        0
    ]);
    var activeAxis = $bh6RR.useRef();
    var id = $bh6RR.useState($0012650a668228df$var$idCounter++)[0];
    var Style = $bh6RR.useState((0, $8f0cc34b8d78d287$export$c1248ee86ba532c8))[0];
    var lastProps = $bh6RR.useRef(props);
    $bh6RR.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $bh6RR.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($0012650a668228df$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $bh6RR.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $0012650a668228df$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $b2f037382e9b8811$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $bh6RR.useCallback(function(_event) {
        var event = _event;
        if (!$0012650a668228df$var$lockStack.length || $0012650a668228df$var$lockStack[$0012650a668228df$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $0012650a668228df$export$39efaa2ca254a28d(event) : $0012650a668228df$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $0012650a668228df$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0012650a668228df$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $bh6RR.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $0012650a668228df$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $bh6RR.useCallback(function(event) {
        touchStartRef.current = $0012650a668228df$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $bh6RR.useEffect(function() {
        $0012650a668228df$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        return function() {
            $0012650a668228df$var$lockStack = $0012650a668228df$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $bh6RR.createElement($bh6RR.Fragment, null, inert ? $bh6RR.createElement(Style, {
        styles: $0012650a668228df$var$generateStyle(id)
    }) : null, removeScrollBar ? $bh6RR.createElement((0, $a1bca04d3c994e31$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $0012650a668228df$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $32fbe4a10a756a07$export$2e2bcd8739ae039 = (0, $db1654befbc8d676$export$6cacc8fb0a9b94ce)((0, $1e32631777ba14da$export$e27363444bedfeac), (0, $0012650a668228df$export$a09dbff87b5da2d));


var $2a904e957609af53$var$ReactRemoveScroll = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement((0, $1c1f9cd94bee4822$export$22940b497e769dee), (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $32fbe4a10a756a07$export$2e2bcd8739ae039)
    }));
});
$2a904e957609af53$var$ReactRemoveScroll.classNames = (0, $1c1f9cd94bee4822$export$22940b497e769dee).classNames;
var $2a904e957609af53$export$2e2bcd8739ae039 = $2a904e957609af53$var$ReactRemoveScroll;


var $43e375177e5001c1$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $43e375177e5001c1$var$counterMap = new WeakMap();
var $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
var $43e375177e5001c1$var$markerMap = {};
var $43e375177e5001c1$var$lockCount = 0;
var $43e375177e5001c1$var$unwrapHost = function(node) {
    return node && (node.host || $43e375177e5001c1$var$unwrapHost(node.parentNode));
};
var $43e375177e5001c1$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $43e375177e5001c1$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $43e375177e5001c1$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $43e375177e5001c1$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$43e375177e5001c1$var$markerMap[markerName]) $43e375177e5001c1$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $43e375177e5001c1$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($43e375177e5001c1$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $43e375177e5001c1$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $43e375177e5001c1$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $43e375177e5001c1$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $43e375177e5001c1$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $43e375177e5001c1$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$43e375177e5001c1$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $43e375177e5001c1$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $43e375177e5001c1$var$lockCount--;
        if (!$43e375177e5001c1$var$lockCount) {
            // clear
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
            $43e375177e5001c1$var$markerMap = {};
        }
    };
};
var $43e375177e5001c1$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live], script")));
    return $43e375177e5001c1$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $43e375177e5001c1$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $43e375177e5001c1$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $43e375177e5001c1$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $43e375177e5001c1$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($43e375177e5001c1$export$cc95fea82d705fca() ? $43e375177e5001c1$export$59151cc8db999a24 : $43e375177e5001c1$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $919b3aedf69a16e5$var$DIALOG_NAME = "Dialog";
var [$919b3aedf69a16e5$var$createDialogContext, $919b3aedf69a16e5$export$cc702773b8ea3e41] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($919b3aedf69a16e5$var$DIALOG_NAME);
var [$919b3aedf69a16e5$var$DialogProvider, $919b3aedf69a16e5$var$useDialogContext] = $919b3aedf69a16e5$var$createDialogContext($919b3aedf69a16e5$var$DIALOG_NAME);
var $919b3aedf69a16e5$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = $bh6RR.useRef(null);
    const contentRef = $bh6RR.useRef(null);
    const [open, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $919b3aedf69a16e5$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        titleId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        descriptionId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $bh6RR.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$919b3aedf69a16e5$export$3ddf2d174ce01153.displayName = $919b3aedf69a16e5$var$DIALOG_NAME;
var $919b3aedf69a16e5$var$TRIGGER_NAME = "DialogTrigger";
var $919b3aedf69a16e5$export$2e1e1122cf0cba88 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $919b3aedf69a16e5$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$919b3aedf69a16e5$export$2e1e1122cf0cba88.displayName = $919b3aedf69a16e5$var$TRIGGER_NAME;
var $919b3aedf69a16e5$var$PORTAL_NAME = "DialogPortal";
var [$919b3aedf69a16e5$var$PortalProvider, $919b3aedf69a16e5$var$usePortalContext] = $919b3aedf69a16e5$var$createDialogContext($919b3aedf69a16e5$var$PORTAL_NAME, {
    forceMount: void 0
});
var $919b3aedf69a16e5$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $bh6RR.Children.map(children, (child)=>/* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $252b3d40eb00b07a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$919b3aedf69a16e5$export$dad7c95542bacce0.displayName = $919b3aedf69a16e5$var$PORTAL_NAME;
var $919b3aedf69a16e5$var$OVERLAY_NAME = "DialogOverlay";
var $919b3aedf69a16e5$export$bd1d06c79be19e17 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$usePortalContext($919b3aedf69a16e5$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$919b3aedf69a16e5$export$bd1d06c79be19e17.displayName = $919b3aedf69a16e5$var$OVERLAY_NAME;
var $919b3aedf69a16e5$var$Slot = (0, $18fd289ffa468154$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $919b3aedf69a16e5$var$DialogOverlayImpl = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: $919b3aedf69a16e5$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, {
            "data-state": $919b3aedf69a16e5$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $919b3aedf69a16e5$var$CONTENT_NAME = "DialogContent";
var $919b3aedf69a16e5$export$b6d9565de1e068cf = $bh6RR.forwardRef((props, forwardedRef)=>{
    const portalContext = $919b3aedf69a16e5$var$usePortalContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$919b3aedf69a16e5$export$b6d9565de1e068cf.displayName = $919b3aedf69a16e5$var$CONTENT_NAME;
var $919b3aedf69a16e5$var$DialogContentModal = $bh6RR.forwardRef((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $bh6RR.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $919b3aedf69a16e5$var$DialogContentNonModal = $bh6RR.forwardRef((props, forwardedRef)=>{
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $bh6RR.useRef(false);
    const hasPointerDownOutsideRef = $bh6RR.useRef(false);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $919b3aedf69a16e5$var$DialogContentImpl = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $bh6RR.useRef(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $919b3aedf69a16e5$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $919b3aedf69a16e5$var$TITLE_NAME = "DialogTitle";
var $919b3aedf69a16e5$export$16f7638e4a34b909 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$919b3aedf69a16e5$export$16f7638e4a34b909.displayName = $919b3aedf69a16e5$var$TITLE_NAME;
var $919b3aedf69a16e5$var$DESCRIPTION_NAME = "DialogDescription";
var $919b3aedf69a16e5$export$94e94c2ec2c954d5 = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$919b3aedf69a16e5$export$94e94c2ec2c954d5.displayName = $919b3aedf69a16e5$var$DESCRIPTION_NAME;
var $919b3aedf69a16e5$var$CLOSE_NAME = "DialogClose";
var $919b3aedf69a16e5$export$fba2fb7cd781b7ac = $bh6RR.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $919b3aedf69a16e5$var$useDialogContext($919b3aedf69a16e5$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $d4dab640dcbe486c$exports.jsx)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$919b3aedf69a16e5$export$fba2fb7cd781b7ac.displayName = $919b3aedf69a16e5$var$CLOSE_NAME;
function $919b3aedf69a16e5$var$getState(open) {
    return open ? "open" : "closed";
}
var $919b3aedf69a16e5$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$919b3aedf69a16e5$export$69b62a49393917d6, $919b3aedf69a16e5$var$useWarningContext] = (0, $1cecd1d75f085228$export$fd42f52fd3ae1109)($919b3aedf69a16e5$var$TITLE_WARNING_NAME, {
    contentName: $919b3aedf69a16e5$var$CONTENT_NAME,
    titleName: $919b3aedf69a16e5$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $919b3aedf69a16e5$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $919b3aedf69a16e5$var$useWarningContext($919b3aedf69a16e5$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $bh6RR.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $919b3aedf69a16e5$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $919b3aedf69a16e5$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $919b3aedf69a16e5$var$useWarningContext($919b3aedf69a16e5$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $bh6RR.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $919b3aedf69a16e5$export$be92b6f5f03c0fe9 = $919b3aedf69a16e5$export$3ddf2d174ce01153;
var $919b3aedf69a16e5$export$41fb9f06171c75f4 = $919b3aedf69a16e5$export$2e1e1122cf0cba88;
var $919b3aedf69a16e5$export$602eac185826482c = $919b3aedf69a16e5$export$dad7c95542bacce0;
var $919b3aedf69a16e5$export$c6fdb837b070b4ff = $919b3aedf69a16e5$export$bd1d06c79be19e17;
var $919b3aedf69a16e5$export$7c6e2c02157bb7d2 = $919b3aedf69a16e5$export$b6d9565de1e068cf;
var $919b3aedf69a16e5$export$f99233281efd08a0 = $919b3aedf69a16e5$export$16f7638e4a34b909;
var $919b3aedf69a16e5$export$393edc798c47379d = $919b3aedf69a16e5$export$94e94c2ec2c954d5;
var $919b3aedf69a16e5$export$f39c2d165cd861fe = $919b3aedf69a16e5$export$fba2fb7cd781b7ac;


function $86f93f828a96e9d5$var$Controls() {
    const { navigateBack: navigateBack , navigateForward: navigateForward , currentNode: currentNode , currentMode: currentMode  } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext((0, $7ead3b1a9a673b0a$export$58d75f9829cbe158));
    const [isDialogOpen, setIsDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [lastForwardPress, setLastForwardPress] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const handleForward = ()=>{
        if (!currentNode || currentNode.children.length === 0) return;
        if (currentNode.children.length > 1) setIsDialogOpen(true);
        else navigateForward(0);
    };
    const handleForwardKey = ()=>{
        if (!currentNode || currentNode.children.length === 0) return;
        const now = Date.now();
        const timeSinceLastPress = now - lastForwardPress;
        if (currentNode.children.length > 1) {
            if (timeSinceLastPress < 300) {
                navigateForward(0);
                setLastForwardPress(0);
                setIsDialogOpen(false);
            } else {
                setIsDialogOpen(true);
                setLastForwardPress(now);
            }
        } else navigateForward(0);
    };
    const chooseVariation = (index)=>{
        navigateForward(index);
        setIsDialogOpen(false);
    };
    const canGoBack = currentNode && currentNode.parent;
    const canGoForward = currentNode && currentNode.children.length > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (currentMode !== "builder") return;
            switch(event.key){
                case "ArrowLeft":
                    event.preventDefault();
                    if (canGoBack) navigateBack();
                    break;
                case "ArrowRight":
                    event.preventDefault();
                    if (canGoForward) handleForwardKey();
                    break;
                default:
                    break;
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        currentMode,
        canGoBack,
        canGoForward,
        navigateBack,
        handleForwardKey
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($86f93f828a96e9d5$var$ControlsWrapper, {
        children: [
            currentMode === "builder" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$ControlButton, {
                        onClick: navigateBack,
                        disabled: !canGoBack,
                        title: "Previous Move (←)",
                        children: "<"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$ControlButton, {
                        onClick: handleForward,
                        disabled: !canGoForward,
                        title: "Next Move (→)",
                        children: ">"
                    })
                ]
            }) : null,
            currentNode && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$VariationDialog, {
                isOpen: isDialogOpen,
                onClose: ()=>setIsDialogOpen(false),
                variations: currentNode.children,
                onChoose: chooseVariation
            })
        ]
    });
}
const $86f93f828a96e9d5$var$VariationDialog = ({ isOpen: isOpen , onClose: onClose , variations: variations , onChoose: onChoose  })=>{
    const [selectedIndex, setSelectedIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (isOpen) setSelectedIndex(0);
    }, [
        isOpen
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (!isOpen) return;
            switch(event.key){
                case "ArrowUp":
                    event.preventDefault();
                    setSelectedIndex((prev)=>prev > 0 ? prev - 1 : variations.length - 1);
                    break;
                case "ArrowDown":
                    event.preventDefault();
                    setSelectedIndex((prev)=>prev < variations.length - 1 ? prev + 1 : 0);
                    break;
                case "Enter":
                    event.preventDefault();
                    onChoose(selectedIndex);
                    break;
                case "Escape":
                    event.preventDefault();
                    onClose();
                    break;
                default:
                    break;
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        isOpen,
        selectedIndex,
        variations.length,
        onChoose,
        onClose
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$be92b6f5f03c0fe9, {
        open: isOpen,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($919b3aedf69a16e5$export$602eac185826482c, {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$DialogOverlay, {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($86f93f828a96e9d5$var$DialogContent, {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$DialogTitle, {
                            children: "Choose Continuation"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$DialogDescription, {
                            children: "Multiple moves found. Select the line to follow."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$VariationList, {
                            children: variations.map((node, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$VariationButton, {
                                        onClick: ()=>onChoose(index),
                                        $selected: index === selectedIndex,
                                        children: node.move.san
                                    })
                                }, node.fen))
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($919b3aedf69a16e5$export$f39c2d165cd861fe, {
                            asChild: true,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($86f93f828a96e9d5$var$CloseButton, {
                                "aria-label": "Close",
                                children: "X"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $86f93f828a96e9d5$export$2e2bcd8739ae039 = $86f93f828a96e9d5$var$Controls;
const $86f93f828a96e9d5$var$ControlsWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 18px;
  flex-wrap: wrap;
`;
const $86f93f828a96e9d5$var$ControlButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  padding: 12px 18px;
  min-width: 60px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  color: var(--accent-strong);
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: 999px;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  &:hover:not(:disabled) {
    background: var(--accent-ghost);
    transform: translateY(-1px);
    box-shadow: 0 12px 24px rgba(86, 62, 43, 0.12);
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
const $86f93f828a96e9d5$var$overlayShow = `
  @keyframes overlayShow {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
const $86f93f828a96e9d5$var$contentShow = `
  @keyframes contentShow {
    from { opacity: 0; transform: translate(-50%, -48%) scale(0.96); }
    to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  }
`;
const $86f93f828a96e9d5$var$DialogOverlay = (0, $e484c752f3f06549$export$2e2bcd8739ae039)($919b3aedf69a16e5$export$c6fdb837b070b4ff)`
  background-color: rgba(47, 38, 31, 0.32);
  position: fixed;
  inset: 0;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  ${$86f93f828a96e9d5$var$overlayShow}
`;
const $86f93f828a96e9d5$var$DialogContent = (0, $e484c752f3f06549$export$2e2bcd8739ae039)($919b3aedf69a16e5$export$7c6e2c02157bb7d2)`
  background: var(--surface-strong);
  border-radius: 24px;
  border: 1px solid var(--border);
  box-shadow:
    0 20px 38px -18px rgba(0, 0, 0, 0.22),
    0 16px 24px -20px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 380px;
  padding: 28px;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  ${$86f93f828a96e9d5$var$contentShow}
`;
const $86f93f828a96e9d5$var$DialogTitle = (0, $e484c752f3f06549$export$2e2bcd8739ae039)($919b3aedf69a16e5$export$f99233281efd08a0)`
  margin: 0;
  font-weight: 600;
  font-size: 1.3rem;
  color: var(--text);
`;
const $86f93f828a96e9d5$var$DialogDescription = (0, $e484c752f3f06549$export$2e2bcd8739ae039)($919b3aedf69a16e5$export$393edc798c47379d)`
  margin: 10px 0 20px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--text-soft);
`;
const $86f93f828a96e9d5$var$VariationList = (0, $e484c752f3f06549$export$2e2bcd8739ae039).ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $86f93f828a96e9d5$var$VariationButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  width: 100%;
  padding: 12px 14px;
  text-align: left;
  background-color: ${(props)=>props.$selected ? "var(--accent-soft)" : "rgba(255, 249, 241, 0.92)"};
  color: ${(props)=>props.$selected ? "var(--accent-strong)" : "var(--text)"};
  border: 1px solid
    ${(props)=>props.$selected ? "rgba(159, 109, 76, 0.3)" : "var(--border)"};
  border-radius: 14px;
  cursor: pointer;

  &:hover {
    background-color: ${(props)=>props.$selected ? "#ecdccf" : "rgba(239, 228, 213, 0.82)"};
  }
`;
const $86f93f828a96e9d5$var$CloseButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid var(--border);
  color: var(--text-soft);
  background: rgba(255, 249, 241, 0.92);
`;





function $9a660e92d1863a0e$var$Body() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9a660e92d1863a0e$var$MainContainer, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9a660e92d1863a0e$var$ContentArea, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9a660e92d1863a0e$var$BoardArea, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4e5ef8436bf532a5$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $86f93f828a96e9d5$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9a660e92d1863a0e$var$ViewerArea, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7317fae8f1e7f82f$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $027cd14b0d670db0$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9a660e92d1863a0e$var$BottomPanel, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bb61fffa3d9fd397$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $9a660e92d1863a0e$export$2e2bcd8739ae039 = $9a660e92d1863a0e$var$Body;
const $9a660e92d1863a0e$var$MainContainer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).main`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-grow: 1;
  min-height: 0;
`;
const $9a660e92d1863a0e$var$ContentArea = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  padding: 24px;
  gap: 20px;
  align-items: stretch;
  border-radius: 32px;
  background: rgba(255, 248, 239, 0.62);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  overflow: visible;

  @media (max-width: 1120px) {
    flex-direction: column;
  }
`;
const $9a660e92d1863a0e$var$BoardArea = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1.6;
  min-width: 0;
  padding: 8px;
`;
const $9a660e92d1863a0e$var$ViewerArea = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  flex: 0.8;
  min-width: 0;
  min-height: 0;
`;
const $9a660e92d1863a0e$var$BottomPanel = (0, $e484c752f3f06549$export$2e2bcd8739ae039).aside`
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-md);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 32vh;
`;





function $5c4c715ef872aa13$var$App() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7ead3b1a9a673b0a$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "wrapper",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9a660e92d1863a0e$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $5c4c715ef872aa13$export$2e2bcd8739ae039 = $5c4c715ef872aa13$var$App;






const $1f0dc3b9307be026$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.querySelector("#root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c4c715ef872aa13$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.933636fc.js.map
